<template>
  <div
      class="new-upload-site-shell workspace-fullscreen-page"
      :class="[
        'workspace-mode-' + checkType,
        {
          'text-fullscreen-page': checkType === 'txt',
          'doc-upload-list-page': checkType === 'doc' && !isShowNewUpload && isShowNewUploadList,
          'convert-upload-list-page': checkType === 'convert' && !isShowNewUpload && isShowNewUploadList
        }
      ]"
      style="width: 100%"
  >
    <div v-if="true">
      <div class="page flex-col">
        <div class="group_1 flex-col">
          <div class="box_1 flex-col justify-end" style="min-height: 100vh">
            <site-header @auth-updated="refreshAuthCapabilities" />
            <!-- header start -->
            <div v-if="false" class="group_2 flex-col">
              <div class="box_2 flex-row">
                <div class="flex-row" style="align-items: center;">
                  <img @click="toPath('/index')"
                       data-track-text="首页Logo"
                       aria-label="首页Logo"
                       class="image_1"
                       referrerpolicy="no-referrer"
                       src="../assets/v2/img/logo-black.png"
                  />
                  <span class="text_1">
                    <span data-track-text="首页" aria-label="首页" @click="toPath('/')">首页</span>
                    <span>
                      <el-dropdown @command="gotoPage">
                        <span>
                          产品
                        </span>
                        <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                            command="text"
                            style="z-index: 1; font-weight: 800"
                        >
                          <span> 文本翻译 </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                            command="doc"
                            style="z-index: 1; font-weight: 800"
                        >
                          <span> 文档翻译 </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                            command="ai"
                            style="z-index: 1; font-weight: 800"
                        >
                          <span> AI翻译 </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                            command="lange"
                            style="z-index: 1; font-weight: 800"
                        >
                          <span> 多语种翻译 </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                            command="polish"
                            style="z-index: 1; font-weight: 800"
                        >
                          <span> 润色改写 </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                            command="aiPPT"
                            style="z-index: 1; font-weight: 800"
                        >
                          <span> AI PPT </span>
                        </el-dropdown-item>
                        <el-dropdown-item
                            command="rag"
                            style="z-index: 1; font-weight: 800; position: relative;"
                        >
                          <span> RAG知识库 </span>
                          <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: 2px;right: 5px;width: 18px;height: auto;"/>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                      </el-dropdown>
                      <img
                          class="thumbnail_4"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/trans/operate.png"
                      />
                    </span>
                    <span>
                      <el-dropdown @command="logOut">
                          <span>
                            服务
                          </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="toTransPro" style="z-index: 1;font-weight: 800">
                              <span>
                                人工翻译
                              </span>
                          </el-dropdown-item>
                          <el-dropdown-item command="standLangSet" style="z-index: 1;font-weight: 800">
                              <span>
                                术语词库
                              </span>
                          </el-dropdown-item>
                          <el-dropdown-item command="convertDoc" style="z-index: 1;font-weight: 800">
                              <span>
                                文档转换
                              </span>
                          </el-dropdown-item>
                          <el-dropdown-item command="mySelfDoc" style="z-index: 1;font-weight: 800">
                              <span>
                                我的文档
                              </span>
                          </el-dropdown-item>
                          <el-dropdown-item command="webTranslate" style="z-index: 1;font-weight: 800;position: relative;">
                              <span>
                                网页翻译
                              </span>
                              <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: 2px;right: 5px;width: 18px;height: auto;"/>
                          </el-dropdown-item>
                          <el-dropdown-item command="smartClassify" style="z-index: 1;font-weight: 800;position: relative;">
                              <span>
                                数据分析
                              </span>
                              <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: 2px;right: 5px;width: 18px;height: auto;"/>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <img
                          class="thumbnail_4"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/trans/operate.png"
                      />
                    </span>
                </span>
                </div>
                <div class="flex-row" style="align-items: center;">
                  <img class="thumbnail_1"
                       @click="toPath('/help')"
                       data-track-text="帮助"
                       aria-label="帮助"
                       referrerpolicy="no-referrer"
                       src="../assets/v2/img/trans/help.png"/>
                  <span class="text_2" data-track-text="帮助" aria-label="帮助" @click="toPath('/help')">帮助</span>
                  <span class="text_2" v-if="groupUserInfo==='机构登录'"
                        data-track-text="机构登录"
                        aria-label="机构登录"
                        @click="showIframe('/login')">
                {{ groupUserInfo }}
              </span>
                  <el-dropdown @command="logOut" v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'"
                               style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">
                <span v-show="groupUserInfo!==''&&groupUserInfo!=='机构登录'" class="text_2">{{
                    groupUserInfo
                  }}</span>
                    <el-dropdown-menu v-if="groupUserInfo!==''&&groupUserInfo!=='机构登录'" slot="dropdown">
                      <el-dropdown-item v-for="(item,index) in groupUserInfos" :key="index" :command="item.name"
                                        style="z-index: 1;font-weight: 800">
                    <span style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">{{
                        item.name
                      }}</span>
                        <span
                            style="margin-left:10px; font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;"
                            v-if="!item.isIpScore">退出</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <img class="thumbnail_1"
                       @click="userInfo!==''?toCenter:''"
                       data-track-text="个人中心"
                       aria-label="个人中心"
                       referrerpolicy="no-referrer"
                       src="../assets/v2/img/trans/login.png"/>
                  <el-dropdown @command="logOut" v-if="showloginOut"
                               style="display: flex;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">
                  <span v-show="userInfo!==''" class="text_2">
                    {{ userInfo }}
                  </span>
                    <el-dropdown-menu v-if="showloginOut" slot="dropdown">
                      <el-dropdown-item command="toCenter" style="z-index: 1;font-weight: 800">
                  <span
                      style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">个人中心</span>
                      </el-dropdown-item>
                      <el-dropdown-item style="z-index: 1;font-weight: 800">
                    <span
                        style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">退出</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <span class="text_2" v-show="userInfo===''">
                  <span data-track-text="登录" aria-label="登录" @click="showIframe('/login')">登录</span>
                    /
                  <span data-track-text="注册" aria-label="注册" @click="showIframe('/register')">注册</span>
                </span>
                  <span v-if="isShowInRoaming&&showRoaming">
                  <span class="text_2">｜</span>
                  <el-popover
                      @hide="removeQrcode"
                      @show="getQrcode"
                      placement="top-start"
                      title="扫一扫开通漫游"
                      width="150"
                      trigger="hover">
                    <el-image
                        :src="qrcodeUrl"
                        fit="contain"
                        style="width: 150px; height: 150px"
                        alt="开通漫游">
                    </el-image>
                    <el-button type="text" slot="reference" class="text_2"
                               style="margin-top: 4px;cursor: pointer">开通漫游</el-button>
                  </el-popover>
                  <span style="position: absolute;margin-top: -8px;margin-left: -20px;">
                    <img src="../assets/new_icon.png" alt="">
                  </span>
                </span>
                </div>
              </div>
            </div>
            <!-- header end -->
            <div class="group_3 flex-col">
              <div class="new-container">
                <div class="box_4" :class="[['doc','polish','more','convert'].includes(checkType)?'flex-row':'']">
                  <div class="text-workbench-toolbar" style="display: flex;align-items:center;width: 1200px"
                       v-show="checkType==='txt'">
                    <span class="flex-row text-workbench-language"
                          style="align-items:center; margin-left: 30px; height: 40px; gap: 10px;">
                      <!-- <span class="text_4">热门功能</span> -->
                      <div class="image-wrapper_1 flex-col" ref="divToExclude3">
                        <div class="text-wrapper_1" data-track-ignore data-track-text="选择文本翻译源语种" aria-label="选择文本翻译源语种" @mousedown="trackLanguageSelector(1)" @click="showLang(1)">
                          <span class="text_6">{{ originalFrom }}</span>
                          <img
                              class="thumbnail_5"
                              referrerpolicy="no-referrer"
                              src="../assets/v2/img/trans/operate.png"/>
                        </div>
                        <transition name="el-fade-in">
                          <div v-if="showLangV===1"
                               style="height: 5px;width: 100%;position: relative;background: #ffffff;margin-top:-4px;z-index: 2000"></div>
                        </transition>
                        <transition name="el-fade-in">
                          <div v-if="showLangV===1" ref="divToExclude1">
                            <lang_panel :val="uploadform.from" :terminology="'暂不使用术语'"
                                        @custom-event="(val)=>changeUploadform(val,'from')"/>
                          </div>
                        </transition>
                      </div>
                      <img @click="zhuanhuan"
                           class="thumbnail_26"
                           data-track-text="切换语种"
                           aria-label="切换语种"
                           referrerpolicy="no-referrer"
                           src="../assets/v2/img/trans/transform.png"
                      />
                      <div class="image-wrapper_2 flex-col" ref="divToExclude4">
                        <div class="text-wrapper_1" data-track-ignore data-track-text="选择文本翻译目标语种" aria-label="选择文本翻译目标语种" @mousedown="trackLanguageSelector(2)" @click="showLang(2)">
                          <span class="text_8">{{ originalTo }}</span>
                          <img
                              class="thumbnail_6"
                              referrerpolicy="no-referrer"
                              src="../assets/v2/img/trans/operate.png"/>
                        </div>
                        <transition name="el-fade-in">
                          <div v-if="showLangV===2"
                               style="height: 5px;width: 100%;position: relative;background: #ffffff;margin-top:-4px;z-index: 2000"></div>
                        </transition>
                        <transition name="el-fade-in">
                          <div v-if="showLangV===2" ref="divToExclude2">
                            <lang_panel :to="true" :val="uploadform.to" :terminology="'暂不使用术语'"
                                        @custom-event="(val)=>changeUploadform(val,'to')"/>
                          </div>
                        </transition>
                      </div>
                      <!-- ai入口 -->
                      <!-- <AiEntry ref="AiEntry" :showLangV="showLangV" :aiModelList="aiModelList" @changeMode="changeMode" @changLang="showLang" /> -->
                      <!-- ai入口 -->
                    </span>
                    <div class="block_1 flex-row" :class="[isShowHistoryRecord?'':'hide-history']"
                         style="margin-left: 570px; gap: 8px; align-items: center;">
                      <span class="btn-toolbar" data-track-text="查看任务列表" aria-label="查看任务列表" @click="toPath('/list-pro','doc')">
                        <span class="el-icon-renwu"></span>
                        <span class="text_5">任务列表</span>
                      </span>
                      <span
                          class="btn-toolbar"
                          data-track-id="translate.history.toggle"
                          data-track-name="translate_history_toggle"
                          data-track-component="NewUploadHistory"
                          data-track-business-id="history"
                          data-track-text="展开翻译历史"
                          aria-label="展开翻译历史"
                          v-show="!isShowHistoryRecord"
                          @click="toggleHistoryRecord">
                        <span class="el-icon-lishijilu"></span>
                        历史记录
                      </span>
                    </div>
                  </div>
                  <div
                      class="doc-workbench-toolbar"
                      style="display: flex;align-items:center;justify-content: space-between;width: 1200px;margin-bottom: 10px;"
                      v-show="checkType==='doc'">
                    <span class="flex-row doc-workbench-main" style="align-items:center; gap: 20px; margin-left: 30px;">
                      <!-- <span class="text_4">热门功能</span> -->
                      <!-- <div style="display:flex;flex-flow: column;"> -->
                      <!-- <span class="text_4">行业领域</span> -->
                      <!-- <div style="display: flex;margin-left: -76px;align-items: center;">
                        <div class="image-wrapper_1 flex-col" ref="divToExclude10" style="z-index: 100;">
                          <div class="text-wrapper_1" @click="showLang(5)">
                            <span class="text_6">{{ getDomainName(domain) }}</span>
                            <img
                                class="thumbnail_5"
                                referrerpolicy="no-referrer"
                                src="../assets/v2/img/trans/operate.png"/>
                          </div>
                        <transition name="el-fade-in">
                          <div v-show="showLangV===5" ref="divToExclude9">
                            <div
                                style="background: #ffffff;z-index: 200;box-shadow: 0px 0px 21px 0px rgba(160,168,199,0.18);border-radius: 10px;position: absolute;">
                              <div class="domains" style="display: flex;justify-content: space-between;width: 235px;"
                                  @click="()=>{domain=item.value; showLangV = -1}"
                                  v-for="item in domainOptions"
                                  :key="item.value" :style="domain===item.value?{'color':'var(--primary)'}:''">
                              <span>{{ item.label }}</span>
                              <span style="color: #bfbfbf;">{{ item.from }}</span>
                              </div>
                            </div>
                          </div>
                        </transition>
                        </div>
                      </div> -->
                      <!-- </div> -->
                      <!-- <div style="display:flex;flex-flow: column;margin-left: 15px;" v-show="domain===''"> -->
                      <!-- <span class="text_4">术语词典</span> -->
                      <!-- <div style="display: flex;margin-left: -76px;align-items: center;">
                        <div class="image-wrapper_1 flex-col" ref="divToExclude16" style="z-index: 50;">
                          <div class="text-wrapper_1" @click="showLang(13)">
                            <span class="text_6">{{ terminology }}</span>
                            <img
                                class="thumbnail_5"
                                referrerpolicy="no-referrer"
                                src="../assets/v2/img/trans/operate.png"/>
                          </div>
                        <transition name="el-fade-in">
                          <div v-show="showLangV===13" ref="divToExclude15">
                            <div
                                style="width: 210px;background: #ffffff;z-index: 200;box-shadow: 0px 0px 21px 0px rgba(160,168,199,0.18);border-radius: 10px;position: absolute;">
                              <div class="domains" style="display: flex;justify-content: space-between;"
                                  @click="()=>{terminology=item.value;showLangV=-1;}"
                                  v-for="item in terminologyOptions"
                                  :key="item.value" :style="terminology===item.value?{'color':'var(--primary)'}:''">
                              <span>{{ item.label }}</span>
                              <span style="color: #bfbfbf;">{{ item.from }}</span>
                              </div>
                            </div>
                          </div>
                        </transition>
                        </div>
                      </div> -->
                      <!-- </div> -->
                      <div class="doc-workbench-language" style="display:flex; align-items:center; gap: 10px; height:40px;">
                        <!-- <span class="text_4">选择语言</span> -->
                        <div style="display: flex;align-items: center;z-index: 10">
                          <div class="image-wrapper_1 flex-col" ref="divToExclude5">
                            <div class="text-wrapper_1" data-track-ignore data-track-text="选择文档翻译源语种" aria-label="选择文档翻译源语种" @mousedown="trackLanguageSelector(3)" @click="showLang(3)">
                              <span class="text_6">{{ originalFrom }}</span>
                              <img
                                  class="thumbnail_5"
                                  referrerpolicy="no-referrer"
                                  src="../assets/v2/img/trans/operate.png"/>
                            </div>
                            <transition name="el-fade-in">
                              <div v-show="showLangV===3"
                                   style="height: 5px;width: 100%;position: relative;background: #ffffff;margin-top:-4px;z-index: 2000"></div>
                            </transition>
                            <transition name="el-fade-in">
                              <div v-show="showLangV===3" ref="divToExclude6">
                                <lang_panel :val="uploadform.from" @custom-event="(val)=>changeUploadform(val,'from')"
                                            :domain="domain" :terminology="terminology"/>
                              </div>
                            </transition>
                          </div>
                          <img @click="zhuanhuan"
                               class="thumbnail_26"
                               data-track-text="切换语种"
                               aria-label="切换语种"
                               referrerpolicy="no-referrer"
                               src="../assets/v2/img/trans/transform.png"
                          />
                          <div class="image-wrapper_2 flex-col" ref="divToExclude7">
                            <div class="text-wrapper_1" data-track-ignore data-track-text="选择文档翻译目标语种" aria-label="选择文档翻译目标语种" @mousedown="trackLanguageSelector(4)" @click="showLang(4)">
                              <span class="text_8">{{ originalTo }}</span>
                              <img
                                  class="thumbnail_6"
                                  referrerpolicy="no-referrer"
                                  src="../assets/v2/img/trans/operate.png"/>
                            </div>
                            <transition name="el-fade-in">
                              <div v-show="showLangV===4"
                                   style="height: 5px;width: 100%;position: relative;background: #ffffff;margin-top:-4px;z-index: 2000"></div>
                            </transition>
                            <transition name="el-fade-in">
                              <div v-show="showLangV===4" ref="divToExclude8">
                                <lang_panel :to="true" :val="uploadform.to"
                                            @custom-event="(val)=>changeUploadform(val,'to')" :domain="domain"
                                            :terminology="terminology"/>
                              </div>
                            </transition>
                          </div>
                        </div>
                      </div>
                      <!-- ai入口 -->
                      <AiEntry
                          class="doc-model-entry"
                          ref="AiEntry"
                          :userInfo="userInfo"
                          :is-authenticated="isAuthenticated"
                          :showLangV="showLangV"
                          :domainOptionsAll="domainOptionsAll"
                          :aiModelList="aiModelList"
                          @getUserStatus="requireFeatureLogin"
                          @selectDomainAndMode="selectDomainAndMode"
                          @changeMode="changeMode"
                          @changLang="showLang"/>
                      <!-- ai入口 -->
                    </span>
                    <span class="doc-workbench-actions" style="display: flex;width: 330px;justify-content: right;align-items: center;gap: 8px;">
                      <div class="doc-terminology-toggle" v-show="domain===''">
                        <el-checkbox @change="changeTerminologyName">术语词库</el-checkbox>
                      </div>
                      <span class="btn-toolbar" data-track-text="切换文档上传列表" aria-label="切换文档上传列表" @click="()=>{isShowNewUpload=!isShowNewUpload;isShowNewUploadList=!isShowNewUploadList;if(isShowNewUploadList) tmpList('doc')}">
                        <span class="el-icon-wenjian"></span>
                        <span class="text_5">{{ !isShowNewUpload && isShowNewUploadList ? '继续上传' : '上传列表' }}</span>
                      </span>
                      <span class="btn-toolbar" data-track-text="查看文档任务列表" aria-label="查看文档任务列表" @click="toPath('/list-pro','doc')">
                        <span class="el-icon-renwu"></span>
                        <span class="text_5">任务列表</span>
                      </span>
                    </span>
                  </div>
                  <div style="display: flex;align-items:center;justify-content: space-between;width: 1200px"
                       v-show="checkType==='AITranslate'">
                    <span class="flex-row" style="align-items:center;">
                      <!-- <span class="text_4">热门功能</span> -->
                    </span>
                  </div>
                  <div style="display: flex;align-items:center;justify-content: space-between;width: 1200px"
                       v-show="checkType==='polish'">
                    <span class="flex-row" style="align-items:center;">
                      <!-- <span class="text_4">热门功能</span> -->
                    </span>
                  </div>
                  <div style="display: flex;align-items:center;justify-content: space-between;width: 1200px"
                       v-show="checkType==='aiPPT'">
                    <span class="flex-row" style="align-items:center;">
                      <!-- <span class="text_4">热门功能</span> -->
                    </span>
                  </div>
                  <div class="image-workbench-toolbar" style="display: flex;align-items:center;justify-content: space-between;width: 1200px"
                       v-show="checkType==='img'">
                    <span class="flex-row image-workbench-language"
                          style="align-items:center;height: 40px;margin-left:30px;gap: 10px;">
                      <!-- <span class="text_4">热门功能</span> -->
                      <div class="image-wrapper_1 flex-col" style="" ref="divToExclude11">
                        <div class="text-wrapper_1" data-track-ignore data-track-text="选择图片翻译源语种" aria-label="选择图片翻译源语种" @mousedown="trackLanguageSelector(11)" @click="showLang(11)">
                          <span class="text_6">{{ originalImgFrom }}</span>
                          <img
                              class="thumbnail_5"
                              referrerpolicy="no-referrer"
                              src="../assets/v2/img/trans/operate.png"/>
                        </div>
                          <div v-show="showLangV===11" ref="divToExclude12">
                            <div class="image-language-menu"
                                style="background: #ffffff;z-index: 200;box-shadow: 0px 0px 21px 0px rgba(160,168,199,0.18);border-radius: 10px;position: absolute;width: 116px;overflow-y: clip;">
                              <div class="image-language-menu-scroll" style="height: 500px;overflow-y: auto;width: 125px;">
                                <div class="domains" :data-track-text="`选择图片源语种${item.label}`" :aria-label="`选择图片源语种${item.label}`" @click="()=>{uploadImgForm.from=item.value; showLangV = -1}"
                                     v-for="item in imgFromOptions"
                                     :key="item.value" :style="uploadImgForm.from===item.value?{'color':'var(--primary)'}:''">
                                <span>{{ item.label }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                      <img @click="zhuanhuanImg" style=""
                           class="thumbnail_26"
                           data-track-text="切换图片翻译语种"
                           aria-label="切换图片翻译语种"
                           referrerpolicy="no-referrer"
                           src="../assets/v2/img/trans/transform.png"
                      />
                      <div class="image-wrapper_2 flex-col" style="" ref="divToExclude13">
                        <div class="text-wrapper_1" data-track-ignore data-track-text="选择图片翻译目标语种" aria-label="选择图片翻译目标语种" @mousedown="trackLanguageSelector(12)" @click="showLang(12)">
                          <span class="text_8">{{ originalImgTo }}</span>
                          <img style="margin-left: 6px"
                               class="thumbnail_14"
                               referrerpolicy="no-referrer"
                               src="../assets/v2/img/trans/operate.png"/>
                        </div>
                          <div v-show="showLangV===12" ref="divToExclude14">
                            <div class="image-language-menu"
                                style="background: #ffffff;z-index: 200;box-shadow: 0px 0px 21px 0px rgba(160,168,199,0.18);border-radius: 10px;position: absolute;width: 116px;overflow-y: clip;">
                              <div class="image-language-menu-scroll" style="height: 500px;overflow-y: auto;width: 125px;">
                                <div class="domains" :data-track-text="`选择图片目标语种${item.label}`" :aria-label="`选择图片目标语种${item.label}`" @click="()=>{uploadImgForm.to=item.value; showLangV = -1}"
                                     v-for="item in imgToOptions"
                                     :key="item.value" :style="uploadImgForm.to===item.value?{'color':'var(--primary)'}:''">
                                <span>{{ item.label }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </span>
                    <span
                        v-if="supportsImageTranslation || supportsEditableWord"
                        class="image-workbench-output">
                      <span class="image-workbench-output-label">输出格式</span>
                      <span class="image-output-switch">
                        <span
                          v-if="supportsImageTranslation"
                          class="switch-item"
                          :class="[imageOutputType === 'image' ? 'active' : '']"
                          data-track-text="切换输出格式翻译图片"
                          aria-label="切换输出格式翻译图片"
                          @click="imageOutputType = 'image'; changeImageOutputType()"
                        >翻译图片</span>
                        <span
                          v-if="supportsEditableWord"
                          class="switch-item"
                          :class="[imageOutputType === 'word' ? 'active' : '']"
                          data-track-text="切换输出格式可编辑Word"
                          aria-label="切换输出格式可编辑Word"
                          @click="imageOutputType = 'word'; changeImageOutputType()"
                        >可编辑 Word</span>
                      </span>
                    </span>
                    <span class="image-workbench-actions" style="display: flex;width: 330px;justify-content: right;align-items: center;gap: 8px;">
                      <span class="btn-toolbar" data-track-text="切换图片上传列表" aria-label="切换图片上传列表" @click="()=>{isShowNewUpload=!isShowNewUpload;isShowNewUploadList=!isShowNewUploadList;if(isShowNewUploadList) tmpList(imageTmpType)}">
                        <span class="el-icon-wenjian"></span>
                        <span class="text_5">{{ !isShowNewUpload && isShowNewUploadList ? '继续上传' : '上传列表' }}</span>
                      </span>
                      <span class="btn-toolbar" data-track-text="查看图片任务列表" aria-label="查看图片任务列表" @click="toPath('/list-pro','doc')">
                        <span class="el-icon-renwu"></span>
                        <span class="text_5">任务列表</span>
                      </span>
                    </span>
                  </div>
                  <div style="display: flex;align-items:center;justify-content: space-between;width: 1200px"
                       v-show="checkType==='music'" v-if="false">
                    <span class="flex-row" style="align-items:center;">
                      <!-- <span class="text_4">热门功能</span> -->
                    </span>
                    <span style="display: flex;width: 330px;justify-content: right;align-items: center;gap: 8px;">
                      <span class="btn-toolbar" data-track-text="切换音频上传列表" aria-label="切换音频上传列表" @click="()=>{isShowNewUpload=!isShowNewUpload;isShowNewUploadList=!isShowNewUploadList;if(isShowNewUploadList) tmpList('music')}">
                        <span class="el-icon-wenjian"></span>
                        <span class="text_5">{{ !isShowNewUpload && isShowNewUploadList ? '继续上传' : '上传列表' }}</span>
                      </span>
                      <span class="btn-toolbar" data-track-text="查看音频任务列表" aria-label="查看音频任务列表" @click="toPath('/list-pro','music')">
                        <span class="el-icon-renwu"></span>
                        <span class="text_5">任务列表</span>
                      </span>
                    </span>
                  </div>
                  <div style="display: flex;align-items:center;justify-content: space-between;width: 1200px"
                       v-show="checkType==='convert'">
                    <span class="flex-row" style="align-items:center;">
                      <!-- <span class="text_4">热门功能</span> -->
                      <div style="display:flex;align-items: center;">
                        <img class="thumbnail_7" referrerpolicy="no-referrer"
                             src="../assets/v2/img/trans/convert-header.png"
                             style="height: 15px;width: 15px" alt=""/>
                        <span
                            style="margin-left: 6px;font-size: 16px;font-family: Microsoft YaHei;font-weight: bold;color: #333333;">文档转换</span>
                      </div>
                    </span>
                  </div>
                  <div class="plugin-workbench-toolbar" style="display: flex;align-items:center;justify-content: space-between;width: 1200px"
                       v-show="checkType==='plugin'">
                    <span class="flex-row" style="align-items:center;">
                      <!-- <span class="text_4">热门功能</span> -->
                      <div class="plugin-workbench-title">
                        <span class="el-icon-daimashengcheng" referrerpolicy="no-referrer"
                              style="height: 17px;width: 15px;color: rgb(213, 153, 100);" alt=""/>
                        <span class="plugin-workbench-label">网页翻译</span>
                        <img :src="require('@/assets/new_icon.png')" alt="new" class="plugin-workbench-new" />
                      </div>
                    </span>
                  </div>
                  <div class="more-workbench-toolbar" style="display: flex;align-items:center;justify-content: space-between;width: 1200px"
                       v-show="checkType==='more'">
                    <span class="flex-row more-workbench-main"
                          style="margin-left: 20px;align-items:center;justify-content: space-between;width: 1200px;">
                      <!-- <span class="text_4">热门功能</span> -->
                      <span class="more-workbench-actions" style="display: flex;width: 330px;justify-content: right;align-items: center;gap: 8px;">
                      <span class="btn-toolbar" data-track-text="切换多语种上传列表" aria-label="切换多语种上传列表" @click="()=>{isShowNewUpload=!isShowNewUpload;isShowNewUploadList=!isShowNewUploadList;if(isShowNewUploadList) tmpList('more')}">
                        <span class="el-icon-wenjian"></span>
                        <span class="text_5">{{ !isShowNewUpload && isShowNewUploadList ? '继续上传' : '上传列表' }}</span>
                      </span>
                      <span class="btn-toolbar" data-track-text="查看多语种任务列表" aria-label="查看多语种任务列表" @click="toPath('/list-pro','doc')">
                        <span class="el-icon-renwu"></span>
                        <span class="text_5">任务列表</span>
                      </span>
                    </span>
                    </span>
                  </div>
                  <div class="terminology-toolbar" style="display: flex;align-items:center;justify-content: space-between;width: 1200px"
                       v-show="checkType==='setting'">
                    <div
                        ref="terminologyAiLauncher"
                        class="terminology-ai-launcher"
                        v-show="!showAi"
                        role="button"
                        tabindex="0"
                        data-track-text="AI助手"
                        aria-label="AI助手，可拖动"
                        title="拖动调整位置，点击打开 AI 助手"
                        @pointerdown="startAiLauncherDrag"
                        @click="handleAiLauncherClick"
                        @keydown.enter.prevent="handleAiLauncherClick"
                        @keydown.space.prevent="handleAiLauncherClick"
                    >
                      <img src="../assets/v2/img/trans/ai.png" alt="" draggable="false" @dragstart.prevent/>
                    </div>
                    <div class="terminology-ai-panel" v-show="showAi">
                      <div class="terminology-ai-shell"
                          style="width: 289px;height: 560px;background: #F5FAFB;box-shadow: 0px 4px 10px 0px rgba(24,54,60,0.2);border-radius: 6px;">
                        <div class="terminology-ai-header" style="width: 289px;height: 40px;background: #059669;border-radius: 6px 6px 0px 0px;display: flex;align-items: center;
                        justify-content:space-between;padding-left: 13px;padding-right: 13px">
                          <span
                              style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #F9FBFE;">历史记录</span>
                          <img src="../assets/v2/img/trans/close.png" alt="" data-track-text="关闭AI助手" aria-label="关闭AI助手" style="cursor: pointer"
                               @click="showAi=false;createAi=false">
                        </div>
                        <div class="terminology-ai-chat-view" v-show="createAi">
                          <div class="terminology-ai-messages" style="padding: 0px 10px 0px 20px;height: 400px;overflow-y: scroll;" ref="chatbox">
                            <div v-for="item in aiMessage">
                              <div v-if="item.getMessageType()==='answer'"
                                   style="display: flex;align-items: start;justify-content: space-between;padding: 20px 0 10px 0">
                                <img src="../assets/v2/img/trans/ai_p.png" alt="" style="cursor: pointer">
                                <div class="terminology-ai-answer" style="position: relative;flex: 1;box-sizing: border-box;padding: 10px 11px;margin-left: 10px;
                                min-width: 150px;max-width: 268px;min-height: 37px;background: #FFFFFF;border: 1px solid #9BB7D8;border-radius: 4px;word-wrap: break-word;overflow-wrap: break-word;">
                                <span
                                    style="position: relative;flex: 1;box-sizing: border-box;overflow: auto;pfont-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">
                                  {{ item.getContent() }}
                                </span>
                                </div>
                              </div>
                              <div v-if="item.getMessageType()==='question'"
                                   style="width: 100%;display: flex;flex-flow:column;align-items: flex-end;padding: 20px 0 10px 0">
                                <div
                                    style="font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;padding-bottom: 10px;">
                                  {{ userInfo || '用户' }}
                                </div>
                                <div class="terminology-ai-question"
                                    style="min-width: 150px;max-width: 268px;min-height: 37px;background: #059669;border-radius: 4px;word-wrap: break-word;overflow-wrap: break-word;padding: 10px 11px;">
                                <span
                                    style="position: relative;flex: 1;box-sizing: border-box;overflow: auto;pfont-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #ffffff;">
                                  {{ item.getContent() }}
                                </span>
                                </div>
                              </div>
                            </div>
                            <div v-if="aiMessageTemp.content"
                                 style="width: 100%;display: flex;flex-flow:column;align-items: flex-end;padding: 20px 0 10px 0">
                              <div
                                  style="font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;padding-bottom: 10px;">
                                {{ userInfo || '用户' }}
                              </div>
                              <div class="terminology-ai-question"
                                  style="min-width: 150px;max-width: 268px;min-height: 37px;background: #059669;border-radius: 4px;word-wrap: break-word;overflow-wrap: break-word;padding: 10px 11px;">
                                <span
                                    style="position: relative;flex: 1;box-sizing: border-box;overflow: auto;pfont-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #ffffff;">
                                  {{ aiMessageTemp.content }}
                                </span>
                                <span class="loader"></span>
                              </div>
                            </div>
                          </div>
                          <div class="shuru">
                            <el-input @keyup.enter="aiSend"
                                      type="textarea"
                                      :autosize="{ minRows: 3, maxRows: 3}"
                                      placeholder="请输入内容"
                                      v-model="message">
                            </el-input>
                            <div style="width: 100%;display: flex;justify-content: space-between">
                              <div class="terminology-ai-action" data-track-text="AI助手返回" aria-label="AI助手返回" @click="callBack"
                                   style="width: 71px;height: 28px;background: #059669;border-radius: 4px;cursor: pointer;
                              display: flex;align-items: center;justify-content: center;    margin-left: 10px;margin-top: 7px;"
                              >
                            <span
                                style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;">返回</span>
                              </div>
                              <div class="terminology-ai-action" data-track-text="AI助手发送" aria-label="AI助手发送" @click="aiSend"
                                   style="width: 71px;height: 28px;background: #059669;border-radius: 4px;cursor: pointer;
                              display: flex;align-items: center;justify-content: center;    margin-right: 10px;margin-top: 7px;">
                            <span
                                style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;">发送</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="terminology-ai-history-view" v-show="!createAi">
                          <div
                              class="terminology-ai-history-list"
                              style="width: 100%;display: flex;align-items: center;flex-flow: column;margin-top: 14px;height: 500px;overflow-y: auto;overflow-x: hidden;">
                            <div class="terminology-ai-new-chat" style="width: 255px;height: 40px;background: #FFFFFF;border: 1px solid var(--primary);border-radius: 4px;
                                          display: flex;justify-content: center;align-items: center;cursor: pointer;margin-bottom:35px; "
                                 data-track-text="新建AI对话" aria-label="新建AI对话" @click="createAiSession">
                              <img src="../assets/v2/img/trans/creat_room.png" alt=""/>
                              <span
                                  style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #10b981;margin-left: 5px">新建对话</span>
                            </div>
                            <div style="width: 100%;padding: 0 15px 0 15px">
                              <div class="terminology-ai-history-title"
                                  style="font-size: 14px;font-family: Microsoft YaHei;font-weight: bold;color: #059669;">
                                历史记录
                              </div>
                            </div>
                            <hr class="terminology-ai-divider" style="background: #DCE4E7;width: 290px;border: 1px solid #DCE4E7;"/>
                            <span v-for="item in sessionList" :key="item.getSessionId()">
                              <div style="width: 100%;padding: 0 15px 0 15px">
                                <div
                                    style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;">
                                  <img src="../assets/v2/img/trans/ai_history.png" style="margin-right: 10px" alt=""/>
                                  <span style="cursor: pointer" data-track-text="打开AI历史会话" aria-label="打开AI历史会话" @click="getHistory(item,false)">{{
                                      item.getName()
                                    }}</span>
                                  <img src="../assets/v2/img/trans/ai_his_del.png"
                                       data-track-text="删除AI会话"
                                       aria-label="删除AI会话"
                                       style="cursor: pointer;float: inline-end;margin-top: 2px；" alt=""
                                       @click="delAiSession(item.getSessionId())"/>
                                </div>
                              </div>
                              <hr class="terminology-ai-divider" style="background: #DCE4E7;width: 290px;border: 1px solid #DCE4E7;"/>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span class="flex-row terminology-filter-row"
                          style="margin-left:20px;align-items:center;justify-content: space-between;width: 1200px;">
                      <!-- <span class="text_4" style="width: 150px;">热门功能</span> -->
                      <span class="terminology-filter-controls" style="display: flex;flex: 1;">
                        <span
                            class="terminology-specialty-filter"
                            style="font-size: 15px;font-family: Microsoft YaHei;font-weight: 400;color: #111111; display: flex;align-items: center;">
                          按专业浏览名词
                          <div class="borderNewSelect" style="margin-left: 15px">
                              <el-select
                                  size="small"
                                  v-model="specQuery"
                                  filterable
                                  clearable
                                  popper-class="terminology-spec-popper"
                                  placeholder="请选择"
                                  @visible-change="handleSettingVisibility"
                                  @change="handleCurrentChange(1)"
                              >
                              <el-option
                                  v-for="item in specData"
                                  :key="item"
                                  :label="item"
                                  :value="item">
                              </el-option>
                            </el-select>
                          </div>
                        </span>
                        <div class="block_1 flex-row query terminology-search" style="width:300px;margin-left: 50px">
                          <el-input placeholder="请输入中文名或英文名称" v-model="query" class="input-with-select"
                                    size="small"
                                    clearable
                                    @focus="prepareMedicineDict"
                                    @change="handleCurrentChange(1)">
                            <span slot="append" data-track-text="检索术语" aria-label="检索术语" @click="handleCurrentChange(1)">检索</span>
                          </el-input>
                        </div>
                        <div class="terminology-result-count"
                            style="flex: 1;font-size: 15px;font-family: Microsoft YaHei;font-weight: 400;color: #111111; display: flex;align-items: center;justify-content: flex-end;">
                          <span>收录相关名词<span class="terminology-count" style="color: var(--primary)">{{ queryCount }}</span>个</span>
                        </div>
                      </span>
                    </span>
                  </div>
                  <div v-if="['txt','convert'].includes(checkType)" class="divider"></div>
                </div>
                <div class="box_5 flex-row">
                  <!-- check tab-->
                  <div class="section_1 flex-col">
	                    <button
	                        type="button"
	                        class="mobile-tool-selector"
	                        data-track-id="translate.mobile.tool-selector"
	                        data-track-text="打开移动端工具选择"
	                        data-track-component="NewUploadMobileMenu"
	                        :aria-expanded="mobileMenuOpen ? 'true' : 'false'"
	                        aria-controls="mobile-tool-menu"
                        @click="mobileMenuOpen = true"
                    >
                      <span class="mobile-tool-selector-main">
                        <span class="mobile-tool-selector-icon" :class="mobileActiveMenuItem.icon"></span>
                        <span class="mobile-tool-selector-copy">
                          <span class="mobile-tool-selector-label">当前工具</span>
                          <span class="mobile-tool-selector-name">{{ mobileActiveMenuItem.text }}</span>
                        </span>
                      </span>
                      <span class="mobile-tool-selector-action">
                        切换工具
                        <span class="el-icon-arrow-right"></span>
                      </span>
                    </button>
                    <transition name="el-fade-in">
                      <div
                          v-show="mobileMenuOpen"
                          id="mobile-tool-menu"
                          class="mobile-tool-overlay"
                          role="dialog"
	                          aria-modal="true"
	                          aria-label="选择工具"
	                          data-track-ignore
	                          @click.self="mobileMenuOpen = false"
	                      >
                        <div class="mobile-tool-sheet">
                          <div class="mobile-tool-sheet-header">
                            <div>
                              <strong>选择工具</strong>
                              <span>翻译、写作与文档服务</span>
                            </div>
	                            <button type="button" data-track-id="translate.mobile.close-tool-selector" data-track-text="关闭移动端工具选择" data-track-component="NewUploadMobileMenu" aria-label="关闭工具选择" @click="mobileMenuOpen = false">
                              <span class="el-icon-close"></span>
                            </button>
                          </div>
                          <div class="mobile-tool-sheet-body">
                            <section class="mobile-tool-group" v-for="(val, key) in menuList" :key="'mobile-' + key">
                              <h3>{{ val.title }}</h3>
                              <div class="mobile-tool-grid">
                                <button
                                    type="button"
	                                    class="mobile-tool-item"
	                                    :class="[currentMenu.url === item.url && item.type === checkType ? 'active' : '']"
	                                    :data-track-id="'translate.mobile.menu.' + (item.type || item.url)"
	                                    :data-track-text="item.text"
	                                    data-track-component="NewUploadMobileMenu"
	                                    :data-track-business-id="item.type || item.url"
	                                    v-for="item in val.list"
                                    :key="'mobile-' + item.text"
                                    @click="selectMobileTool(item)"
                                >
                                  <span class="mobile-tool-item-icon" :class="item.icon"></span>
                                  <span>{{ item.text }}</span>
                                </button>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </transition>
                    <div class="menu">
                      <div class="menu-type" v-for="(val, key) in menuList" :key="key">
                        <div class="title">{{ val.title }}</div>
                        <div
                            class="menu-item"
                            :class="[currentMenu.url === item.url && item.type===checkType ? 'active' : '']"
                            :data-track-id="'translate.menu.' + (item.type || item.url)"
                            :data-track-name="'translate_menu_click'"
                            data-track-component="NewUploadSideMenu"
                            :data-track-business-id="item.type || item.url"
                            role="button"
                            tabindex="0"
                            :aria-label="item.text"
                            :aria-current="currentMenu.url === item.url && item.type===checkType ? 'page' : null"
                            v-for="item in val.list"
                            :key="item.text"
                            @mousedown="trackMenuBeforeNavigate(item)"
                            @click.capture="trackMenuBeforeNavigate(item)"
                            @click="gotoUrl(item)"
                            @keydown.enter.prevent="gotoUrl(item)"
                            @keydown.space.prevent="gotoUrl(item)"
                        >
                          <span class="menu-icon" :class="[item.icon]"></span>
                          <span class="menu-name">{{ item.text }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="box_6 flex-row">
                      <div class="image-wrapper_4 flex-col justify-between">
                        <img v-show="checkType==='txt'"
                            class="thumbnail_16"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/txt-check.png"
                        />
                        <img v-show="checkType!=='txt'"
                            class="thumbnail_16"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/txt.png"
                        />
                        <img v-show="checkType!=='doc'"
                            class="thumbnail_17"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/doc.png"
                        />
                        <img v-show="checkType==='doc'"
                            class="thumbnail_17"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/doc-check.png"
                        />
                        <img v-show="checkType!=='AITranslate'"
                            class="thumbnail_17_1"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/setting.png"
                        />
                        <img v-show="checkType==='AITranslate'"
                            class="thumbnail_17_1"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/setting-check.png"
                        />
                        <img v-show="checkType!=='polish'"
                            class="thumbnail_17_1"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/setting.png"
                        />
                        <img v-show="checkType==='polish'"
                            class="thumbnail_17_1"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/setting-check.png"
                        />
                        <img v-show="checkType!=='aiPPT'"
                            class="thumbnail_17_1"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/setting.png"
                        />
                        <img v-show="checkType==='aiPPT'"
                            class="thumbnail_17_1"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/setting-check.png"
                        />
                        <img v-show="checkType!=='setting'"
                            class="thumbnail_17_1"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/setting.png"
                        />
                        <img v-show="checkType==='setting'"
                            class="thumbnail_17_1"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/setting-check.png"
                        />
                        <img v-show="checkType!=='img'"
                            class="thumbnail_17_1"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/img.png"
                        />
                        <img v-show="checkType==='img'"
                            class="thumbnail_17_1"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/img-check.png"
                        />
                      </div>
                      <div class="text-wrapper_2">
                        <span class="text_9_1" :class="checkType==='txt'?'paragraph_1':''"
                              @click="()=>{checkType='txt';isShowNewUpload=true;isShowNewUploadList=false;toPath('/translate','txt')}">文本翻译</span>
                        <br/>
                        <span class="text_9" :class="checkType==='doc'?'paragraph_1':''"
                              @click="()=>{checkType='doc';isShowNewUpload=true;isShowNewUploadList=false;toPath('/translate','doc')}">文档翻译</span>
                        <br/>
                        <span class="text_9" :class="checkType==='AITranslate'?'paragraph_1':''"
                              @click="()=>{checkType='AITranslate';isShowNewUpload=true;isShowNewUploadList=false;toPath('/translate','AITranslate')}">AI翻译</span>
                        <br/>
                        <span class="text_9" :class="checkType==='polish'?'paragraph_1':''"
                              @click="()=>{checkType='polish';isShowNewUpload=true;isShowNewUploadList=false;toPath('/translate','polish')}">润色改写</span>
                              <br/>
                        <span class="text_9" :class="checkType==='aiPPT'?'paragraph_1':''"
                              @click="()=>{checkType='aiPPT';isShowNewUpload=true;isShowNewUploadList=false;toPath('/translate','aiPPT')}">AI PPT</span>
                        <span class="text_9" :class="checkType==='setting'?'paragraph_1':''"
                              @click="()=>{checkType='setting';isShowNewUpload=true;isShowNewUploadList=false;toPath('/translate','setting')}">医学术语</span>
                        <br/>
                        <span class="text_9" :class="checkType==='img'?'paragraph_1':''"
                              @click="()=>{checkType='img';isShowNewUpload=true;isShowNewUploadList=false;toPath('/translate','img')}">图片翻译</span>
                      </div>
                      <img v-show="checkType==='txt'"
                          class="image_2"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/trans/check.png"
                      />
                      <img v-show="checkType==='doc'"
                          class="image_2" style="margin-top: 45px"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/trans/check.png"
                      />
                      <img v-show="checkType==='setting'"
                          class="image_2" style="margin-top: 85px"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/trans/check.png"
                      />
                      <img v-show="checkType==='img'"
                          class="image_2" style="margin-top: 120px"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/trans/check.png"
                      />
                    </div> -->
                    <!-- <span class="text_10">翻译功能</span>
                    <div class="box_7 flex-row">
                      <div class="image-wrapper_5 flex-col">
                        <img v-show="checkType!=='more'"
                            class="thumbnail_18"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/more.png"
                        />
                        <img v-show="checkType==='more'"
                            class="thumbnail_18"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/more-check.png"
                        />
                        <img v-show="checkType!=='music'"
                            class="thumbnail_19"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/music.png"
                        />
                        <img v-show="checkType==='music'"
                            class="thumbnail_19"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/music-check.png"
                        />
                        <img v-show="checkType!=='video'"
                            class="thumbnail_20"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/vidoe.png"
                        />
                        <img v-show="checkType==='video'"
                            class="thumbnail_20"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/vidoe-check.png"
                        />
                      </div>
                      <span class="paragraph_2">
                        <span :class="checkType==='more'?'paragraph_1':''"
                              @click="()=>{checkType='more';isShowNewUpload=true;isShowNewUploadList=false;toPath('/translate','more')}">多语种翻译</span>
                        <br/>
                        <span :class="checkType==='music'?'paragraph_1':''"
                              @click="()=>{checkType='music';isShowNewUpload=true;isShowNewUploadList=false;toPath('/translate','music')}">音频翻译</span>
                        <br/>
                        <span :class="checkType==='video'?'paragraph_1':''"
                              @click="()=>{checkType='video';isShowNewUpload=true;isShowNewUploadList=false;toPath('/translate','video')}">视频翻译</span>
                      </span>
                      <img v-show="checkType==='more'"
                          class="image_2"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/trans/check.png"
                      />
                      <img v-show="checkType==='music'"
                          class="image_2" style="margin-top: 50px"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/trans/check.png"
                      />
                      <img v-show="checkType==='video'"
                          class="image_2" style="margin-top: 90px"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/trans/check.png"
                      />
                    </div>
                    <span class="text_11">文档服务</span>
                    <div class="box_8 flex-row">
                      <div class="image-text_1 flex-row justify-between">
                        <div class="image-wrapper_6 flex-col">
                          <img v-show="checkType!=='pro'"
                              class="thumbnail_21"
                              referrerpolicy="no-referrer"
                              src="../assets/v2/img/trans/pro.png"
                          />
                          <img v-show="checkType==='pro'"
                              class="thumbnail_21"
                              referrerpolicy="no-referrer"
                              src="../assets/v2/img/trans/pro-check.png"
                          />
                          <img v-show="checkType!=='convert'"
                              class="thumbnail_22"
                              referrerpolicy="no-referrer"
                              src="../assets/v2/img/trans/convert.png"
                          />
                          <img v-show="checkType==='convert'"
                              class="thumbnail_22"
                              referrerpolicy="no-referrer"
                              src="../assets/v2/img/trans/convert-check.png"
                          />

                        </div>
                        <span class="text-group_1">
                          <span :class="checkType==='pro'?'paragraph_1':''"
                                @click="()=>{checkType='pro';toPath('/trans-pro');}">人工翻译</span>
                          <br/>
                          <span :class="checkType==='convert'?'paragraph_1':''"
                                @click="()=>{checkType='convert';isShowNewUpload=true;isShowNewUploadList=false;toPath('/translate','convert')}">文档转换</span>
                        </span>
                      </div>
                      <img v-show="checkType==='pro'"
                          class="image_2"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/trans/check.png"
                      />
                      <img v-show="checkType==='convert'"
                          class="image_2" style="margin-top: 45px"
                          referrerpolicy="no-referrer"
                          src="../assets/v2/img/trans/check.png"
                      />
                    </div> -->
                  </div>
                  <!-- tab -->
                  <transition name="common-panel-fade">
                    <span v-show="checkType==='txt'" class="text-workbench-content">
                      <div
                          class="section_2 flex-row"
                          :class="{ 'history-open': isShowHistoryRecord }"
                          style="position: relative; width:1210px"
                      >
                        <div class="mobile-text-panel-label">原文</div>
                        <el-input
                            rows="23"
                            resize="none"
                            class="text_12"
                            type="textarea"
                            placeholder="请输入要翻译的文字……"
                            v-model="originaltext"
                            maxlength="5000"
                            show-word-limit
                            @focus="requireFeatureLogin"
                            @beforeinput.native="guardTextInputInteraction"
                            @paste.native="guardTextInputInteraction"
                        >
                        </el-input>
                        <FileTranslateEntry
                            v-if="isShowFileTranslate&&originaltext===''"
                            :isShowHistoryRecord="isShowHistoryRecord"
                            data-track-text="打开文档翻译入口"
                            aria-label="打开文档翻译入口"
                            @click.native="gotoPath('doc')"
                        />
                        <div v-if="originaltext!==''" class="group_4 flex-col justify-between" style="z-index:1">
                          <img
                               data-track-text="清空文本"
                               aria-label="清空文本"
                               @click="()=>{originaltext='';translatetext='';}"
                               class="thumbnail_24"
                               referrerpolicy="no-referrer"
                               src="../assets/v2/img/trans/clear.png"
                          />
                        </div>
                        <div class="mobile-text-panel-label mobile-text-panel-label-result">译文</div>
                        <div class="group_5 flex-col" :class="[!translatetext?'ash':'']"
                             style="white-space: pre-wrap;flex:1;"
                             data-track-text="复制译文"
                             aria-label="复制译文"
                             @click="copyText"
                             :title="translatetext!==undefined&&translatetext!==null&&translatetext!==''&&translatetext!=='翻译失败，请重试。'?'点击复制':''">
                          {{ translatetext || '译文......' }}
                        </div>
                        <!-- <AiHistory :userInfo="userInfo" @gotoPath="gotoPath" @getUserStatus="getUserStatus" /> -->
                        <TransTextHistory
                            v-show="isShowHistoryRecord"
                            :userInfo="userInfo"
                            :is-authenticated="isAuthenticated"
                            @gotoPath="gotoPath"
                            @getUserStatus="requireFeatureLogin"
                            @hideHistoryRecord="isShowHistoryRecord=false"/>
                      </div>
                      <!-- <div class="box_9 flex-row">
                        <div class="text-wrapper_3 flex-col">
                          <span class="text_14">1</span>
                        </div>
                        <div class="text-wrapper_4">
                          <span class="paragraph_3">第一步:选择源语种<br/></span>
                          <span class="paragraph_4">支持上百种语言<br/></span>
                        </div>
                        <img
                            class="image_3"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/other.png"
                        />
                        <div class="text-wrapper_5 flex-col">
                          <span class="text_15">2</span>
                        </div>
                        <div class="text-wrapper_6">
                          <span class="paragraph_5">第二步:选择目标语言<br/></span>
                          <span class="paragraph_6">支持多种语言互译<br/></span>
                        </div>
                        <img
                            class="image_4"
                            referrerpolicy="no-referrer"
                            src="../assets/v2/img/trans/other.png"
                        />
                        <div class="text-wrapper_7 flex-col">
                          <span class="text_16">3</span>
                        </div>
                        <div class="text-wrapper_8">
                          <span class="paragraph_7">第三步:输入译文<br/></span>
                          <span class="paragraph_8">实时出译文效果<br/></span>
                        </div>
                      </div> -->
                    </span>
                  </transition>
                  <transition name="common-panel-fade">
                    <span v-show="checkType==='doc'" style="border-top: 1px solid #F1F2F3;width: 1220px;">
                      <div
                          class="section_3 flex-row"
                          :class="{ 'doc-upload-list-active': !isShowNewUpload && isShowNewUploadList }">
                        <el-form
                            v-show="isShowNewUpload"
                            ref="uploadForm"
                            :rules="uploadrules"
                            :model="uploadform"
                            :inline="true"
                            class="demo-form-inline"
                            style="width: 1071px;height:429px">
                          <div @click="getUserStatus" data-track-text="上传文档" aria-label="上传文档" style="width: 1071px;height:429px">
                            <el-upload
                                style="width: 1071px;height:429px"
                                :class="elUploadMdjy"
                                :disabled="isUploadDisabled"
                                action
                                drag
                                multiple
                                ref="fileUpload"
                                class="new-upload-demo"
                                accept=".doc, .docx, .pdf, .txt, .xls, .xlsx, .ppt, .pptx, .xml, .html, .htm"
                                :limit="count"
                                :on-exceed="onExceed"
                                :file-list="fileList"
                                :auto-upload="autoUpload"
                                :before-upload="beforeUpload"
                                :http-request="()=>submitUploadTmpFiles('doc')"
                                :on-error="onError"
                                :on-success="onSuccess"
                                :on-remove="handleRemove">
                                <div class="block_3 flex-col">
                            <div class="image-wrapper_11 flex-row justify-between">
                              <img
                                  class="label_1"
                                  referrerpolicy="no-referrer"
                                  src="../assets/v2/img/trans/file-doc.png"
                              />
                              <img
                                  class="label_2"
                                  referrerpolicy="no-referrer"
                                  src="../assets/v2/img/trans/file-xls.png"
                              />
                              <img
                                  class="label_3"
                                  referrerpolicy="no-referrer"
                                  src="../assets/v2/img/trans/file-ppt.png"
                              />
                              <img
                                  class="label_4"
                                  referrerpolicy="no-referrer"
                                  src="../assets/v2/img/trans/file-xml.png"
                              />
                              <img
                                  class="label_5"
                                  referrerpolicy="no-referrer"
                                  src="../assets/v2/img/trans/file-txt.png"
                              />
                              <img
                                  class="label_6"
                                  referrerpolicy="no-referrer"
                                  src="../assets/v2/img/trans/file-pdf.png"
                              />
                            </div>
                            <div class="text-wrapper_4 flex-row">
                              <span class="text_15">doc/docx</span>
                              <span class="text_16">xls/xlsx</span>
                              <span class="text_17">ppt/pptx</span>
                              <span class="text_18">xml/html/htm</span>
                              <span class="text_19">txt</span>
                              <span class="text_20">pdf</span>
                            </div>
                            <div class="doc-file-type-grid">
                              <div class="doc-file-type-item">
                                <img src="../assets/v2/img/trans/file-doc.png" alt=""/>
                                <span>doc/docx</span>
                              </div>
                              <div class="doc-file-type-item">
                                <img src="../assets/v2/img/trans/file-xls.png" alt=""/>
                                <span>xls/xlsx</span>
                              </div>
                              <div class="doc-file-type-item">
                                <img src="../assets/v2/img/trans/file-ppt.png" alt=""/>
                                <span>ppt/pptx</span>
                              </div>
                              <div class="doc-file-type-item">
                                <img src="../assets/v2/img/trans/file-xml.png" alt=""/>
                                <span>xml/html/htm</span>
                              </div>
                              <div class="doc-file-type-item">
                                <img src="../assets/v2/img/trans/file-txt.png" alt=""/>
                                <span>txt</span>
                              </div>
                              <div class="doc-file-type-item">
                                <img src="../assets/v2/img/trans/file-pdf.png" alt=""/>
                                <span>pdf</span>
                              </div>
                            </div>
                            <div class="doc-upload-prompt">
                              <svg class="doc-upload-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 13v8"></path><path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"></path><path d="m8 17 4-4 4 4"></path></svg>
                              <span class="text_21">点击或拖拽上传</span>
                            </div>
                            <span class="text_22"
                            >支持doc/docx、xls/xlsx、ppt/pptx、xml/html/htm、txt、pdf多种格式文档,文件大小不超过50M</span
                            >
                          </div>
                            </el-upload>
                          </div>
                        </el-form>
                        <div class="box_11 flex-col doc-upload-progress" v-show="!isShowNewUpload&&!isShowNewUploadList">
                          <span class="text_15">已上传{{ processNum }}%</span>
                          <div class="group_4 flex-col justify-center">
                            <div class="block_6 flex-col" :style="{width: processNum+'%'}"></div>
                          </div>
                          <span class="text_16">正在上传中……</span>
                        </div>
                        <div class="box_11 flex-col doc-upload-list-shell" v-show="!isShowNewUpload&&isShowNewUploadList">
                        <div class="box_7 flex-col doc-upload-list-card">
                            <div class="text-wrapper_4 flex-col doc-upload-list-header">
                              <div class="text_16" role="row">
                                <div class="doc-upload-select-header" aria-hidden="true"></div>
                                <div role="columnheader" style="width: 320px">文档名称</div>
                                <div role="columnheader">字数</div>
                                <div role="columnheader">页数</div>
                                <div role="columnheader" style="width: 230px">翻译模型</div>
                                <div role="columnheader" style="width: 120px;margin-left:0">术语</div>
                                <!-- <div style="margin-left: 77px">行业领域</div> -->
                                <div role="columnheader" style="width: 140px; margin-left:0;text-align: right;">原文语言</div>
                                <div role="columnheader" aria-label="翻译方向" style="width: 20px;">→</div>
                                <div role="columnheader">目标语言</div>
                                <div role="columnheader">操作</div>
                              </div>
                            </div>
                            <div class="group_11 doc-upload-list" style="max-height: 410px">
                              <el-checkbox-group v-model="checkTmpList">
                                <div v-for="(item,index) in tmpFileData" :key="index+'TMP'" class="item doc-upload-list-item">
                                  <el-checkbox class="doc-upload-select" :label="item.id">{{ }}</el-checkbox>
                                    <div class="doc-upload-file" style="width: 330px">
                                      <img :src="typeImg[item.type]" alt=""/>
                                      {{ item.title }}
                                    </div>
                                    <div class="doc-upload-character">{{ item.character }}</div>
                                    <div class="doc-upload-page">{{ item.page }}</div>
                                    <div class="doc-upload-model" style="width: 230px; color: var(--primary);" data-track-text="选择翻译模型" aria-label="选择翻译模型" @click="showSelectModel(item)">{{
                                        getTransTypeName(item.model || item.domain)
                                      }}</div>
                                    <div class="doc-upload-terminology" style="width: 120px;text-align: center;">{{ item.terminology }}</div>
                                  <!-- <div class="borderNewSelect" style="margin-left:0px;width: 300px">
                                    <el-select  style="margin-left:0px;" :style="item.domain===''?'':'width: 100%!important;'"
                                                @change="()=>changeDomain(item)"
                                                v-model="item.domain"
                                                filterable
                                                placeholder="行业领域">
                                      <el-option
                                          v-for="it in domainOptionsAll"
                                          :key="it.value"
                                          :label="it.label"
                                          :value="it.value"
                                      ></el-option>
                                  </el-select>
                                  <el-select v-show="item.domain===''"  style="margin-left:5px"
                                            @change="()=>changeTerminology(item)"
                                            v-model="item.terminology"
                                            filterable
                                            placeholder="暂不使用术语">
                                        <el-option
                                            v-for="it in terminologyOptionsAll"
                                            :key="it.value"
                                            :label="it.label"
                                            :value="it.value"
                                        ></el-option>
                                    </el-select>
                                  </div> -->
                                    <div class="borderNewSelect2 doc-upload-language doc-upload-language-from" :class="item.visible ?'breathing':''"
                                         style="width: 130px;margin-left: 10px">
                                      <el-select
                                          v-model="item.from"
                                          filterable
                                          placeholder="原文语言"
                                      >
                                        <el-option-group
                                            v-for="group in lanuagesFrom"
                                            :key="group.value"
                                            :label="group.label"
                                        >
                                          <el-option
                                              v-for="(it,index)  in group.lanuagesFrom"
                                              :key="index"
                                              :label="it.label"
                                              :value="it.value"
                                              :disabled="(item.terminology!=='暂不使用术语' && it.value!=='zh' && it.value!=='en')||
                                              (item.domain!=='' && it.value!=='auto' && it.value!=='zh' && it.value!=='en')||
                                              ((item.domain==='novel'||item.domain==='wiki') && it.value!=='auto' && it.value!=='zh')"
                                          ></el-option>
                                        </el-option-group>
                                      </el-select>
                                    </div>
                                    <div class="doc-upload-swap"
                                        style="width: 20px;margin-left: 0;margin-left: -10px;height: 40px;">
                                      <img @click="zhuanhuanItem(item)"
                                           class="thumbnail_26"
                                           data-track-text="切换文件语种"
                                           aria-label="切换文件语种"
                                           style="margin: 0"
                                           referrerpolicy="no-referrer"
                                           src="../assets/v2/img/trans/transform.png"
                                      />
                                    </div>
                                    <div class="borderNewSelect2 doc-upload-language doc-upload-language-to" :class="item.visible ?'breathing':''"
                                         style="width: 130px;margin-left: -14px">
                                      <el-select
                                          v-model="item.to"
                                          filterable
                                          placeholder="目标语言"
                                      >
                                      <el-option-group
                                          v-for="group in lanuagesTo"
                                          :key="group.value"
                                          :label="group.label"
                                      >
                                        <el-option
                                            v-for="(it,index) in group.lanuagesFrom"
                                            :key="index"
                                            :label="it.label"
                                            :value="it.value"
                                            :disabled="(item.terminology!=='暂不使用术语' && it.value!=='zh' && it.value!=='en')||
                                            (item.domain!=='' && it.value!=='auto' && it.value!=='zh' && it.value!=='en')||
                                              ((item.domain==='novel'||item.domain==='wiki') && it.value!=='en')"
                                        ></el-option>
                                      </el-option-group>
                                    </el-select>
                                    </div>
                                    <div class="doc-upload-delete" style="margin-left: 16px;">
                                      <img @click="delTmp(item.id,'doc')" data-track-text="删除临时文档" aria-label="删除临时文档" src="../assets/v2/img/trans/close.png"
                                           alt=""/>
                                    </div>
                                </div>
                              </el-checkbox-group>
                            </div>
                            <el-empty description="极速上传文件翻译吧～" v-show="tmpFileData.length===0"></el-empty>
                            <div class="text-wrapper_8 flex-col doc-upload-submit" v-show="tmpFileData.length>0">
                              <span class="text_32" data-track-text="提交文档翻译" aria-label="提交文档翻译" @click="submitTmpTrans(false,'doc')">立即翻译</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </span>
                  </transition>
                  <transition name="common-panel-fade">
                    <span v-show="checkType==='AITranslate'">
                      <div class="section_2 flex-row">
                        <AiChat
                            ref="aiChat"
                            :aiModelList="aiModelList"
                            :userInfo="userInfo"
                            :is-authenticated="isAuthenticated"
                            @getUserStatus="requireFeatureLogin"
                            @gotoPath="gotoPath"
                        />
                      </div>
                    </span>
                  </transition>
                  <transition name="common-panel-fade">
                    <span v-show="checkType==='polish'">
                      <div class="section_2 flex-row">
                        <Polish
                            :aiModelList="aiModelList"
                            :userInfo="userInfo"
                            :is-authenticated="isAuthenticated"
                            @getUserStatus="requireFeatureLogin"
                        />
                      </div>
                    </span>
                  </transition>
                  <transition name="common-panel-fade">
                    <span v-if="checkType==='aiPPT'">
                      <div class="flex-row">
                        <AiPPT
                            :userInfo="userInfo"
                            :is-authenticated="isAuthenticated"
                            @getUserStatus="requireFeatureLogin"/>
                      </div>
                    </span>
                  </transition>
                  <transition name="common-panel-fade">
                    <span v-show="checkType==='img'" class="image-translation-panel">
                      <div class="section_5 flex-row image-upload-section">
                        <el-form
                            v-show="isShowNewUpload"
                            ref="uploadImgForm"
                            :rules="uploadrules"
                            :model="uploadImgForm"
                            :inline="true"
                            class="demo-form-inline">
                          <div @click="getUserStatus" data-track-text="上传图片" aria-label="上传图片">
                            <el-upload
                                :class="elUploadMdjy"
                                :disabled="isUploadDisabled"
                                action
                                drag
                                multiple
                                ref="fileUploadImg"
                                class="new-upload-demo"
                                accept=".jpg,.jpeg,.png"
                                :limit="count"
                                :on-exceed="onImgExceed"
                                :file-list="fileList"
                                :auto-upload="autoUpload"
                                :before-upload="beforeImgUpload"
                                :http-request="()=>submitUploadImgTmpFiles(imageTmpType)"
                                :on-error="onError"
                                :on-success="onSuccess"
                                :on-remove="handleRemove">
                                <div class="block_3 flex-col">
                                  <div class="image-upload-dropzone">
                                    <span class="text_21"
                                          style="margin-left: 0px;width: 175px">拖入/选择要上传的图片</span>
                                    <span class="text_22"
                                          style="margin-left: 0px;width: 224px">支持jpg/jpeg/png格式， 限<span
                                        class="image-upload-size-limit" style="color: var(--primary)">4M</span>以内</span>
                                    <span class="text_22"
                                          style="margin-left: 0px;width: 210px">图片尺寸: 30*30 ~ 4096*1365px</span>
                                  </div>
                                  <div class="image-upload-button"
                                      style="width: 140px;height: 41px;background: var(--primary-dark);border-radius: var(--radius-md);margin-top: 37px;display: flex;align-items: center;justify-content: center">
                                    <span
                                        style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;">选择图片</span>
                                  </div>
                                </div>
                            </el-upload>
                          </div>
                        </el-form>
                        <div class="box_11 flex-col" v-show="!isShowNewUpload&&!isShowNewUploadList">
                          <span class="text_15">已上传{{ processNum }}%</span>
                          <div class="group_4 flex-col justify-center">
                            <div class="block_6 flex-col" :style="{ width: processNum + '%' }"></div>
                          </div>
                          <span class="text_16">正在上传中……</span>
                        </div>
                        <div class="box_11 flex-col image-upload-list-shell" v-show="!isShowNewUpload&&isShowNewUploadList">
                        <div class="box_7 flex-col image-upload-list-card">
                            <div class="text-wrapper_4 flex-col image-upload-list-header">
                              <div class="text_16 image-upload-list-columns" role="row">
                                <div aria-hidden="true"></div>
                                <div role="columnheader">图片名称</div>
                                <div role="columnheader">页数</div>
                                <div role="columnheader">原文语言</div>
                                <div role="columnheader" aria-label="翻译方向">→</div>
                                <div role="columnheader">目标语言</div>
                                <div role="columnheader">操作</div>
                              </div>
                            </div>
                            <div class="group_11 image-upload-list">
                              <el-checkbox-group v-model="checkTmpList">
                                <div v-for="(item,index) in tmpFileData" :key="index+'TMP'" class="item image-upload-list-item">
                                  <el-checkbox :label="item.id">{{ }}</el-checkbox>
                                    <div class="image-upload-list-file">
                                      <img :src="typeImg[item.type]" alt=""/>
                                      {{ item.title }}
                                    </div>
                                    <div class="image-upload-list-page">{{ item.page }}</div>
                                    <div class="borderNewSelect image-upload-list-language">
                                      <el-select
                                          v-model="item.from"
                                          filterable
                                          placeholder="原文语言"
                                      >
                                      <el-option
                                          v-for="it in imgFromOptions"
                                          :key="it.value"
                                          :label="it.label"
                                          :value="it.value"
                                      ></el-option>
                                      </el-select>
                                    </div>
                                    <div class="image-upload-list-swap">
                                      <img @click="zhuanhuanImgItem(item)"
                                           class="thumbnail_26"
                                           data-track-text="切换图片文件语种"
                                           aria-label="切换图片文件语种"
                                           referrerpolicy="no-referrer"
                                           src="../assets/v2/img/trans/transform.png"
                                      />
                                    </div>
                                    <div class="borderNewSelect image-upload-list-language">
                                      <el-select
                                          v-model="item.to"
                                          filterable
                                          placeholder="目标语言"
                                      >
                                      <el-option
                                          v-for="it in imgToOptions"
                                          :key="it.value"
                                          :label="it.label"
                                          :value="it.value"
                                      ></el-option>
                                    </el-select>
                                    </div>
                                    <div class="image-upload-list-delete">
                                      <img @click="delTmp(item.id,imageTmpType)" data-track-text="删除临时图片" aria-label="删除临时图片" src="../assets/v2/img/trans/close.png"
                                           alt=""/>
                                    </div>
                                </div>
                              </el-checkbox-group>
                            </div>
                            <el-empty description="极速上传文件翻译吧～" v-show="tmpFileData.length===0"></el-empty>
                            <div class="text-wrapper_8 flex-col image-upload-list-submit" v-show="tmpFileData.length>0">
                              <span class="text_32" data-track-text="提交图片翻译" aria-label="提交图片翻译" @click="submitTmpTrans(false,imageTmpType)">立即翻译</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="image-upload-help"
                          style="height: 100px;font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #5F7186;line-height: 24px;margin-top: 25px;margin-left: 19px;">
                        <div>使用说明：</div>
                        <div>1. 图片翻译将图像识别与文本翻译合二为一，轻松实现图文翻译，支持实景贴合；</div>
                        <div>2. 文本识别：汉语、英语、法语、日语、韩语、葡萄牙语、德语、意大利语、西班牙语、俄语、丹麦语、荷兰语、马来语、瑞典语、印尼语、波兰语、罗马尼亚语、土耳其语、希腊语、</br>
                          匈牙利语20个语种；</div>
                    </div>
                    </span>
                  </transition>
                  <transition name="common-panel-fade">
                    <span v-show="checkType==='convert'" class="convert-workspace-panel">
                      <div class="convert-workspace-title"
                          style="font-size: 24px;font-family: Microsoft YaHei;font-weight: 400;color: #059669;width: 1082px;text-align: center;">
                        PDF转Word
                      </div>
                      <div class="section_6 flex-col convert-workspace-card" style="margin-top: 16px;align-items: center;">
                        <div class="convert-workspace-links"
                            style="width:1000px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: var(--primary);display: flex;justify-content: flex-end;margin-top: 21px;">
                          <div class="convert-workspace-link" style="display: flex;align-items: center;"
                               data-track-text="切换PDF转换列表"
                               aria-label="切换PDF转换列表"
                               @click="()=>{isShowNewUpload=!isShowNewUpload;isShowNewUploadList=!isShowNewUploadList;if(isShowNewUploadList) tmpList('convert')}">
                            <img class="convert-workspace-link-icon" src="../assets/v2/img/trans/convert-list.png" alt="" style="margin-right: 5px;"/>
                            {{
                              !isShowNewUpload && isShowNewUploadList ? '继续转换' : '转换列表'
                            }}>>
                          </div>
                          <div class="convert-workspace-link" style="display: flex;align-items: center;margin-left: 15px;"
                               data-track-text="查看转换记录"
                               aria-label="查看转换记录"
                               @click="toPath('/list-pro','convert')">
                            <img class="convert-workspace-link-icon" src="../assets/v2/img/trans/convert-list.png" alt="" style="margin-right: 5px;"/>
                            转换记录>>
                          </div>
                        </div>
                        <el-form
                            v-show="isShowNewUpload"
                            ref="uploadForm"
                            :rules="uploadrules"
                            :model="uploadform"
                            :inline="true"
                            class="demo-form-inline"
                            style="width: 1071px;">
                          <div @click="getUserStatus" data-track-text="上传PDF转换文件" aria-label="上传PDF转换文件" style="width: 1071px">
                            <el-upload
                                style="width: 1071px;height:335px"
                                :class="elUploadMdjy"
                                :disabled="isUploadDisabled"
                                action
                                drag
                                multiple
                                ref="fileConvertUpload"
                                class="new-upload-demo"
                                accept=".pdf"
                                :limit="count"
                                :on-exceed="onExceed"
                                :file-list="fileList"
                                :auto-upload="autoUpload"
                                :before-upload="beforeConvertUpload"
                                :http-request="()=>submitUploadConvertTmpFiles('convert')"
                                :on-error="onError"
                                :on-success="onSuccess"
                                :on-remove="handleRemove">
                                <div class="block_3 flex-col"
                                     style="display: flex;justify-content: center;align-items: center;margin-top: 18px;">
                                  <div class="convert-workspace-dropzone" style="width: 1000px;height: 191px;background: #F8FBFF;border: 1px dashed #9BB7D8;border-radius: 5px;
                                      display: flex;justify-content: center;align-items: center; flex-flow: column;">
                                    <span class="text_21"
                                          style="margin-left: 0px;width: 175px">拖入/选择要转换的文档</span>
                                  </div>
                                  <div class="convert-workspace-primary"
                                      style="width: 140px;height: 41px;background: #059669;border-radius: 6px;margin-top: 26px;display: flex;align-items: center;justify-content: center">
                                    <span
                                        style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;">确认转换</span>
                                  </div>
                                </div>
                            </el-upload>
                          </div>
                        </el-form>
                        <div class="box_11 flex-col" v-show="!isShowNewUpload&&!isShowNewUploadList">
                          <span class="text_15">已上传{{ processNum }}%</span>
                          <div class="group_4 flex-col justify-center">
                            <div class="block_6 flex-col" :style="{width: (processNum*(4.6))+'px'}"></div>
                          </div>
                          <span class="text_16">正在上传中……</span>
                        </div>
                        <div class="box_11 flex-col convert-upload-list-shell" v-show="!isShowNewUpload&&isShowNewUploadList">
                        <div class="box_7 flex-col convert-upload-list-card">
                            <div class="group_11 convert-upload-list">
                              <el-checkbox-group v-model="checkTmpList">
                                <div v-for="(item,index) in tmpFileData" :key="index+'TMP'" class="item convert-upload-list-item">
                                  <el-checkbox :label="item.id">{{ }}</el-checkbox>
                                    <div class="convert-upload-list-file">
                                      <img :src="typeImg[item.type]" alt=""/>
                                      {{ item.title }}
                                    </div>
                                    <div class="convert-workspace-file-type"
                                        style="width: 88px;height: 26px;border-radius: 4px;">常规文件</div>
                                    <div class="convert-upload-list-delete">
                                      <img @click="delTmp(item.id,'convert')" data-track-text="删除临时转换文件" aria-label="删除临时转换文件" src="../assets/v2/img/trans/close.png"
                                           alt=""/>
                                    </div>
                                </div>
                              </el-checkbox-group>
                            </div>
                            <el-empty description="极速上传文件转换吧～" v-show="tmpFileData.length===0"
                                      style="padding: 0px;"></el-empty>
                            <div class="text-wrapper_8 flex-row convert-workspace-submit convert-upload-list-submit" v-show="tmpFileData.length>0"
                                 data-track-text="提交PDF转换"
                                 aria-label="提交PDF转换"
                                 @click="submitTmpConvertTrans(false,'convert')">
                              <span class="text_32">立即转换</span>
                              <img src="../assets/v2/img/trans/right-jain-tou.png" alt=""/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="convert-workspace-help"
                          style="height: 100px;font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #5F7186;line-height: 24px;margin-top: 22px;margin-left: 19px;">
                        <div>使用说明：</div>
                        <div>1. 您可以转换30M以内或200页以内的文档;</div>
                        <div>2. 为保证扫描文档转换结果，请点击已上传文档中「常规文档」按钮进行替换;</div>
                        <div>3. 所有转换成功的文档，将至少保存10天；</div>
                    </div>
                    </span>
                  </transition>
                  <transition name="common-panel-fade">
                    <span v-show="checkType==='music'"
                          style="display: flex;align-items: center;justify-content: center;width: 1082px;">
                      <img src="../assets/v2/img/update.jpg" alt="">
                    </span>
                    <span v-if="false">
                      <div class="section_4 flex-row" style="margin-top: 20px;height: 377px">
                        <el-form
                            v-show="isShowNewUpload"
                            ref="uploadForm"
                            :rules="uploadrules"
                            :model="uploadform"
                            :inline="true"
                            class="demo-form-inline"
                            style="width: 1071px;height:377px">
                          <div @click="getUserStatus" data-track-text="上传文档" aria-label="上传文档" style="width: 1071px;height:377px">
                            <el-upload
                                style="width: 1071px;height:377px"
                                :class="elUploadMdjy"
                                :disabled="isUploadDisabled"
                                action
                                drag
                                multiple
                                ref="fileUpload"
                                class="new-upload-demo"
                                accept=".doc, .docx, .pdf, .txt, .xls, .xlsx, .ppt, .pptx, .xml, .html, .htm"
                                :limit="count"
                                :on-exceed="onExceed"
                                :file-list="fileList"
                                :auto-upload="autoUpload"
                                :before-upload="beforeUpload"
                                :http-request="()=>submitUploadTmpFiles('doc')"
                                :on-error="onError"
                                :on-success="onSuccess"
                                :on-remove="handleRemove">
                                <div class="block_3 flex-col"
                                     style="display: flex;justify-content: center;height:377px;align-items: center;">
                                  <div style="width: 1000px;height: 243px;background: #FFFFFF;border: 1px dashed rgba(211, 211, 211, 1);;border-radius: 5px;
                                      display: flex;justify-content: center;align-items: center; flex-flow: column;">
                                    <span class="text_21"
                                          style="margin-left: 0px;width: 175px">拖入/选择要上传的音频</span>
                                    <span class="text_22"
                                          style="margin-left: 0px;width: 288px">支持mp3、mp4、mov、m4v多种格式视频</span>
                                  </div>
                                  <div
                                      style="width: 140px;height: 41px;background: #10b981;border-radius: 6px;margin-top: 37px;display: flex;align-items: center;justify-content: center">
                                    <span
                                        style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;">选择音频</span>
                                  </div>
                                </div>
                            </el-upload>
                          </div>
                        </el-form>
                        <div class="box_11 flex-col" v-show="!isShowNewUpload&&!isShowNewUploadList">
                          <span class="text_15">已上传{{ processNum }}%</span>
                          <div class="group_4 flex-col justify-center">
                            <div class="block_6 flex-col" :style="{width: (processNum*(4.6))+'px'}"></div>
                          </div>
                          <span class="text_16">正在上传中……</span>
                        </div>
                        <div class="box_11 flex-col" v-show="!isShowNewUpload&&isShowNewUploadList">
                        <div class="box_7 flex-col">
                            <div class="text-wrapper_4 flex-col">
                              <div class="text_16">
                                <div>音频名称</div>
                                <div>文件大小</div>
                                <div>原文语言</div>
                                <div>目标语言</div>
                                <div>行业领域</div>
                                <div></div>
                              </div>
                            </div>
                            <div class="group_11">
                              <el-checkbox-group v-model="checkTmpList">
                                <div v-for="(item,index) in tmpFileData" :key="index+'TMP'" class="item">
                                  <el-checkbox :label="item.id">{{ }}</el-checkbox>
                                    <div>
                                      <img :src="typeImg[item.type]" alt=""/>
                                      {{ item.title }}
                                    </div>
                                    <div>{{ item.character }}</div>
                                    <div>{{ item.page }}</div>
                                    <div class="borderNewSelect">
                                      <el-select
                                          v-model="item.from"
                                          filterable
                                          placeholder="原文语言"
                                      >
                                        <el-option-group
                                            v-for="group in lanuagesFrom"
                                            :key="group.value"
                                            :label="group.label"
                                        >
                                          <el-option
                                              v-for="it in group.lanuagesFrom"
                                              :key="it.value"
                                              :label="it.label"
                                              :value="it.value"
                                              :disabled="(item.domain!=='' && item.value!=='auto' && item.value!=='zh' && item.value!=='en')||
                                              ((item.domain==='novel'||item.domain==='wiki') && item.value!=='auto' && item.value!=='zh')"
                                          ></el-option>
                                        </el-option-group>
                                      </el-select>
                                    </div>
                                    <div>
                                      <img @click="zhuanhuanItem(item)"
                                           class="thumbnail_26"
                                           data-track-text="切换多语种文件语种"
                                           aria-label="切换多语种文件语种"
                                           referrerpolicy="no-referrer"
                                           src="../assets/v2/img/trans/transform.png"
                                      />
                                    </div>
                                    <div class="borderNewSelect">
                                      <el-select
                                          v-model="item.to"
                                          filterable
                                          placeholder="目标语言"
                                      >
                                      <el-option-group
                                          v-for="group in lanuagesTo"
                                          :key="group.value"
                                          :label="group.label"
                                      >
                                        <el-option
                                            v-for="it in group.lanuagesFrom"
                                            :key="it.value"
                                            :label="it.label"
                                            :value="it.value"
                                            :disabled="(item.domain!=='' && item.value!=='auto' && item.value!=='zh' && item.value!=='en')||
                                              ((item.domain==='novel'||item.domain==='wiki') && item.value!=='en')"
                                        ></el-option>
                                      </el-option-group>
                                    </el-select>
                                    </div>
                                  <div class="borderNewSelect">
                                      <el-select
                                          @change="()=>changeDomain(item)"
                                          v-model="item.domain"
                                          filterable
                                          placeholder="行业领域"
                                      >
                                        <el-option
                                            v-for="it in domainOptionsAll"
                                            :key="it.value"
                                            :label="it.label"
                                            :value="it.value"
                                        ></el-option>
                                    </el-select>
                                    </div>
                                    <div>
                                      <img @click="delTmp(item.id,'doc')" data-track-text="删除临时文档" aria-label="删除临时文档" src="../assets/v2/img/trans/close.png"
                                           alt=""/>
                                    </div>
                                </div>
                              </el-checkbox-group>
                            </div>
                            <el-empty description="极速上传文件翻译吧～" v-show="tmpFileData.length===0"></el-empty>
                            <div class="text-wrapper_8 flex-col" v-show="tmpFileData.length>0">
                              <span class="text_32" data-track-text="提交音频翻译" aria-label="提交音频翻译" @click="submitTmpTrans(false,'doc')">立即翻译</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                          style="height: 100px;font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #4C8490;line-height: 24px;margin-top: 25px;margin-left: 19px;">
                        <div>使用说明：</div>
                        <div>1. 语音翻译API集成语音识别、文本翻译、语音合成三大技术能力</div>
                        <div>2. 可以将1分钟内的音频文件进行语音识别，转换成文本并翻译成目标语言，支持译文语音播报；</div>
                        <div>3. 支持中文、英语、日语、韩语、粤语、俄语、德语、法语、泰语、葡萄牙语、西班牙语、阿拉伯语。</div>
                    </div>
                    </span>
                  </transition>
                  <transition name="common-panel-fade">
                    <span v-show="checkType==='setting'" class="terminology-table-panel">
                      <div class="section_5 flex-row terminology-table-section">
                        <div class="box_11 flex-col terminology-list-shell">
                        <div class="box_7 flex-col terminology-list-card">
                            <div class="text-wrapper_4 flex-col terminology-list-header">
                              <div class="text_16">
                                <div class="terminology-col-cn" role="columnheader">中文名称</div>
                                <div class="terminology-col-en" role="columnheader">英文名称</div>
                              </div>
                            </div>
                            <div class="group_11 terminology-list">
                              <div class="item terminology-list-row"
                                   v-for="(item,index) in queryData" :key="index+'TMP'">
                                <div class="terminology-cell terminology-cell-cn"
                                     data-label="中文名称" :title="item.getOriginal()"
                                     data-track-text="复制术语中文名" aria-label="复制术语中文名"
                                     @click="copySettingText(item.getOriginal())">
                                  <span class="terminology-cell-value">{{ item.getOriginal() }}</span>
                                </div>
                                <div class="terminology-cell terminology-cell-en"
                                     data-label="英文名称" :title="item.getTarger()"
                                     data-track-text="复制术语英文名" aria-label="复制术语英文名"
                                     @click="copySettingText(item.getTarger())">
                                  <span class="terminology-cell-value">{{ item.getTarger() }}</span>
                                </div>
                              </div>
                              <el-empty description="暂无数据" v-show="queryData.length===0"></el-empty>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="terminology-pagination">
                        <el-pagination
                            class="terminology-pagination-control"
                            hide-on-single-page
                            background
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size=10
                            :pager-count="isSmallViewport ? 5 : 11"
                            layout="prev, pager, next"
                            :total="queryCount">
                        </el-pagination>
                    </div>
                    </span>
                  </transition>
                  <transition name="common-panel-fade">
                    <span v-show="checkType==='more'" class="more-translation-panel">
                      <div class="section_5 flex-row more-upload-section" style="margin-top: 20px;height: 377px">
                        <el-form
                            v-show="isShowNewUpload"
                            ref="uploadMoreForm"
                            :rules="uploadrules"
                            :model="{}"
                            :inline="true"
                            class="demo-form-inline"
                            style="width: 1071px;height:377px">
                          <div @click="getUserStatus" data-track-text="上传多语种文件" aria-label="上传多语种文件" style="width: 1071px;height:377px">
                            <el-upload
                                style="width: 1071px;height:377px"
                                :class="elUploadMdjy"
                                :disabled="isUploadDisabled"
                                action
                                drag
                                multiple
                                ref="fileUploadExcel"
                                class="new-upload-demo"
                                accept=".xls, .xlsx"
                                :limit="count"
                                :on-exceed="onExcelExceed"
                                :file-list="fileList"
                                :auto-upload="autoUpload"
                                :before-upload="beforeExcelUpload"
                                :http-request="()=>submitUploadMoreTmpFiles('more')"
                                :on-error="onError"
                                :on-success="onSuccess"
                                :on-remove="handleRemove">
                                <div class="block_3 flex-col"
                                     style="display: flex;justify-content: center;height:377px;align-items: center;">
                                  <div class="more-upload-dropzone" style="width: 100%;display: flex;justify-content: center;align-items: center; flex-flow: column;">
                                    <span class="text_21"
                                          style="margin-left: 0px;width: 175px">拖入选择要上传的文档</span>
                                    <span class="text_22" style="margin-left: 0px;width: 58px;cursor: pointer"
                                          data-track-text="下载多语种模板"
                                          aria-label="下载多语种模板"
                                          @click.stop="doSomething($event)">下载模板</span>
                                  </div>
                                  <div class="more-upload-button"
                                      style="width: 140px;height: 41px;background: #059669;border-radius: 6px;margin-top: 37px;display: flex;align-items: center;justify-content: center">
                                    <span
                                        style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;">上传模板</span>
                                  </div>
                                </div>
                            </el-upload>
                          </div>
                        </el-form>
                        <div class="box_11 flex-col" v-show="!isShowNewUpload&&!isShowNewUploadList">
                          <span class="text_15">已上传{{ processNum }}%</span>
                          <div class="group_4 flex-col justify-center">
                            <div class="block_6 flex-col" :style="{ width: processNum + '%' }"></div>
                          </div>
                          <span class="text_16">正在上传中……</span>
                        </div>
                        <div class="box_11 flex-col more-upload-list-shell" v-show="!isShowNewUpload&&isShowNewUploadList">
                        <div class="box_7 flex-col more-upload-list-card">
                            <div class="text-wrapper_4 flex-col more-upload-list-header">
                              <div class="text_16 more-upload-list-columns" role="row">
                                <div aria-hidden="true"></div>
                                <div role="columnheader">文档名称</div>
                                <div role="columnheader">字数</div>
                                <div role="columnheader">操作</div>
                              </div>
                            </div>
                            <div class="group_11 more-upload-list">
                              <el-checkbox-group v-model="checkTmpList">
                                <div v-for="(item,index) in tmpFileData" :key="index+'TMP'" class="item more-upload-list-item">
                                  <el-checkbox :label="item.id">{{ }}</el-checkbox>
                                    <div class="more-upload-list-file">
                                      <img src="../assets/v2/img/trans/more-execl.png" alt=""/>
                                      {{ item.title }}
                                    </div>
                                    <div class="more-upload-list-count">{{ item.character }}</div>
                                    <div class="more-upload-list-delete">
                                      <img @click="delTmp(item.id,'more')" data-track-text="删除临时多语种文件" aria-label="删除临时多语种文件" src="../assets/v2/img/trans/close.png"
                                           alt=""/>
                                    </div>
                                </div>
                              </el-checkbox-group>
                            </div>
                            <el-empty description="极速上传文件翻译吧～" v-show="tmpFileData.length===0"></el-empty>
                            <div class="text-wrapper_8 flex-col more-upload-list-submit" v-show="tmpFileData.length>0">
                              <span class="text_32" data-track-text="提交多语种翻译" aria-label="提交多语种翻译" @click="submitTmpTrans(false,'more')">立即翻译</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="more-upload-help"
                          style="height: 100px;font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #5F7186;line-height: 24px;margin-top: 25px;margin-left: 19px;">
                        <div>使用说明：</div>
                        <div>1. excel列数不超过10列，记录最多支持5000条；</div>
                        <div>2. excel模板中翻译方向列必须有值，内容为"原文-译文"，如：zh-en；</div>
                        <div>3.语种标识对照说明，中文-zh，英语-en，日语-ja，德语-de，俄语-ru，法语-fr，韩语-ko，葡萄牙语-pt，阿拉伯语-ar，印第安语-hi。</div>
                    </div>
                    </span>
                  </transition>
                  <transition name="common-panel-fade">
                    <span v-show="checkType==='video'"
                          style="display: flex;align-items: center;justify-content: center;width: 1082px;">
                      <img src="../assets/v2/img/update.jpg" alt="">
                    </span>
                  </transition>
                  <transition name="common-panel-fade">
                    <span v-show="checkType==='plugin'" class="plugin-translation-panel">
                      <div class="plugin-page-title">
                        微思翻译：全网精选的 网页翻译 插件
                      </div>
                      <div class="plugin-page-description">
                        一款免费的（原文/译文）直接翻译、双语对照、划词翻译的网页翻译插件，同时支持文档翻译（保留原文档排版），截图/图片翻译等；
                        提供世界领先的翻译能力，支持全球304种语言、近4万个翻译方向来对以上内容进行更准确的翻译。
                      </div>
                      <div class="plugin-browser-heading">
                        <span>请选择您使用的浏览器进行安装</span>
                        <span class="plugin-version-badge">{{ browserVersion }}</span>
                      </div>
                      <div class="plugin-install-entry">
                          <!--插件安装筛选-->
                         <BrowserInstall ref="browserInstall"/>
                      </div>
                      <div class="section_6 flex-col plugin-guide-section">
                        <InstallGuide />
                      </div>
                    </span>
                  </transition>
                </div>
              </div>
            </div>
            <div v-if="false" class="text-wrapper_9 flex-col">
            <span class="paragraph_9"
            >©&nbsp;2020&nbsp;北京容智科技发展有限公司&nbsp;<a href="https://beian.miit.gov.cn/#/Integrated/index"
                                                               style="color: white">京ICP备19036872号-3</a>
          &nbsp;All&nbsp;rights&nbsp;reserved.&nbsp;京公网安备&nbsp;
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011402010815" style="color: white">11011402010815</a><br/>
          联系邮箱：<a href="mailto:info@wiseivy.com.cn?subject=微思翻译咨询" style="color: white">info&#64;wiseivy.com.cn</a>&nbsp;联系电话：010-80755328</span
            >
            </div>
            <site-footer class="translate-site-footer" />
          </div>
        </div>
      </div>
      <floating-contact-tools
          class="translate-floating-tools"/>
    </div>
    <el-dialog :visible.sync="dialogTableVisible" :close-on-click-modal="false" class="payClass1">
      <el-table :data="gridData"
                :header-cell-style="{ 'background': 'rgb(244 248 251)','line-height': '30px','height': '23px',
                'text-align':'center','font-size':'14px','color':'#333333'}"
      >
        <el-table-column type="index" property="id" label="序号" width="50" align="center"></el-table-column>
        <el-table-column property="title" label="题名" show-overflow-tooltip></el-table-column>
        <el-table-column property="page" label="校验页数" width="100" align="center"></el-table-column>
        <el-table-column property="money" label="金额（元）" width="100" align="center"
                         v-if="isShowMoney"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <div style="float: left;
          font-size: 14px;
          font-family: Noto Sans S Chinese;
          font-weight: 400;
          color: #333333;
          width: 80%;">
          <div style="float: left">
            总计：<span>{{ pages }}</span>页
          </div>
          <div style="float: right" v-if="isShowMoney">
            <span style="padding-right: 15px;">总价：￥{{ NumFilter(orderMoney) }}</span>
            <span style="padding-right: 15px;">优惠：
              <span style="color:#e13f3f;">{{ NumberSub(orderMoney, moneys) }}</span>
            </span>
            <span style="padding-right: 15px;">实付：<span
                style="color:#e13f3f ;font-size: 18px;">￥{{ NumFilter(moneys) }}</span></span>
          </div>
        </div>
        <el-button v-if="!isShowFree" type="primary" data-track-text="确认翻译转换订单" aria-label="确认翻译转换订单" @click="submitPay" class="okTranslate"
                   :class="{'convert-order-action': gridData && gridData[0] && gridData[0].tmpType === 'convert'}">
          {{
            gridData && gridData[0] && gridData[0].tmpType && gridData[0].tmpType === 'convert' ? '确认转换' : '确认翻译'
          }}
        </el-button>
        <el-button v-if="isShowFree" type="primary" data-track-text="免费翻译转换订单" aria-label="免费翻译转换订单" @click="submitPay" class="okTranslate"
                   :class="{'convert-order-action': gridData && gridData[0] && gridData[0].tmpType === 'convert'}">
          {{
            gridData && gridData[0] && gridData[0].tmpType && gridData[0].tmpType === 'convert' ? '免费转换' : '免费翻译'
          }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
        :top="'40vh'"
        :show-close="false"
        :visible.sync="setMailVisible"
        width="280px"
        center>
        <span slot="title"
              style="font-size: 14px;font-family: Source Han Sans CN;font-weight: 400;color: #999999;">
           您暂未设置邮箱，请填写邮箱
        </span>
      <div style="width: 100%;display: flex;justify-content: center">
        <div
            style="width: 95px;height: 30px;background: #059669;border-radius: 5px;display: flex;align-items: center;justify-content: center;">
            <span style="cursor: pointer;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #FFFFFF;"
                  data-track-text="填写邮箱"
                  aria-label="填写邮箱"
                  @click="toSetMail">
              填写邮箱
            </span>
        </div>
      </div>
    </el-dialog>
    <SelectModel
        ref="selectModel"
        :userInfo="userInfo"
        :showLangV="showLangV"
        :domainOptionsAll="domainOptionsAll"
        :aiModelList="aiModelList"
        @selectModel="selectModel"/>
  </div>
</template>

<script>
import {authServiceClient, translateServiceClient} from "@/tools/api/service";
import {
  outRequest,
  userPowerRequest,
  userStatusRequest,
} from "@/tools/api/auth-api";
import lanuagefrom from "../../languagefrom.json";
import languageto from "../../languageto.json";
import {
  parentPowerRequest,
  submitRequest,
  transTextRequest,
  uploadCountRequest,
  uploadRequest,
  uploadTipRequest,
  checkRoamingRequest,
  getEmailRequest,
  uploadTmpRequest,
  delTmpRequest,
  transTmpRequest,
  selectTmpRequest,
  submitConvertRequest,
  getMedicineDictRequest,
  selectMedicineDictSpecRequest,
  aiSendRequest,
  aiSessionPageRequest,
  delAiSessionRequest,
  createAiSessionRequest,
  aiHistoryPageRequest,
} from "@/tools/api/translate-api";
import {Loading} from "element-ui";
import languages from "../../language.json";
import LangPanel from "../components/lang_panel/LangPanel";
import {TransTmpFile, UploadFile} from "../../api/translateService_pb";
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import AiEntry from "./modules/AiEntry";
import SelectModel from "./modules/SelectModel";
import AiChat from "./modules/AiChat";
import Polish from "./modules/Polish";
import AiPPT from "./modules/AiPPT";
import FileTranslateEntry from "./modules/FileTranslateEntry";
// import AiHistory from "./modules/AiHistory";
import TransTextHistory from "./modules/TransTextHistory";
import BrowserInstall from "./modules/BrowserInstall.vue";
import InstallGuide from "./modules/InstallGuide.vue";
import { flush, trackElementClick } from "../utils/track";
import SiteHeader from "@/components/home/SiteHeader.vue";
import SiteFooter from "@/components/home/SiteFooter.vue";
import FloatingContactTools from "@/components/home/FloatingContactTools.vue";
import createWorkspaceMenu from "@/config/workspaceMenu";

export default {
  name: "NewUpload",
  components: {
    lang_panel: LangPanel,
    AiEntry,
    SelectModel,
    AiChat,
    Polish,
    AiPPT,
    FileTranslateEntry,
    TransTextHistory,
    BrowserInstall,
    InstallGuide,
    SiteHeader,
    SiteFooter,
    FloatingContactTools
  },
  data() {
    return {
      mobileMenuOpen: false,
      isShowHistoryRecord: false,
      session: {},
      createAi: false,
      showAi: false,
      sessionList: [],
      message: "",
      aiMessageTemp: {},
      specData: [],
      specQuery: "",
      query: "",
      queryCount: 0,
      medicineInitialLoadStarted: false,
      checkType: "txt",
      showLangV: -1,
      email: "",
      showExcelUploadOk: true,
      showUploadOk: true,
      showSelect: false,
      hasH5: false,
      isSmallViewport: false,
      isShowTransPro: false,
      qrcodeUrl: "",
      showRoaming: false,
      groupUserInfos: [],
      userInfo: "",
      authPromptActive: false,
      authStateVersion: 0,
      userType: "",
      iframeState: false,
      showloginOut: false,
      showHeader: true,
      groupUserInfo: "",
      activeLabDoc: "",
      activeLabTxt: "",
      activeLabImg: "",
      activeLabExcel: "",
      languages2: "languages",
      languages: "languages",
      originalFrom: "自动检测",
      originalTo: "中文(简体)",
      originalImgFrom: "自动检测",
      originalImgTo: "中文(简体)",
      originaltext: "",
      translatetext: "",
      terminology: "暂不使用术语",
      domain: "",
      terminologyOptions: [
        {
          value: "",
          label: "暂不使用术语",
          from: "",
        },
        {
          value: "医学术语",
          label: "医学术语",
          from: "(中-英、英-中)",
        },
      ],
      terminologyOptionsAll: [
        {
          value: "",
          label: "暂不使用术语",
          from: "",
        },
        {
          value: "医学术语",
          label: "医学术语 (中-英、英-中)",
          from: "",
        },
      ],
      domainOptions: [
        {
          value: "",
          label: "通用领域",
          from: "200+语种互译",
        },
        {
          value: "it",
          label: "信息技术领域",
          from: "(中-英、英-中)",
        },
        {
          value: "finance",
          label: "金融财经领域",
          from: "(中-英、英-中)",
        },
        {
          value: "machinery",
          label: "机械制造领域",
          from: "(中-英、英-中)",
        },
        {
          value: "senimed",
          label: "生物医药领域",
          from: "(中-英、英-中)",
        },
        {
          value: "novel",
          label: "网络文学领域",
          from: "(中-英)",
        },
        {
          value: "academic",
          label: "学术论文领域",
          from: "(中-英、英-中)",
        },
        {
          value: "aerospace",
          label: "航空航天领域",
          from: "(中-英、英-中)",
        },
        {
          value: "wiki",
          label: "人文社科领域",
          from: "(中-英)",
        },
        {
          value: "news",
          label: "新闻资讯领域",
          from: "(中-英、英-中)",
        },
        {
          value: "law",
          label: "法律法规领域",
          from: "(中-英、英-中)",
        },
        {
          value: "contract",
          label: "合同领域",
          from: "(中-英、英-中)",
        },
      ],
      domainOptionsAll: [
        {
          value: "",
          label: "通用领域 200+语种互译",
          from: "",
        },
        {
          value: "it",
          label: "信息技术领域 (中-英、英-中)",
          from: "",
        },
        {
          value: "finance",
          label: "金融财经领域 (中-英、英-中)",
          from: "",
        },
        {
          value: "machinery",
          label: "机械制造领域 (中-英、英-中)",
          from: "",
        },
        {
          value: "senimed",
          label: "生物医药领域 (中-英、英-中)",
          from: "",
        },
        {
          value: "novel",
          label: "网络文学领域 (中-英)",
          from: "",
        },
        {
          value: "academic",
          label: "学术论文领域 (中-英、英-中)",
          from: "",
        },
        {
          value: "aerospace",
          label: "航空航天领域 (中-英、英-中)",
          from: "",
        },
        {
          value: "wiki",
          label: "人文社科领域 (中-英)",
          from: "",
        },
        {
          value: "news",
          label: "新闻资讯领域 (中-英、英-中)",
          from: "",
        },
        {
          value: "law",
          label: "法律法规领域 (中-英、英-中)",
          from: "",
        },
        {
          value: "contract",
          label: "合同领域 (中-英、英-中)",
          from: "",
        },
      ],
      domainOptionsNew: [
        {
          value: "",
          label: "混合模型",
          from: "支持200多种互译",
        },
        {
          value: "it",
          label: "信息技术",
          from: "中英互译",
        },
        {
          value: "finance",
          label: "金融财经",
          from: "中英互译",
        },
        {
          value: "machinery",
          label: "机械制造",
          from: "中英互译",
        },
        {
          value: "senimed",
          label: "生物医药",
          from: "中英互译",
        },
        {
          value: "novel",
          label: "网络文学",
          from: "(中-英)",
        },
        {
          value: "academic",
          label: "学术论文",
          from: "中英互译",
        },
        {
          value: "aerospace",
          label: "航空航天",
          from: "中英互译",
        },
        {
          value: "wiki",
          label: "人文社科",
          from: "(中-英)",
        },
        {
          value: "news",
          label: "新闻资讯",
          from: "中英互译",
        },
        {
          value: "law",
          label: "法律法规",
          from: "中英互译",
        },
        {
          value: "contract",
          label: "合同领域",
          from: "中英互译",
        },
      ],
      imgFromOptions: [
        {value: "auto", label: "自动检测"},
        {value: "zh", label: "中文"},
        {value: "en", label: "英语"},
        {value: "jp", label: "日语"},
        {value: "kor", label: "韩语"},
        {value: "fra", label: "法语"},
        {value: "spa", label: "西班牙语"},
        {value: "ru", label: "俄语"},
        {value: "pt", label: "葡萄牙语"},
        {value: "de", label: "德语"},
        {value: "it", label: "意大利语"},
        {value: "dan", label: "丹麦语"},
        {value: "nl", label: "荷兰语"},
        {value: "may", label: "马来语"},
        {value: "swe", label: "瑞典语"},
        {value: "id", label: "印尼语"},
        {value: "pl", label: "波兰语"},
        {value: "rom", label: "罗马尼亚语"},
        {value: "tr", label: "土耳其语"},
        {value: "el", label: "希腊语"},
        {value: "hu", label: "匈牙利语"},
      ],
      imgToOptions: [
        {value: "zh", label: "中文"},
        {value: "en", label: "英语"},
        {value: "jp", label: "日语"},
        {value: "kor", label: "韩语"},
        {value: "fra", label: "法语"},
        {value: "spa", label: "西班牙语"},
        {value: "ru", label: "俄语"},
        {value: "pt", label: "葡萄牙语"},
        {value: "de", label: "德语"},
        {value: "it", label: "意大利语"},
        {value: "dan", label: "丹麦语"},
        {value: "nl", label: "荷兰语"},
        {value: "may", label: "马来语"},
        {value: "swe", label: "瑞典语"},
        {value: "id", label: "印尼语"},
        {value: "pl", label: "波兰语"},
        {value: "rom", label: "罗马尼亚语"},
        {value: "tr", label: "土耳其语"},
        {value: "el", label: "希腊语"},
        {value: "hu", label: "匈牙利语"},
      ],
      showTxt: false,
      showDoc: true,
      showImg: false,
      showExcel: false,
      isShowMoney: false,
      isShowFree: false,
      orderMoney: 0,
      moneys: 0,
      pages: 0,
      idData: [],
      setMailVisible: false,
      dialogTableVisible: false,
      gridData: [],
      title: "",
      isShowInRoaming: false,
      selectOption: "selectOption",
      uploadCount: 0,
      limitCount: 20,
      count: 10,
      isUploadDisabled: true,
      isImgUploadDisabled: true,
      isExcelUploadDisabled: true,
      isShowupload: true,
      showupload: "",
      elUploadMdjy: "",
      showUpload1: true,
      showUpload2: true,
      timer: "",
      autoUpload: true,
      hasUpload: false,
      hasSendMail: false,
      lanuagesFrom: lanuagefrom,
      lanuagesTo: languageto,
      uploadform: {
        from: "auto",
        to: "zh",
      },
      uploadImgForm: {
        from: "auto",
        to: "zh",
      },
      imageOutputType: "image",
      imageCapabilityRequestId: 0,
      // 旧后台或配置读取失败时保留原来的图片翻译能力，不默认开放可编辑 Word。
      supportsImageTranslation: true,
      supportsEditableWord: false,
      uploadrules: {
        from: [{required: true, message: "请输入原文语言", trigger: "blur"}],
        to: [{required: true, message: "请输入目标语言", trigger: "blur"}],
      },
      fileList: [],
      uploadLoading: false,
      one: true,
      two: false,
      three: false,
      four: false,
      one2: true,
      two2: false,
      three2: false,
      lastTime: 0,
      userId: "",
      isRoamingTimer: undefined,
      isRoamingTimerOut: undefined,
      isShowNewUpload: true,
      isShowNewUploadList: false,
      tmpFileData: [],
      queryData: [],
      currentPage: 1,
      pageSize: 10,
      checkTmpList: [],
      processNum: 5,
      aiMessage: [],
      typeImg: {
        png: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAndJREFUOE+tlM9LVFEUx8/3vhlLQspIIoiKQHrvTamEtJH+gYoWBbUw5jlZSd7XtIsWhULugqKcN6KlvjeLCNq0MIhAilAoiwjC98Zc9A9YQpiWM3NPzODEjIw/SO/y3HM+93t+3APa5INN5hEc13/LQPVaYDCBwO+lZcq8r+P6IwzsJmZBwLhtGfG8HY7nP2XwfWIh8gahmJVAReU5xTPXY+Z03q8v5R/OMWqUYtY08VJG9R1LwGBAWsYVIobjBbeY0KIUd8dj5ru1VBfvHc//IS1zZxkw6aZjDL6kQI5gToR+z+/t6GieXw+0ItBJ+e2s6DyB+ojwGHNqv5SRuf8GLhW6h4SIsMol7LbIaCXYg2G/PqyJk1mhDcUv1P8sxFVKeT1KBgfTNQshngDRAhN9ti3j4oaACdd/RAK14YWq9uyWxU8QuNkZ1Z+tqjCv4tcebTF+ov5PqeqEF5wCUS9CmaOdrQ2zyeHJ4wp4rjKZRlEV/mJbZu2ysSHqTaWbBdMLIp5lohbbMr7nnR4OTddpWnaKsuq0bI+MFR9KptJ3WPExIjZkm7mvDNg7PKULoV5DiKusVCMRnaFq1SLPReYcL3gDwkSnpd8oVd3dzaLuQDBOQJO0jMJvQ8IN+qHCPaxlxgDqklHDXSq0w4ApFL1iUKu09CNE4OXNSw59PchabvIfMOmlU4q5iUCubRn3SgMcL3jCRGcZ0K9F9W8rTYLjBTPSMnYVU2Zm7rHbzNulAf39H8OZrds+gMSAtA4lVxursi4nvGAUUF1AqHwhKL6siBs0hmQNhcWx0mGlRqRlbC8q7FrPUK8O5Hk7Zt4tADcKWx6/6cC/r7E/JKn88XcAAAAASUVORK5CYII=",
        jpg: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAndJREFUOE+tlM9LVFEUx8/3vhlLQspIIoiKQHrvTamEtJH+gYoWBbUw5jlZSd7XtIsWhULugqKcN6KlvjeLCNq0MIhAilAoiwjC98Zc9A9YQpiWM3NPzODEjIw/SO/y3HM+93t+3APa5INN5hEc13/LQPVaYDCBwO+lZcq8r+P6IwzsJmZBwLhtGfG8HY7nP2XwfWIh8gahmJVAReU5xTPXY+Z03q8v5R/OMWqUYtY08VJG9R1LwGBAWsYVIobjBbeY0KIUd8dj5ru1VBfvHc//IS1zZxkw6aZjDL6kQI5gToR+z+/t6GieXw+0ItBJ+e2s6DyB+ojwGHNqv5SRuf8GLhW6h4SIsMol7LbIaCXYg2G/PqyJk1mhDcUv1P8sxFVKeT1KBgfTNQshngDRAhN9ti3j4oaACdd/RAK14YWq9uyWxU8QuNkZ1Z+tqjCv4tcebTF+ov5PqeqEF5wCUS9CmaOdrQ2zyeHJ4wp4rjKZRlEV/mJbZu2ysSHqTaWbBdMLIp5lohbbMr7nnR4OTddpWnaKsuq0bI+MFR9KptJ3WPExIjZkm7mvDNg7PKULoV5DiKusVCMRnaFq1SLPReYcL3gDwkSnpd8oVd3dzaLuQDBOQJO0jMJvQ8IN+qHCPaxlxgDqklHDXSq0w4ApFL1iUKu09CNE4OXNSw59PchabvIfMOmlU4q5iUCubRn3SgMcL3jCRGcZ0K9F9W8rTYLjBTPSMnYVU2Zm7rHbzNulAf39H8OZrds+gMSAtA4lVxursi4nvGAUUF1AqHwhKL6siBs0hmQNhcWx0mGlRqRlbC8q7FrPUK8O5Hk7Zt4tADcKWx6/6cC/r7E/JKn88XcAAAAASUVORK5CYII=",
        jpeg: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAndJREFUOE+tlM9LVFEUx8/3vhlLQspIIoiKQHrvTamEtJH+gYoWBbUw5jlZSd7XtIsWhULugqKcN6KlvjeLCNq0MIhAilAoiwjC98Zc9A9YQpiWM3NPzODEjIw/SO/y3HM+93t+3APa5INN5hEc13/LQPVaYDCBwO+lZcq8r+P6IwzsJmZBwLhtGfG8HY7nP2XwfWIh8gahmJVAReU5xTPXY+Z03q8v5R/OMWqUYtY08VJG9R1LwGBAWsYVIobjBbeY0KIUd8dj5ru1VBfvHc//IS1zZxkw6aZjDL6kQI5gToR+z+/t6GieXw+0ItBJ+e2s6DyB+ojwGHNqv5SRuf8GLhW6h4SIsMol7LbIaCXYg2G/PqyJk1mhDcUv1P8sxFVKeT1KBgfTNQshngDRAhN9ti3j4oaACdd/RAK14YWq9uyWxU8QuNkZ1Z+tqjCv4tcebTF+ov5PqeqEF5wCUS9CmaOdrQ2zyeHJ4wp4rjKZRlEV/mJbZu2ysSHqTaWbBdMLIp5lohbbMr7nnR4OTddpWnaKsuq0bI+MFR9KptJ3WPExIjZkm7mvDNg7PKULoV5DiKusVCMRnaFq1SLPReYcL3gDwkSnpd8oVd3dzaLuQDBOQJO0jMJvQ8IN+qHCPaxlxgDqklHDXSq0w4ApFL1iUKu09CNE4OXNSw59PchabvIfMOmlU4q5iUCubRn3SgMcL3jCRGcZ0K9F9W8rTYLjBTPSMnYVU2Zm7rHbzNulAf39H8OZrds+gMSAtA4lVxursi4nvGAUUF1AqHwhKL6siBs0hmQNhcWx0mGlRqRlbC8q7FrPUK8O5Hk7Zt4tADcKWx6/6cC/r7E/JKn88XcAAAAASUVORK5CYII=",
        pdf: "data:image/png;base64,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",
        xls: "data:image/png;base64,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",
        xlsx: "data:image/png;base64,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",
        ppt: "data:image/png;base64,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",
        pptx: "data:image/png;base64,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",
        xml: "data:image/png;base64,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",
        html: "data:image/png;base64,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",
        htm: "data:image/png;base64,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",
        txt: "data:image/png;base64,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",
        doc: "data:image/png;base64,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",
        docx: "data:image/png;base64,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",
      },
      aiModelList: [],
      aiMode: {},
      isShowFileTranslate: true,
      currentMenu: {},
      menuList: createWorkspaceMenu(),
    };
  },
  mounted() {
    // AI 助手入口的拖动状态不参与渲染，避免 pointermove 触发整页更新。
    this.aiLauncherDragRuntime = null;
    this.aiLauncherMoveFrame = null;
    this.aiLauncherIgnoreClickUntil = 0;
    this.aiLauncherTrackIgnoreTimer = null;
    this.handleViewportResize();
    window.addEventListener("resize", this.handleViewportResize);
    window.addEventListener("focus", this.refreshImageCapabilitiesIfNeeded);
    //是移动端返回true,否则false
    this.hasH5 = this.isMobile();
    if (this.hasH5) {
      this.activeLabDoc = "is-active";
      this.elUploadMdjy = "new-el-upload-mdjy-h5";
      this.showupload = "new-el-upload-manjy-h5";
    } else {
      this.activeLabDoc = "active-lab";
      this.showupload = "new-el-upload-manjy";
      this.elUploadMdjy = "new-el-upload-mdjy";
    }
    // 注册 VueClipboard 插件
    Vue.use(VueClipboard);
    this.checkUploadCountByDay1();
    // 添加全局点击事件监听器
    document.addEventListener("click", this.handleClickOutside);
    // 在组件挂载后，初始滚动到底部
    this.scrollToBottom();
    this.getUserInfo();
    this.$nextTick(() => this.initializeMedicineDict());
  },
  watch: {
    aiMessage: {
      handler() {
        this.scrollToBottom();
      },
      deep: true, // 深度监听，以便能够检测到数组内部对象的变化
    },
    authStateVersion() {
      this.getUploadTip();
      this.$nextTick(() => this.initializeMedicineDict());
    },
    domain(val) {
      if (val !== "") {
        this.terminology = "暂不使用术语";
        if (val === "novel" || val === "wiki") {
          this.uploadform.from = "zh";
          this.uploadform.to = "en";
          return;
        }
        if (
            (this.uploadform.from === "zh" || this.uploadform.from === "en") &&
            (this.uploadform.to === "zh" || this.uploadform.to === "en")
        ) {
          return;
        }
        this.uploadform.from = "zh";
        this.uploadform.to = "en";
      }
    },
    terminology(val) {
      if (val !== "暂不使用术语") {
        if (
            (this.uploadform.from === "zh" || this.uploadform.from === "en") &&
            (this.uploadform.to === "zh" || this.uploadform.to === "en")
        ) {
          this.domain = "";
          return;
        }
        this.uploadform.from = "zh";
        this.uploadform.to = "en";
        this.domain = "";
      }
    },
    dialogTableVisible(val) {
      if (!val) {
        this.$refs.fileUpload.clearFiles();
        this.$refs.fileUpload.$data.uploadFiles = [];
        this.idData = [];
        this.gridData = [];
        this.orderMoney = 0;
        this.moneys = 0;
        this.pages = 0;
        this.isUploadDisabled = false;
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy";
        }
        this.$router.push("/list");
      } else {
        let request = parentPowerRequest;
        request.setMoney(this.moneys);
        const TOKEN_KEY = "token";
        translateServiceClient
            .checkParentPower(request, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              this.isShowMoney = res.getShowmoney();
              if (this.isShowMoney && this.moneys === 0) {
                this.isShowFree = true;
              }
            })
            .catch((err) => {
              this.isShowMoney = true;
            });
      }
    },
    originaltext(val) {
      if (val && !this.hasAuthenticatedContext()) {
        this.originaltext = "";
        this.translatetext = "";
        this.isShowFileTranslate = true;
        this.requireFeatureLogin();
        return;
      }
      if (val) {
        this.isShowFileTranslate = false;
      }
      if (this.lastTime === 0) {
        this.lastTime = setTimeout(() => {
          this.submitTransText();
        }, 2000);
      } else {
        clearTimeout(this.lastTime);
        this.lastTime = setTimeout(() => {
          this.submitTransText();
        }, 2000);
      }
    },
    "uploadform.from": function (val) {
      this.originalFrom = this.getChineseName(val);
      if (this.lastTime === 0) {
        this.lastTime = setTimeout(() => {
          this.submitTransText();
        }, 2000);
      } else {
        clearTimeout(this.lastTime);
        this.lastTime = setTimeout(() => {
          this.submitTransText();
        }, 2000);
      }
    },
    "uploadform.to": function (val) {
      this.originalTo = this.getChineseName(val);
      if (this.lastTime === 0) {
        this.lastTime = setTimeout(() => {
          this.submitTransText();
        }, 2000);
      } else {
        clearTimeout(this.lastTime);
        this.lastTime = setTimeout(() => {
          this.submitTransText();
        }, 2000);
      }
    },
    "uploadImgForm.from": function (val) {
      this.originalImgFrom = this.getImgChineseName(val);
    },
    "uploadImgForm.to": function (val) {
      this.originalImgTo = this.getImgChineseName(val);
    },
    "$route.query.type"(val) {
      this.checkType = val;
      if (val === "img") {
        this.getUploadTip();
      }
      this.currentMenu = {
        url: "/translate",
        type: this.checkType,
      };
      if (val !== "setting") {
        this.cancelAiLauncherDrag();
        this.medicineInitialLoadStarted = false;
      }
      this.$nextTick(() => {
        this.initializeMedicineDict();
        if (val === "setting") {
          this.keepAiLauncherInViewport();
        }
      });
    },
  },
  updated() {
    this.scrollToBottom();
  },
  beforeDestroy() {
    this.cancelAiLauncherDrag();
    window.removeEventListener("resize", this.handleViewportResize);
    window.removeEventListener("focus", this.refreshImageCapabilitiesIfNeeded);
    clearInterval(this.timer);
    clearInterval(this.isRoamingTimer);
    clearTimeout(this.isRoamingTimerOut);
    // 移除全局点击事件监听器
    document.removeEventListener("click", this.handleClickOutside);
  },
  beforeCreate() {
    const that = this;
    window.addEventListener("message", function (e) {
      if (e.data.data === "params") {
        that.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
      }
      if (e.data.data === "register") {
        that.openTry();
      }
      if (e.data.data === "close") {
        layer.closeAll();
      }
      if (e.data.data === "topHidden") {
        that.showHeader = false;
      }
      if (e.data.data === "topNotHidden") {
        that.showHeader = true;
      }
    });
    const TOKEN_KEY = "token";
    authServiceClient
        .getUserStatus(userStatusRequest, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!res.getStatus()) {
            localStorage.removeItem("token");
            localStorage.removeItem("auth-context");
            this.userInfo = "";
            this.groupUserInfo = "";
            this.showRoaming = false;
            this.authStateVersion += 1;
            return;
          }
          const user = localStorage.getItem("auth-context");
          if (!user) {
            this.authStateVersion += 1;
            return;
          }
          const userJson = JSON.parse(user);
          const Base64 = require("js-base64").Base64;
          userJson.forEach((item) => {
            if (item.type === "Person" || item.type === "Child") {
              let realName = "";
              if (item.realName !== "" && item.realName !== undefined) {
                realName = Base64.decode(item.realName);
              } else {
                realName = item.name;
              }
              if (item.type === "Person") {
                this.userType = "0";
              }
              if (item.type === "Child") {
                this.userType = "1";
              }
              this.userInfo = realName;
              this.userId = item.name;
              if (!item.isRoaming) {
                let roaming = localStorage.getItem(this.userId);
                if (!roaming || roaming !== "1") {
                  this.showRoaming = true;
                } else {
                  this.showRoaming = false;
                  this.userType = "2";
                }
              } else {
                this.userType = "2";
              }
              if (this.groupUserInfo === "") {
                this.groupUserInfo = "机构登录";
              }
              this.showloginOut = true;
            }
            if (item.type === "Group") {
              this.groupUserInfos.push(item);
              let realName = "";
              if (item.realName !== "" && item.realName !== undefined) {
                realName = Base64.decode(item.realName);
              } else {
                realName = item.name;
              }
              this.groupUserInfo = realName;
              this.url = process.env.VUE_APP_WEB_LOGIN_URL;
            }
          });
          this.authStateVersion += 1;
        })
        .catch((err) => {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          this.userInfo = "";
          this.showRoaming = false;
          this.authStateVersion += 1;
        });
  },
  created() {
    let query = this.$route.query;
    this.checkType = query?.type || "txt";
    this.currentMenu = {
      url: "/translate",
      type: this.checkType,
    };
    this.getUploadTip();
  },
  computed: {
    mobileActiveMenuItem() {
      const groups = Object.values(this.menuList || {});
      for (const group of groups) {
        const activeItem = (group.list || []).find((item) =>
            item.type ? item.type === this.checkType : item.url === this.currentMenu.url
        );
        if (activeItem) {
          return activeItem;
        }
      }
      return {
        icon: "el-icon-menu",
        text: "选择工具",
      };
    },
    isAuthenticated() {
      // 机构身份变化也会触发重算，但功能使用仅接受个人或子账号登录。
      void this.authStateVersion;
      void this.userInfo;
      void this.groupUserInfo;
      void this.groupUserInfos.length;
      return this.hasAuthenticatedContext();
    },
    imageTmpType() {
      return this.imageOutputType === "word" ? "img-word" : "img";
    },
    // 获取浏览器插件版本号
    browserVersion() {
      if (this.$refs.browserInstall && this.$refs.browserInstall.currentVersion) {
        return this.$refs.browserInstall.currentVersion;
      }
      return '最新版本：v1.0.0 2026-01-11';
    }
  },
  methods: {
    handleViewportResize() {
      this.isSmallViewport = window.matchMedia("(max-width: 768px)").matches;
      this.hasH5 = this.isSmallViewport;
      this.activeLabDoc = this.hasH5 ? "is-active" : "active-lab";
      this.elUploadMdjy = this.hasH5 ? "new-el-upload-mdjy-h5" : "new-el-upload-mdjy";
      this.showupload = this.hasH5 ? "new-el-upload-manjy-h5" : "new-el-upload-manjy";
      this.keepAiLauncherInViewport();
    },
    handleAiLauncherClick(event) {
      const isKeyboardActivation = event && event.type === "keydown";
      if (!isKeyboardActivation && Date.now() < (this.aiLauncherIgnoreClickUntil || 0)) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        return;
      }
      this.aiSessionPage(event);
    },
    startAiLauncherDrag(event) {
      if (!event || event.isPrimary === false) {
        return;
      }
      if (event.button !== 0) {
        return;
      }
      const launcher = this.$refs.terminologyAiLauncher;
      if (!launcher) {
        return;
      }

      this.cancelAiLauncherDrag();
      this.aiLauncherIgnoreClickUntil = 0;

      const rect = launcher.getBoundingClientRect();
      this.aiLauncherDragRuntime = {
        pointerId: event.pointerId,
        startClientX: event.clientX,
        startClientY: event.clientY,
        startLeft: rect.left,
        startTop: rect.top,
        width: rect.width,
        height: rect.height,
        moved: false,
        pending: null,
      };
      launcher.classList.add("is-dragging");
      try {
        launcher.setPointerCapture(event.pointerId);
      } catch (error) {
        // 某些旧浏览器不支持指针捕获，window 监听仍可完成拖动。
      }
      window.addEventListener("pointermove", this.moveAiLauncher, {passive: false});
      window.addEventListener("pointerup", this.finishAiLauncherDrag, true);
      window.addEventListener("pointercancel", this.finishAiLauncherDrag, true);
      window.addEventListener("blur", this.cancelAiLauncherDrag);
    },
    getAiLauncherClampedPosition(left, top, width, height) {
      const edgeInset = 8;
      const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
      const viewportHeight = document.documentElement.clientHeight || window.innerHeight;
      const maxLeft = Math.max(edgeInset, viewportWidth - width - edgeInset);
      let maxTop = viewportHeight - height - edgeInset;
      if (window.matchMedia("(max-width: 768px)").matches) {
        const mobileNav = document.querySelector(".mobile-bottom-nav");
        const mobileNavRect = mobileNav ? mobileNav.getBoundingClientRect() : null;
        maxTop = mobileNavRect && mobileNavRect.height && mobileNavRect.top > 0
            ? mobileNavRect.top - height - edgeInset
            : viewportHeight - height - 72;
      }
      maxTop = Math.max(edgeInset, maxTop);
      return {
        left: Math.min(Math.max(left, edgeInset), maxLeft),
        top: Math.min(Math.max(top, edgeInset), maxTop),
      };
    },
    moveAiLauncher(event) {
      const runtime = this.aiLauncherDragRuntime;
      if (!runtime || event.pointerId !== runtime.pointerId) {
        return;
      }
      const deltaX = event.clientX - runtime.startClientX;
      const deltaY = event.clientY - runtime.startClientY;
      if (!runtime.moved) {
        if ((deltaX * deltaX) + (deltaY * deltaY) < 36) {
          return;
        }
        runtime.moved = true;
        const launcher = this.$refs.terminologyAiLauncher;
        if (launcher) {
          launcher.setAttribute("data-track-ignore", "");
        }
      }
      runtime.pending = this.getAiLauncherClampedPosition(
          runtime.startLeft + deltaX,
          runtime.startTop + deltaY,
          runtime.width,
          runtime.height
      );
      if (!this.aiLauncherMoveFrame) {
        this.aiLauncherMoveFrame = window.requestAnimationFrame(() => {
          this.aiLauncherMoveFrame = null;
          this.applyAiLauncherPendingPosition();
        });
      }
      if (event.cancelable) {
        event.preventDefault();
      }
    },
    applyAiLauncherPendingPosition() {
      const runtime = this.aiLauncherDragRuntime;
      const launcher = this.$refs.terminologyAiLauncher;
      if (!runtime || !runtime.pending || !launcher) {
        return;
      }
      launcher.style.left = `${runtime.pending.left}px`;
      launcher.style.top = `${runtime.pending.top}px`;
      launcher.style.right = "auto";
      launcher.style.bottom = "auto";
    },
    finishAiLauncherDrag(event) {
      const runtime = this.aiLauncherDragRuntime;
      if (!runtime) {
        return;
      }
      if (event && event.pointerId !== undefined && event.pointerId !== runtime.pointerId) {
        return;
      }

      if (event && event.type === "pointerup") {
        const deltaX = event.clientX - runtime.startClientX;
        const deltaY = event.clientY - runtime.startClientY;
        if (runtime.moved || (deltaX * deltaX) + (deltaY * deltaY) >= 36) {
          runtime.moved = true;
          runtime.pending = this.getAiLauncherClampedPosition(
              runtime.startLeft + deltaX,
              runtime.startTop + deltaY,
              runtime.width,
              runtime.height
          );
          const currentLauncher = this.$refs.terminologyAiLauncher;
          if (currentLauncher) {
            currentLauncher.setAttribute("data-track-ignore", "");
          }
        }
      }

      if (this.aiLauncherMoveFrame) {
        window.cancelAnimationFrame(this.aiLauncherMoveFrame);
        this.aiLauncherMoveFrame = null;
      }
      this.applyAiLauncherPendingPosition();

      const launcher = this.$refs.terminologyAiLauncher;
      if (launcher) {
        launcher.classList.remove("is-dragging");
        try {
          if (launcher.hasPointerCapture(runtime.pointerId)) {
            launcher.releasePointerCapture(runtime.pointerId);
          }
        } catch (error) {
          // 忽略已经失效的指针捕获。
        }
      }

      window.removeEventListener("pointermove", this.moveAiLauncher);
      window.removeEventListener("pointerup", this.finishAiLauncherDrag, true);
      window.removeEventListener("pointercancel", this.finishAiLauncherDrag, true);
      window.removeEventListener("blur", this.cancelAiLauncherDrag);
      this.aiLauncherDragRuntime = null;

      if (runtime.moved) {
        this.aiLauncherIgnoreClickUntil = Date.now() + 350;
        this.aiLauncherTrackIgnoreTimer = window.setTimeout(() => {
          const currentLauncher = this.$refs.terminologyAiLauncher;
          if (currentLauncher) {
            currentLauncher.removeAttribute("data-track-ignore");
          }
          this.aiLauncherTrackIgnoreTimer = null;
        }, 350);
        if (event && event.cancelable) {
          event.preventDefault();
        }
      }
    },
    cancelAiLauncherDrag() {
      if (this.aiLauncherMoveFrame) {
        window.cancelAnimationFrame(this.aiLauncherMoveFrame);
        this.aiLauncherMoveFrame = null;
      }
      const runtime = this.aiLauncherDragRuntime;
      const launcher = this.$refs.terminologyAiLauncher;
      if (launcher) {
        launcher.classList.remove("is-dragging");
        if (runtime) {
          try {
            if (launcher.hasPointerCapture(runtime.pointerId)) {
              launcher.releasePointerCapture(runtime.pointerId);
            }
          } catch (error) {
            // 忽略已经失效的指针捕获。
          }
        }
      }
      window.removeEventListener("pointermove", this.moveAiLauncher);
      window.removeEventListener("pointerup", this.finishAiLauncherDrag, true);
      window.removeEventListener("pointercancel", this.finishAiLauncherDrag, true);
      window.removeEventListener("blur", this.cancelAiLauncherDrag);
      this.aiLauncherDragRuntime = null;
      if (this.aiLauncherTrackIgnoreTimer) {
        window.clearTimeout(this.aiLauncherTrackIgnoreTimer);
        this.aiLauncherTrackIgnoreTimer = null;
      }
      if (launcher) {
        launcher.removeAttribute("data-track-ignore");
      }
      this.aiLauncherIgnoreClickUntil = 0;
    },
    keepAiLauncherInViewport() {
      const launcher = this.$refs.terminologyAiLauncher;
      if (!launcher || !launcher.style.left || this.aiLauncherDragRuntime) {
        return;
      }
      const rect = launcher.getBoundingClientRect();
      if (!rect.width || !rect.height) {
        return;
      }
      const position = this.getAiLauncherClampedPosition(
          rect.left,
          rect.top,
          rect.width,
          rect.height
      );
      launcher.style.left = `${position.left}px`;
      launcher.style.top = `${position.top}px`;
      launcher.style.right = "auto";
      launcher.style.bottom = "auto";
    },
    selectMobileTool(item) {
      this.mobileMenuOpen = false;
      this.gotoUrl(item);
    },
    hasAuthenticatedContext() {
      const token = localStorage.getItem("token");
      const authContext = localStorage.getItem("auth-context");
      if (!token || !authContext) {
        return false;
      }
      try {
        const identities = JSON.parse(authContext);
        return Array.isArray(identities) && identities.some((item) =>
          item && ["Person", "Child"].includes(item.type)
        );
      } catch (error) {
        return false;
      }
    },
    openFeatureLogin() {
      if (this.hasH5 || window.matchMedia("(max-width: 768px)").matches) {
        this.$authPopup.close();
        this.authPromptActive = false;
        if (this.$route.path !== "/h5/login") {
          this.$router.push("/h5/login");
        }
        return null;
      }
      if (this.authPromptActive) {
        return null;
      }
      this.authPromptActive = true;
      const index = this.$authPopup.open(process.env.VUE_APP_WEB_LOGIN_URL || "/login", {
        onClose: () => {
          this.authPromptActive = false;
          this.authStateVersion += 1;
        },
      });
      if (index === null) {
        this.authPromptActive = false;
      }
      return index;
    },
    requireFeatureLogin(event) {
      if (this.hasAuthenticatedContext()) {
        return true;
      }
      if (event && typeof event.preventDefault === "function") {
        event.preventDefault();
      }
      this.openFeatureLogin();
      return false;
    },
    guardTextInputInteraction(event) {
      if (this.requireFeatureLogin(event)) {
        return true;
      }
      if (event && typeof event.stopPropagation === "function") {
        event.stopPropagation();
      }
      if (event && typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
      return false;
    },
    prepareMedicineDict(event) {
      if (!this.requireFeatureLogin(event)) {
        return false;
      }
      if (!this.specData.length) {
        this.selectMedicineDictSpec();
      }
      if (!this.queryData.length) {
        this.handleCurrentChange(1);
      }
      return true;
    },
    handleSettingVisibility(visible) {
      if (visible) {
        this.prepareMedicineDict();
      }
    },
    initializeMedicineDict() {
      if (
          this.checkType !== "setting" ||
          this.authStateVersion === 0 ||
          !this.hasAuthenticatedContext() ||
          this.medicineInitialLoadStarted
      ) {
        return false;
      }
      this.medicineInitialLoadStarted = true;
      if (!this.specData.length) {
        this.selectMedicineDictSpec();
      }
      if (!this.queryData.length) {
        this.handleCurrentChange(1);
      }
      return true;
    },
    hasPersonalAccountContext() {
      const authContext = localStorage.getItem("auth-context");
      if (!authContext) {
        return false;
      }
      try {
        const users = JSON.parse(authContext);
        return Array.isArray(users) && users.some((item) =>
          item && (item.type === "Person" || item.type === "Child")
        );
      } catch (error) {
        return false;
      }
    },
    changeImageOutputType() {
      this.checkTmpList = [];
      this.tmpFileData = [];
      if (this.isShowNewUploadList) {
        this.tmpList(this.imageTmpType);
      }
    },
    refreshAuthCapabilities() {
      this.authStateVersion += 1;
    },
    refreshImageCapabilitiesIfNeeded() {
      if (this.checkType === "img") {
        this.getUploadTip();
      }
    },
    showSelectModel(item) {
      if (!this.requireFeatureLogin()) {
        return;
      }
      console.log(22, item);
      this.$refs.selectModel.showSelectMode(item);
    },
    selectModel(domain, model, rowData) {
      this.tmpFileData.forEach((item) => {
        if (item.id === rowData.id) {
          item.model = model.value || "";
          item.domain = model.value ? "" : domain.value || "";
        }
      });
      console.log(111, domain, model, this.tmpFileData);
    },
    getTransTypeName(val) {
      const optionAll = [...this.domainOptionsNew, ...this.aiModelList];
      return optionAll.find((item) => item.value === val)?.label;
    },
    changeMode(aiMode) {
      this.aiMode = aiMode;
    },
    selectDomainAndMode(domain, mode) {
      this.aiMode = mode;
      this.domain = domain.value;
    },
    getIcon(item, isActive) {
      return {
        background:
            "url(" +
            require(`../assets/chat/menu/${item.icon}${
                isActive ? "-active" : ""
            }.png`) +
            ") center center / contain no-repeat",
      };
    },
    gotoPage(type) {
      if (type === "text") {
        this.toPath("/translate", "txt");
      } else if (type === "doc") {
        this.toPath("/translate", "doc");
      } else if (type === "ai") {
        this.toPath("/translate", "AITranslate");
      } else if (type === "lange") {
        this.toPath("/translate", "more");
      } else if (type === "img") {
        this.toPath("/translate", "img");
      } else if (type === "polish") {
        this.toPath("/translate", "polish");
      } else if (type === "aiPPT") {
        this.toPath("/translate", "aiPPT");
      } else if (type === "rag") {
        this.toPath("/rag");
      } else if (type === "pro") {
        this.toPath("/trans-pro");
      }
    },
    gotoPath(type) {
      this.checkType = type;
      this.isShowNewUpload = true;
      this.isShowNewUploadList = false;
      this.toPath("/translate", type);
    },
	    getUserInfo() {
	      this.$http.get("/chatApi/app/user/model").then((res) => {
        this.aiModelList = res.data.data;
        this.aiModelList = this.aiModelList?.map((item) => {
          return {
            ...item,
            value: item.model,
            label: item.name,
          };
	        });
	      });
	    },
	    toggleHistoryRecord() {
	      if (!this.requireFeatureLogin()) {
	        return;
	      }
	      trackElementClick({
	        trackId: "translate.history.toggle",
	        text: this.isShowHistoryRecord ? "收起翻译历史" : "展开翻译历史",
	        type: "button",
	        tag: "span",
	        componentName: "NewUploadHistory",
	      }, {
	        trackSource: "method_history_toggle",
	      });
	      flush();
	      this.isShowHistoryRecord = !this.isShowHistoryRecord;
	    },
	    trackMenuBeforeNavigate(item) {
      if (!item) return;
      trackElementClick({
        eventName: "translate_menu_click",
        trackId: `translate.menu.${item.type || item.url}`,
        text: item.text,
        type: "menu",
        tag: "div",
        componentName: "NewUploadSideMenu",
        businessId: item.type || item.url,
      }, {
        trackSource: "method_menu_before_navigate",
      });
      flush();
    },
    gotoUrl(item) {
      trackElementClick({
        eventName: "translate_menu_click",
        trackId: `translate.menu.${item.type || item.url}`,
        text: item.text,
        type: "menu",
        tag: "div",
        componentName: "NewUploadSideMenu",
        businessId: item.type || item.url,
      }, {
        trackSource: "method_gotoUrl",
      });
      if (item.url !== "/trans-pro") {
        flush(true);
      }
      this.currentMenu = item;
      if (item.type) {
        this.checkType = item.type;
        this.isShowNewUpload = true;
        this.isShowNewUploadList = false;
        this.toPath(item.url, item.type);
        if (item.type === "AITranslate") {
          this.$refs.aiChat.setDefaultChat();
        }
      } else {
        this.toPath(item.url);
      }
    },
    changeUploadform(val, key) {
      this.uploadform[key] = val;
      this.showLangV = -1;
    },
    aiSend() {
      if (this.session === "") {
        return;
      }
      let request = aiSendRequest;
      request.setSessionId(this.session.getSessionId());
      request.setContent(this.message);
      this.aiMessageTemp = {content: this.message, messageType: "question"};
      this.message = "";
      const TOKEN_KEY = "token";
      translateServiceClient
          .aiSend(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            this.getHistory(this.session, true);
            this.scrollToBottom();
            return;
          })
          .catch((err) => {
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
              } else {
                this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
              }
              return;
            }
            this.$message.error("服务暂不可用，请稍后再试");
          });
    },
    scrollToBottom() {
      this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
    },
    getHistory(session, flag) {
      this.session = session;
      let request = aiHistoryPageRequest;
      request.setSessionId(session.getSessionId());
      request.setSize(10);
      request.setIsUseCursor(false);
      if (flag && this.aiMessage.length > 0) {
        request.setSize(2);
      } else {
        this.aiMessage = [];
      }
      const TOKEN_KEY = "token";
      translateServiceClient
          .aiHistoryPage(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            this.aiMessage.push(...res.getMessageList());
            this.aiMessageTemp = {};
            if (this.aiMessage) {
              this.createAi = true;
              this.scrollToBottom();
              return;
            }
            this.$message.error("获取失败，请稍后再试");
          })
          .catch((err) => {
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
              } else {
                this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
              }
              return;
            }
            this.$message.error("服务暂不可用，请稍后再试");
          });
    },
    callBack() {
      this.aiSessionPage();
      this.createAi = false;
    },
    createAiSession() {
      let request = createAiSessionRequest;
      const TOKEN_KEY = "token";
      translateServiceClient
          .createAiSession(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            let session = res.getSession();
            if (session) {
              this.session = session;
              this.createAi = true;
              return;
            }
            this.$message.error("删除失败，请稍后再试");
          })
          .catch((err) => {
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
              } else {
                this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
              }
              return;
            }
            this.$message.error("服务暂不可用，请稍后再试");
          });
    },
    delAiSession(sessionId) {
      console.log(sessionId);
      let request = delAiSessionRequest;
      request.setSessionId(sessionId);
      const TOKEN_KEY = "token";
      translateServiceClient
          .delAiSession(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (res.getStatus()) {
              this.aiSessionPage();
              return;
            }
            this.$message.error("删除失败，请稍后再试");
          })
          .catch((err) => {
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
              } else {
                this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
              }
              return;
            }
            this.$message.error("服务暂不可用，请稍后再试");
          });
    },
    aiSessionPage(event) {
      if (!this.requireFeatureLogin(event)) {
        return;
      }
      this.showAi = true;
      let request = aiSessionPageRequest;
      request.setPageSize(20);
      request.setPageNum(1);
      const TOKEN_KEY = "token";
      translateServiceClient
          .aiSessionPage(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            this.sessionList = res.getSessionList();
            this.showAi = true;
          })
          .catch((err) => {
            if (err.code === 5) {
              this.showAi = false;
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
              } else {
                this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
              }
              return;
            }
            this.$message.error("服务暂不可用，请稍后再试");
          });
    },
    selectMedicineDictSpec() {
      if (!this.requireFeatureLogin()) {
        return;
      }
      const request = selectMedicineDictSpecRequest;
      const TOKEN_KEY = "token";
      translateServiceClient
          .selectMedicineDictSpec(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            this.specData = res.getSpecList();
          })
          .catch((err) => {
            this.medicineInitialLoadStarted = false;
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
              } else {
                this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
              }
              return;
            }
            this.$message.error("获取临床专业名词失败，请稍后再试");
          });
    },
    handleCurrentChange(val) {
      if (!this.requireFeatureLogin()) {
        return;
      }
      this.currentPage = val;
      const request = getMedicineDictRequest;
      request.setCurrentPage(this.currentPage);
      request.setPageSize(this.pageSize);
      request.setSpec(this.specQuery);
      request.setWord(this.query);
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: "获取医学术语中...",
        customClass: "loadClass",
      });
      const TOKEN_KEY = "token";
      translateServiceClient
          .getMedicineDict(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            loadingInstance.close();
            this.queryCount = res.getCount();
            this.queryData = res.getMedicineDictList();
          })
          .catch((err) => {
            this.medicineInitialLoadStarted = false;
            if (err.code === 5) {
              loadingInstance.close();
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
              } else {
                this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
              }
              return;
            }
            this.$message.error("获取医学术语失败，请稍后再试");
            loadingInstance.close();
          });
    },
    copyText() {
      if (
          this.translatetext !== undefined &&
          this.translatetext !== null &&
          this.translatetext !== "" &&
          this.translatetext !== "翻译失败，请重试。"
      ) {
        // 调用 $copyText 方法复制文本
        this.$copyText(this.translatetext);
        this.$message.success("复制成功");
      }
    },
    copySettingText(txt) {
      this.$copyText(txt);
      this.$message.success("复制成功");
    },
    openNewMessage() {
      this.$alert("服务升级中，敬请期待", "产品升级", {
        confirmButtonText: "确定",
      });
    },
    changeDomain(item) {
      if (item.domain !== "") {
        item.terminology = "暂不使用术语";
        if (item.domain === "novel" || item.domain === "wiki") {
          item.from = "zh";
          item.to = "en";
          return;
        }
        if (
            (item.from === "zh" || item.from === "en") &&
            (item.to === "zh" || item.to === "en")
        ) {
          return;
        }
        item.from = "zh";
        item.to = "en";
      }
    },
    changeTerminologyName(val) {
      if (val) {
        this.terminology = "医学术语";
      } else {
        this.terminology = "";
      }
    },
    changeTerminology(item) {
      if (item.terminology !== "暂不使用术语") {
        if (
            (item.from === "zh" || item.from === "en") &&
            (item.to === "zh" || item.to === "en")
        ) {
          item.domain = "";
          return;
        }
        item.from = "zh";
        item.to = "en";
        item.domain = "";
      }
    },
    tmpList(tmpType) {
      const TOKEN_KEY = "token";
      let request = selectTmpRequest;
      request.setTmpType(tmpType);
      translateServiceClient
          .selectTmp(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (res.getStatus()) {
              console.log(888, res.getUploadtmpfilesList());
              this.tmpFileData = [];
              res.getUploadtmpfilesList().forEach((item) => {
                const data = {};
                data["id"] = item.getId();
                data["type"] = item.getType();
                data["title"] = item.getTitle();
                data["page"] = item.getPage();
                data["character"] = item.getCharacter();
                data["from"] = item.getFrom();
                data["to"] = item.getTo();
                data["domain"] = item.getDomain();
                data["model"] = item.getModel();
                console.log(1111, item.getTransType());
                data["terminology"] =
                    item.getTerminology() === undefined ||
                    item.getTerminology() === null ||
                    item.getTerminology() === ""
                        ? "暂不使用术语"
                        : item.getTerminology();
                this.tmpFileData.push(data);
              });
              console.log(999, this.tmpFileData);
              return;
            }
            this.$message.error(res.getMessage());
          })
          .catch((err) => {
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            } else {
              this.$message.error("查询失败，请稍后再试！");
            }
          });
    },
    handleClickOutside(event) {
      // 判断点击事件的目标是否在指定的 div 元素之内
      if (
          !this.$refs.divToExclude1?.contains(event.target) &&
          !this.$refs.divToExclude2?.contains(event.target) &&
          !this.$refs.divToExclude3?.contains(event.target) &&
          !this.$refs.divToExclude4?.contains(event.target) &&
          !this.$refs.divToExclude5?.contains(event.target) &&
          !this.$refs.divToExclude6?.contains(event.target) &&
          !this.$refs.divToExclude7?.contains(event.target) &&
          !this.$refs.divToExclude8?.contains(event.target) &&
          !this.$refs.divToExclude9?.contains(event.target) &&
          !this.$refs.divToExclude10?.contains(event.target) &&
          !this.$refs.divToExclude11?.contains(event.target) &&
          !this.$refs.divToExclude12?.contains(event.target) &&
          !this.$refs.divToExclude13?.contains(event.target) &&
          !this.$refs.divToExclude14?.contains(event.target) &&
          !this.$refs.divToExclude15?.contains(event.target) &&
          !this.$refs.divToExclude16?.contains(event.target)
      ) {
        this.showLangV = -1;
      }
    },
    getDomainName(value) {
      for (let i = 0; i < this.domainOptions.length; i++) {
        const item = this.domainOptions[i];
        if (item.value === value) {
          return item.label;
        }
      }
      return "通用领域"; // 如果没有找到匹配的选项，则返回默认值
    },
    trackLanguageSelector(v) {
      const trackTextMap = {
        1: "选择文本翻译源语种",
        2: "选择文本翻译目标语种",
        3: "选择文档翻译源语种",
        4: "选择文档翻译目标语种",
        11: "选择图片翻译源语种",
        12: "选择图片翻译目标语种",
      };
      const trackText = trackTextMap[v];
      if (trackText) {
        trackElementClick({
          trackId: `translate.language.${v}`,
          text: trackText,
          type: "language_selector",
          eventName: "language_selector_click",
        });
      }
    },
    showLang(v) {
      this.trackLanguageSelector(v);
      console.log(222, v);
      if (this.showLangV === v) {
        this.showLangV = -1;
        return;
      }
      this.showLangV = v;
      console.log(333, this.showLangV);
    },
    setHasSendMail(val) {
      if (val) {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "获取邮箱中...",
          customClass: "loadClass",
        });
        const TOKEN_KEY = "token";
        translateServiceClient
            .getEmail(getEmailRequest, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              let mail = res.getMail();
              if (mail === null || mail === "" || mail === undefined) {
                this.hasSendMail = false;
                this.setMailVisible = true;
                loadingInstance.close();
                return;
              }
              this.email = mail;
              this.hasSendMail = val;
              loadingInstance.close();
            })
            .catch((err) => {
              if (err.code === 5) {
                this.email = "";
                this.hasSendMail = false;
                loadingInstance.close();
                localStorage.removeItem("token");
                localStorage.removeItem("auth-context");
                if (this.hasH5) {
                  this.$router.push("/h5/login");
                } else {
                  this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                }
                return;
              }
              this.email = "";
              this.hasSendMail = false;
              this.$message.error("获取邮箱失败，请稍后再试");
              loadingInstance.close();
            });
        return;
      }
      this.email = "";
      this.hasSendMail = val;
    },
    toSetMail() {
      window.open("https://user.wesitrans.com/account", "_blank");
    },
    getPower() {
      let request = parentPowerRequest;
      request.setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient
          .checkParentPower(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            this.isShowMoney = res.getShowmoney();
            if (this.isShowMoney && this.moneys === 0) {
              this.isShowFree = true;
            }
          })
          .catch((err) => {
            this.isShowMoney = true;
          });
    },
    isMobile() {
      return window.matchMedia('(max-width: 768px)').matches;
    },
    toCenter() {
      window.open("https://user.wesitrans.com/account", "_blank");
    },
    getQrcode() {
      this.qrcodeUrl = "http://common.wesitrans.com/common/roaming/qrcode";
      this.isRoamingTimer = setInterval(this.roamingEvent, 1000);
      this.isRoamingTimerOut = setTimeout(this.clearTime, 60000);
    },
    clearTime() {
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    roamingEvent() {
      if (this.userId && localStorage.getItem(this.userId) !== "1") {
        let request = checkRoamingRequest;
        request.setUserId(this.userId);
        const TOKEN_KEY = "token";
        translateServiceClient
            .checkRoaming(request, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              localStorage.setItem(this.userId, res.getMessage());
              if (res.getMessage() === "1") {
                window.location.reload();
              }
            })
            .catch((err) => {
            });
      }
    },
    removeQrcode() {
      this.qrcodeUrl = "";
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    openRecommendations() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: "login-demo-class",
          area: ["948px", "625px"],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ["/recommendations", "no"],
        });
      } else {
        layer.open({
          area: ["948px", "625px"],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ["/recommendations", "no"],
        });
      }
    },
    logOut(val) {
      if (val === "toCenter") {
        window.open("http://user.wesitrans.com", "_blank");
        return;
      }
      if (val === "toAccount") {
        window.open("https://user.wesitrans.com/account", "_blank");
        return;
      }
      if (val === "toOrder") {
        window.open("https://user.wesitrans.com/order", "_blank");
        return;
      }
      if (val === "txtTrans") {
        this.checkType = "txt";
        return;
      }
      if (val === "docTrans") {
        this.checkType = "doc";
        return;
      }
      if (val === "mediaTrans") {
        this.openNewMessage();
        return;
      }
      if (val === "imgTrans") {
        this.checkType = "img";
        return;
      }
      if (val === "xlsTrans") {
        this.checkType = "more";
        return;
      }
      if (val === "musicTrans") {
        this.openNewMessage();
        return;
      }

      if (val === "toTransPro") {
        this.toPath("/trans-pro");
        return;
      }
      if (val === "standLangSet") {
        this.toPath("/translate", "setting");
        return;
      }
      if (val === "convertDoc") {
        this.checkType = "convert";
        return;
      }
      if (val === "imgTrans") {
        this.openNewMessage();
        return;
      }
      if (val === "mySelfDoc") {
        this.toPath("/list-pro");
        return;
      }
      if (val === "webTranslate") {
        this.checkType = "plugin";
        return;
      }
      if (val === "smartClassify") {
        this.toPath("/smart-classify");
        return;
      }
      let request = outRequest;
      if (val === undefined) {
        request.setName(this.userInfo);
      } else {
        request.setName(val);
      }
      const TOKEN_KEY = "token";
      authServiceClient
          .logOut(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            window.location.reload();
            this.$router.push("/index");
          })
          .catch((err) => {
            localStorage.removeItem("token");
            localStorage.removeItem("auth-context");
            this.userInfo = "";
            this.showRoaming = false;
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          });
    },
    showIframe(url) {
      return this.$authPopup.open(url)
    },
    toPath(url, type) {
      if (url === "/translate" && type === "txt") {
        this.isShowFileTranslate = true;
      }
      if (url === "/trans-pro") {
        trackElementClick({
          eventName: "translate_menu_click",
          trackId: "translate.menu./trans-pro",
          text: "人工翻译",
          type: "menu",
          tag: "div",
          componentName: "NewUploadSideMenu",
          businessId: "/trans-pro",
        }, {
          trackSource: "method_toPath_hard_nav",
        });
        flush();
        window.setTimeout(() => {
          window.open("/trans-pro/index", "_self");
        }, 700);
        return;
      }
      if (url === "/list" || url === "/list-pro") {
        const TOKEN_KEY = "token";
        authServiceClient
            .getUserStatus(userStatusRequest, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              if (!res.getStatus()) {
                localStorage.removeItem("token");
                localStorage.removeItem("auth-context");
                if (this.hasH5) {
                  this.$router.push("/h5/login");
                  return;
                }
                this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                return;
              }
              if (
                  localStorage.getItem("auth-context") &&
                  localStorage.getItem("token")
              ) {
                authServiceClient
                    .checkUserPower(userPowerRequest, {
                      [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                    })
                    .then((res) => {
                      if (res.getStatus()) {
                        if (type) {
                          this.$router.push({
                            path: url,
                            query: {type: type},
                          });
                          return;
                        }
                        this.$router.push(url);
                        return;
                      }
                      if (this.hasPersonalAccountContext()) {
                        this.$message({
                          center: true,
                          type: "error",
                          showClose: true,
                          duration: 3000,
                          message: res.getMessage(),
                        });
                      }
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                    })
                    .catch((err) => {
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                    });
              }
            })
            .catch((err) => {
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            });
        return;
      }
      if (type) {
        this.$router.push({
          path: url,
          query: {type: type},
        });
        return;
      }
      this.$router.push(url);
    },
    getUploadTip() {
      const TOKEN_KEY = "token";
      const requestId = ++this.imageCapabilityRequestId;
      translateServiceClient
          .getUploadTip(uploadTipRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (requestId !== this.imageCapabilityRequestId) {
              return;
            }
            this.applyImageOutputCapabilities(res);
            this.isShowTransPro = res.getIsTransPro();
            this.isShowInRoaming = res.getIsRoaming();
            this.title = res.getMessage();
            if (
                this.title === undefined ||
                this.title === null ||
                this.title === ""
            ) {
              this.selectOption = "selectOption1";
            }
          })
          .catch((err) => {
            if (requestId !== this.imageCapabilityRequestId) {
              return;
            }
            this.resetImageOutputCapabilities();
            this.isShowInRoaming = false;
            this.isShowTransPro = true;
            this.title = "";
            this.selectOption = "selectOption1";
          });
    },
    resetImageOutputCapabilities() {
      const outputChanged = this.imageOutputType !== "image";
      this.supportsImageTranslation = true;
      this.supportsEditableWord = false;
      if (outputChanged) {
        this.imageOutputType = "image";
        this.changeImageOutputType();
      }
    },
    applyImageOutputCapabilities(response) {
      const hasCapability = response
          && typeof response.getHasImageOutputCapability === "function"
          && response.getHasImageOutputCapability();
      if (!hasCapability) {
        this.resetImageOutputCapabilities();
        return;
      }

      const supportsImage = typeof response.getSupportsImageTranslation === "function"
          && response.getSupportsImageTranslation();
      const supportsWord = typeof response.getSupportsEditableWord === "function"
          && response.getSupportsEditableWord();
      const previousOutputType = this.imageOutputType;

      // A malformed empty capability set must not remove the legacy image workflow.
      this.supportsImageTranslation = supportsImage || !supportsWord;
      this.supportsEditableWord = supportsWord;
      if (this.imageOutputType === "word" && !this.supportsEditableWord) {
        this.imageOutputType = "image";
      } else if (this.imageOutputType === "image" && !this.supportsImageTranslation) {
        this.imageOutputType = "word";
      }
      if (this.imageOutputType !== previousOutputType) {
        this.changeImageOutputType();
      }
    },
    submitTransText() {
      if (!this.originaltext) {
        return;
      }
      const text = this.originaltext.replace(/\s+/g, "");
      if (text === null || text === "") {
        return;
      }
      if (!this.requireFeatureLogin()) {
        return;
      }
      if (this.uploadform.from === this.uploadform.to) {
        this.translatetext = this.originaltext;
        return;
      }
      this.translatetext = "正在翻译...";
      let request = transTextRequest;
      request.setText(this.originaltext);
      request.setFrom(this.uploadform.from);
      request.setTo(this.uploadform.to);
      const TOKEN_KEY = "token";
      translateServiceClient
          .submitTransText(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            this.translatetext = res.getText();
          })
          .catch((err) => {
            this.translatetext = "翻译失败，请重试。";
          });
    },
    leaveTab(activeName, oldActiveName) {
    },
    getUserStatus() {
      if (!this.hasAuthenticatedContext()) {
        this.openFeatureLogin();
        return false;
      }
      const that = this;
      const TOKEN_KEY = "token";
      authServiceClient
          .getUserStatus(userStatusRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (!res.getStatus()) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              this.authStateVersion += 1;
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return false;
              }
              this.openFeatureLogin();
              return false;
            }
            const user = localStorage.getItem("auth-context");
            if (!user) {
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return false;
              }
              this.openFeatureLogin();
              return false;
            }
            return that.checkUserPower();
          })
          .catch((err) => {
            localStorage.removeItem("token");
            localStorage.removeItem("auth-context");
            this.authStateVersion += 1;
            if (this.hasH5) {
              this.$router.push("/h5/login");
              return false;
            }
            this.openFeatureLogin();
            return false;
          });
    },
    checkUserPower() {
      const that = this;
      const TOKEN_KEY = "token";
      authServiceClient
          .checkUserPower(userPowerRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (!res.getStatus()) {
              if (that.hasPersonalAccountContext()) {
                that.$message({
                  center: true,
                  type: "error",
                  showClose: true,
                  duration: 3000,
                  message: res.getMessage(),
                });
              }
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return false;
              }
              this.openFeatureLogin();
              return false;
            }
            return that.checkUploadCountByDay();
          })
          .catch((err) => {
            if (this.hasH5) {
              this.$router.push("/h5/login");
              return false;
            }
            this.openFeatureLogin();
            return false;
          });
    },
    checkUploadCountByDay() {
      const that = this;
      const TOKEN_KEY = "token";
      translateServiceClient
          .checkUploadCountByDay(uploadCountRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (!res.getIsoverstepcount()) {
              if (that.hasPersonalAccountContext()) {
                that.$message.error(res.getMessage());
              }
              that.isUploadDisabled = true;
              if (that.hasH5) {
                that.elUploadMdjy = "new-el-upload-mdjy-none-h5";
              } else {
                that.elUploadMdjy = "new-el-upload-mdjy-none";
              }
              that.limitCount = res.getLimitcount();
              return false;
            }
            that.isUploadDisabled = false;
            if (that.hasH5) {
              that.elUploadMdjy = "new-el-upload-mdjy-h5";
            } else {
              that.elUploadMdjy = "new-el-upload-mdjy";
            }
            if (res.getCount() >= 10) {
              that.count = 10;
              that.limitCount = res.getLimitcount();
              return true;
            }
            that.count = res.getCount();
            that.limitCount = res.getLimitcount();
            return true;
          })
          .catch((err) => {
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return false;
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            } else {
              that.$message.error("文件上传遇到了问题，请稍后再试！");
            }
            return false;
          });
    },
    checkUploadCountByDay1() {
      const that = this;
      const TOKEN_KEY = "token";
      translateServiceClient
          .checkUploadCountByDay(uploadCountRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (!res.getIsoverstepcount()) {
              if (that.hasPersonalAccountContext()) {
                that.$message.error(res.getMessage());
              }
              that.isUploadDisabled = true;
              that.isImgUploadDisabled = true;
              that.isExcelUploadDisabled = true;
              if (that.hasH5) {
                that.elUploadMdjy = "new-el-upload-mdjy-none-h5";
              } else {
                that.elUploadMdjy = "new-el-upload-mdjy-none";
              }
              that.limitCount = res.getLimitcount();
              return false;
            }
            that.isUploadDisabled = false;
            that.isImgUploadDisabled = false;
            that.isExcelUploadDisabled = false;
            if (that.hasH5) {
              that.elUploadMdjy = "new-el-upload-mdjy-h5";
            } else {
              that.elUploadMdjy = "new-el-upload-mdjy";
            }
            if (res.getCount() >= 10) {
              that.count = 10;
              that.limitCount = res.getLimitcount();
              return true;
            }
            that.count = res.getCount();
            that.limitCount = res.getLimitcount();
            return true;
          })
          .catch((err) => {
            return false;
          });
    },
    clickShowDoc(target) {
      if (target === "0") {
        this.showTxt = false;
        this.showImg = false;
        this.showExcel = false;
        this.showDoc = true;
        if (this.hasH5) {
          this.activeLabDoc = "is-active";
        } else {
          this.activeLabDoc = "active-lab";
        }
        this.activeLabTxt = "";
        this.activeLabImg = "";
        this.activeLabExcel = "";
      }
      if (target === "1") {
        this.showTxt = true;
        this.showDoc = false;
        this.showImg = false;
        this.showExcel = false;
        this.activeLabDoc = "";
        this.activeLabImg = "";
        this.activeLabExcel = "";
        if (this.hasH5) {
          this.activeLabTxt = "is-active";
        } else {
          this.activeLabTxt = "active-lab";
        }
      }
      if (target === "2") {
        this.showTxt = false;
        this.showDoc = false;
        this.showExcel = false;
        this.showImg = true;
        this.activeLabDoc = "";
        this.activeLabTxt = "";
        this.activeLabExcel = "";
        if (this.hasH5) {
          this.activeLabImg = "is-active";
        } else {
          this.activeLabImg = "active-lab";
        }
      }
      if (target === "3") {
        this.showTxt = false;
        this.showDoc = false;
        this.showImg = false;
        this.showExcel = true;
        this.activeLabDoc = "";
        this.activeLabTxt = "";
        this.activeLabImg = "";
        if (this.hasH5) {
          this.activeLabExcel = "is-active";
        } else {
          this.activeLabExcel = "active-lab";
        }
      }
    },
    submitConvertPay() {
      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id);
      });
      let request = submitConvertRequest;
      request.setIdsList(ids).setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient
          .submitConvert(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (res.getStatus()) {
              if (
                  res.getMessage() !== undefined &&
                  res.getMessage() !== null &&
                  res.getMessage() !== ""
              ) {
                window.open(res.getMessage(), "_self");
                return;
              }
              this.$router.push({
                path: "/list",
                query: {
                  type: "convert",
                },
              });
              return;
            }
            this.$message({
              center: true,
              type: "error",
              showClose: true,
              duration: 3000,
              message: res.getMessage(),
            });
          })
          .catch((err) => {
            this.$message({
              center: true,
              type: "error",
              showClose: true,
              duration: 3000,
              message: "提交失败请稍后再试",
            });
          });
    },
    submitPay() {
      if (
          this.gridData &&
          this.gridData[0] &&
          this.gridData[0].tmpType &&
          this.gridData[0].tmpType === "convert"
      ) {
        this.submitConvertPay();
        return;
      }
      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id);
      });
      let request = submitRequest;
      request.setIdsList(ids).setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient
          .submit(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (res.getStatus()) {
              if (
                  res.getMessage() !== undefined &&
                  res.getMessage() !== null &&
                  res.getMessage() !== ""
              ) {
                window.open(res.getMessage(), "_self");
                return;
              }
              this.$router.push("/list");
              return;
            }
            this.$message({
              center: true,
              type: "error",
              showClose: true,
              duration: 3000,
              message: res.getMessage(),
            });
          })
          .catch((err) => {
            this.$message({
              center: true,
              type: "error",
              showClose: true,
              duration: 3000,
              message: "提交失败请稍后再试",
            });
          });
    },
    closeTip() {
      this.selectOption = "selectOption1";
    },
    yuwenClose1(event) {
      this.showUpload1 = !event;
      if (this.showUpload1 && this.showUpload2) {
        if (this.hasH5) {
          this.showupload = "new-el-upload-manjy-h5";
        } else {
          this.showupload = "new-el-upload-manjy";
        }
        this.isShowupload = true;
        this.languages = "languages";
      } else {
        this.showupload = "new-el-upload-manjy-display";
        this.isShowupload = false;
        this.languages = "openlanguages";
      }
      if (this.uploadform.from) {
        this.originalFrom = this.getChineseName(this.uploadform.from);
        this.one = true;
        this.two = false;
        this.three = false;
        this.four = false;
      }
    },
    yuwenClose2(event) {
      this.showUpload2 = !event;
      if (this.showUpload1 && this.showUpload2) {
        if (this.hasH5) {
          this.showupload = "new-el-upload-manjy-h5";
        } else {
          this.showupload = "new-el-upload-manjy";
        }
        this.isShowupload = true;
        this.languages2 = "languages";
      } else {
        this.showupload = "new-el-upload-manjy-display";
        this.isShowupload = false;
        this.languages2 = "openlanguages";
      }
      if (this.uploadform.to) {
        this.originalTo = this.getChineseName(this.uploadform.to);
        this.one2 = true;
        this.two2 = false;
        this.three2 = false;
      }
    },
    onSuccess() {
      return false;
    },
    doSomething(e) {
      document.location.href =
          "https://wesitrans.com/wesitrans/template/表格翻译样例.xlsx";
      try {
        e.stopPropagation(); //非IE浏览器
      } catch (e) {
        window.event.cancelBubble = true; //IE浏览器
      }
    },
    handleRemove(file) {
      this.$refs.fileUpload.abort(); //取消上传
      this.$refs.fileUploadImg.abort();
      this.$refs.fileUploadExcel.abort();
      this.$refs.fileConvertUpload.abort();
      this.$refs.fileUploadExcel.abort();
    },
    onError(err, file, fileList) {
    },
    changeLanuage2(event) {
      if (
          (event.target.innerText === "中文(简体)" && this.one2) ||
          (event.target.innerText === "英语" && this.two2) ||
          (event.target.innerText === "日语" && this.three2)
      ) {
        this.one2 = false;
        this.two2 = false;
        this.three2 = false;
        this.uploadform.to = "zh";
        return;
      }
      this.one2 = false;
      this.two2 = false;
      this.three2 = false;
      if (event.target.innerText === "中文(简体)") {
        this.uploadform.to = "zh";
        this.one2 = true;
        return;
      }
      if (event.target.innerText === "英语") {
        this.uploadform.to = "en";
        this.two2 = true;
        return;
      }
      if (event.target.innerText === "日语") {
        this.uploadform.to = "ja";
        this.three2 = true;
        return;
      }
      this.one2 = true;
    },
    zhuanhuanItem(item) {
      if (item.from === "auto") {
        this.$message.error("请选择原文件语言");
        return;
      }
      if (item.domain === "novel" || item.domain === "wiki") {
        this.$message.error(
            item.domain === "novel"
                ? "网络文学领域暂时只支持 中文（简）-> 英语"
                : "人文社科领域暂时只支持 中文（简）-> 英语"
        );
        return;
      }
      const tmp = item.from;
      item.from = item.to;
      item.to = tmp;
    },
    zhuanhuanImgItem(item) {
      if (item.from === "auto") {
        this.$message.error("请选择原文件语言");
        return;
      }
      const tmp = item.from;
      item.from = item.to;
      item.to = tmp;
    },
    zhuanhuanImg() {
      if (this.uploadImgForm.from === "auto") {
        this.$message.error("请选择原文件语言");
        return;
      }
      const tmp = this.uploadImgForm.from;
      this.uploadImgForm.from = this.uploadImgForm.to;
      this.uploadImgForm.to = tmp;
    },
    zhuanhuan() {
      if (this.uploadform.from === "auto") {
        this.$message.error("请选择原文件语言");
        return;
      }
      if (this.domain === "novel" || this.domain === "wiki") {
        this.$message.error(
            this.domain === "novel"
                ? "网络文学领域暂时只支持 中文（简）-> 英语"
                : "人文社科领域暂时只支持 中文（简）-> 英语"
        );
        return;
      }
      if (
          this.uploadform.from !== "zh" &&
          this.uploadform.from !== "en" &&
          this.uploadform.from !== "ja"
      ) {
        this.originalTo = this.getChineseName(this.uploadform.from);
        this.one2 = true;
        this.two2 = false;
        this.three2 = false;
      }
      if (
          this.uploadform.to !== "zh" &&
          this.uploadform.to !== "en" &&
          this.uploadform.to !== "ja"
      ) {
        this.originalFrom = this.getChineseName(this.uploadform.to);
        this.one = true;
        this.two = false;
        this.three = false;
        this.four = false;
      }
      if (this.uploadform.from === "zh") {
        this.one2 = true;
        this.two2 = false;
        this.three2 = false;
      }
      if (this.uploadform.from === "en") {
        this.one2 = false;
        this.two2 = true;
        this.three2 = false;
      }
      if (this.uploadform.from === "ja") {
        this.one2 = false;
        this.two2 = false;
        this.three2 = true;
      }
      if (this.uploadform.to === "zh") {
        this.one = false;
        this.two = true;
        this.three = false;
        this.four = false;
      }
      if (this.uploadform.to === "en") {
        this.one = false;
        this.two = false;
        this.three = true;
        this.four = false;
      }
      if (this.uploadform.to === "ja") {
        this.one = false;
        this.two = false;
        this.three = false;
        this.four = true;
      }
      const tmp = this.uploadform.from;
      this.uploadform.from = this.uploadform.to;
      this.uploadform.to = tmp;
    },
    changeLanuage(event) {
      this.one = false;
      this.two = false;
      this.three = false;
      this.four = false;
      if (event.target.innerText === "自动检测") {
        this.uploadform.from = "auto";
        this.one = true;
        return;
      }
      if (event.target.innerText === "中文(简体)") {
        this.uploadform.from = "zh";
        this.two = true;
        return;
      }
      if (event.target.innerText === "英语") {
        this.uploadform.from = "en";
        this.three = true;
        return;
      }
      if (event.target.innerText === "日语") {
        this.uploadform.from = "ja";
        this.four = true;
        return;
      }
      this.one = true;
    },
    getChineseName(lanuage) {
      let label = lanuage;
      languages.forEach((item) => {
        if (item.value === lanuage) {
          label = item.label;
        }
      });
      return label;
    },
    getImgChineseName(lanuage) {
      let label = lanuage;
      this.imgFromOptions.forEach((item) => {
        if (item.value === lanuage) {
          label = item.label;
        }
      });
      return label;
    },
    submitTmpTrans(flag, tmpType) {
      if (!flag && this.checkTmpList.length === 0) {
        this.$confirm("您确认要翻译全部文件吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
            .then(() => {
              this.checkTmpList = this.tmpFileData.map((item) => item.id);
              this.submitTmpTrans(true, tmpType);
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "勾选您要翻译的文档吧",
              });
            });
        return;
      }
      const checkList = this.tmpFileData.filter(
          (item) => this.checkTmpList.indexOf(item.id) >= 0
      );
      if (checkList.length === 0) {
        this.$message.warning("请勾选您要翻译的文档");
        return;
      }
      const transTmpFiles = [];
      debugger;
      checkList.forEach((check) => {
        let data = new TransTmpFile();
        data.setId(check.id);
        data.setFrom(check.from);
        data.setTo(check.to);
        data.setModel(check.model);
        data.setDomain(check.domain);
        data.setTerminology(check.terminology);
        transTmpFiles.push(data);
      });
      console.log(checkList);
      console.log(transTmpFiles);
      let request = transTmpRequest;
      request.setTranstmpfilesList(transTmpFiles);
      request.setTmpType(tmpType);
      const TOKEN_KEY = "token";
      translateServiceClient
          .transTmp(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (res.getStatus()) {
              let uploadfileList = res.getUploadfileList();
              uploadfileList.forEach((file) => {
                const data = {};
                data.id = file.getId();
                data.title = file.getTitle();
                data.page = file.getPage();
                data.money = file.getOrderMoney();
                this.gridData.push(data);
                this.moneys = this.moneys + file.getMoney();
                this.orderMoney = this.orderMoney + file.getOrderMoney();
                this.pages = this.pages + file.getPage();
              });
              this.dialogTableVisible = true;
              return;
            }
            this.$message.error(res.getMessage());
          })
          .catch((err) => {
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            } else {
              this.$message.error("翻译失败，请稍后再试！");
            }
          });
    },
    submitTmpConvertTrans(flag, tmpType) {
      if (!flag && this.checkTmpList.length === 0) {
        this.$confirm("您确认要转换全部文件吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
            .then(() => {
              this.checkTmpList = this.tmpFileData.map((item) => item.id);
              this.submitTmpConvertTrans(true, tmpType);
            })
            .catch(() => {
              this.$message({
                type: "warning",
                message: "勾选您要转换的文档吧",
              });
            });
        return;
      }

      const checkList = this.tmpFileData.filter(
          (item) => this.checkTmpList.indexOf(item.id) >= 0
      );
      if (checkList.length === 0) {
        this.$message.warning("请勾选您要转换的文档");
        return;
      }
      const transTmpFiles = [];
      checkList.forEach((check) => {
        let data = new TransTmpFile();
        data.setId(check.id);
        transTmpFiles.push(data);
      });
      let request = transTmpRequest;
      request.setTranstmpfilesList(transTmpFiles);
      request.setTmpType(tmpType);
      const TOKEN_KEY = "token";
      translateServiceClient
          .transTmp(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (res.getStatus()) {
              let uploadfileList = res.getUploadfileList();
              uploadfileList.forEach((file) => {
                const data = {};
                data.id = file.getId();
                data.title = file.getTitle();
                data.page = file.getPage();
                data.money = file.getOrderMoney();
                data.tmpType = tmpType;
                this.gridData.push(data);
                this.moneys = this.moneys + file.getMoney();
                this.orderMoney = this.orderMoney + file.getOrderMoney();
                this.pages = this.pages + file.getPage();
              });
              this.dialogTableVisible = true;
              return;
            }
            this.$message.error(res.getMessage());
          })
          .catch((err) => {
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            } else {
              this.$message.error("翻译失败，请稍后再试！");
            }
          });
    },
    delTmp(id, tmpType) {
      const TOKEN_KEY = "token";
      let request = delTmpRequest;
      request.setId(id);
      request.setTmpType(tmpType);
      translateServiceClient
          .delTmp(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (res.getStatus()) {
              console.log(999, res.getUploadtmpfilesList());
              this.tmpFileData = [];
              res.getUploadtmpfilesList().forEach((item) => {
                const data = {};
                data["id"] = item.getId();
                data["type"] = item.getType();
                data["title"] = item.getTitle();
                data["page"] = item.getPage();
                data["character"] = item.getCharacter();
                data["from"] = item.getFrom();
                data["to"] = item.getTo();
                data["domain"] = item.getDomain();
                data["terminology"] =
                    item.getTerminology() === undefined ||
                    item.getTerminology() === null ||
                    item.getTerminology() === ""
                        ? "暂不使用术语"
                        : item.getTerminology();
                this.tmpFileData.push(data);
              });
              if (this.tmpFileData.length === 0) {
                this.isShowNewUpload = true;
                this.isShowNewUploadList = false;
              }
              return;
            }
            this.$message.error(res.getMessage());
          })
          .catch((err) => {
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            } else {
              this.$message.error("删除失败，请稍后再试！");
            }
          });
    },
    submitUploadConvertTmpFiles(tmpType) {
      const TOKEN_KEY = "token";
      translateServiceClient
          .checkUploadCountByDay(uploadCountRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isUploadDisabled = true;
              return;
            }
            this.isShowNewUpload = false;
            this.isUploadDisabled = false;
            if (res.getCount() >= 10) {
              this.count = 10;
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            const files = this.$refs.fileConvertUpload.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            //上传进度
            this.timer = setInterval(() => {
              if (this.processNum === 100) {
                this.processNum = 1;
              }
              if (this.processNum < 99) {
                this.processNum += 1;
              } else {
                clearInterval(this.timer);
              }
            }, 10);
            let request = uploadTmpRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            reader.onloadend = () => {
              request.setTmpType(tmpType);
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              request.setModel && request.setModel(this.aiMode.model);
              console.log(11);
              translateServiceClient
                  .uploadTmp(request, {
                    [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                  })
                  .then((res) => {
                    if (res.getStatus()) {
                      console.log(111, res.getUploadtmpfilesList());
                      this.tmpFileData = [];
                      res.getUploadtmpfilesList().forEach((item) => {
                        const data = {};
                        data["id"] = item.getId();
                        data["type"] = item.getType();
                        data["title"] = item.getTitle();
                        data["page"] = item.getPage();
                        data["character"] = item.getCharacter();
                        this.tmpFileData.push(data);
                      });
                      this.isShowNewUploadList = true;
                      return;
                    }
                    this.$refs.fileConvertUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileConvertUpload.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: "error",
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage(),
                    });
                    if (files.length === 0) {
                      clearInterval(this.timer);
                      this.processNum = 100;
                      this.isShowNewUpload = true;
                      this.isUploadDisabled = false;
                    }
                  })
                  .catch((error) => {
                    this.isShowNewUpload = true;
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.$router.push("/index");
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                      return;
                    }
                    this.$refs.fileConvertUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileConvertUpload.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                    }
                  });
            };
          })
          .catch((err) => {
            this.isShowNewUpload = true;
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            } else {
              this.$message.error("文件上传遇到了问题，请稍后再试！");
            }
          });
    },
    submitUploadImgTmpFiles(tmpType) {
      const TOKEN_KEY = "token";
      translateServiceClient
          .checkUploadCountByDay(uploadCountRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isUploadDisabled = true;
              return;
            }
            this.isShowNewUpload = false;
            this.isUploadDisabled = false;
            if (res.getCount() >= 10) {
              this.count = 10;
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            if (this.uploadImgForm.from === "原文语言") {
              this.uploadImgForm.from = "auto";
            }
            if (this.uploadImgForm.to === "目标语言") {
              this.uploadImgForm.to = "zh";
            }
            const files = this.$refs.fileUploadImg.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            //上传进度
            this.timer = setInterval(() => {
              if (this.processNum === 100) {
                this.processNum = 1;
              }
              if (this.processNum < 99) {
                this.processNum += 1;
              } else {
                clearInterval(this.timer);
              }
            }, 10);
            let request = uploadTmpRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            reader.onloadend = () => {
              request.setTmpType(tmpType);
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              request.setFrom(this.uploadImgForm.from);
              request.setTo(this.uploadImgForm.to);
              request.setModel && request.setModel(this.aiMode.model);
              console.log(22);
              translateServiceClient
                  .uploadTmp(request, {
                    [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                  })
                  .then((res) => {
                    if (res.getStatus()) {
                      console.log(222, res.getUploadtmpfilesList());
                      this.tmpFileData = [];
                      res.getUploadtmpfilesList().forEach((item) => {
                        const data = {};
                        data["id"] = item.getId();
                        data["type"] = item.getType();
                        data["title"] = item.getTitle();
                        data["page"] = item.getPage();
                        data["character"] = item.getCharacter();
                        data["from"] = item.getFrom();
                        data["to"] = item.getTo();
                        data["domain"] = item.getDomain();
                        data["terminology"] =
                            item.getTerminology() === undefined ||
                            item.getTerminology() === null ||
                            item.getTerminology() === ""
                                ? "暂不使用术语"
                                : item.getTerminology();
                        this.tmpFileData.push(data);
                      });
                      this.isShowNewUploadList = true;
                      return;
                    }
                    this.$refs.fileUploadImg.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUploadImg.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: "error",
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage(),
                    });
                    if (files.length === 0) {
                      clearInterval(this.timer);
                      this.processNum = 100;
                      this.isShowNewUpload = true;
                      this.isUploadDisabled = false;
                    }
                  })
                  .catch((error) => {
                    this.isShowNewUpload = true;
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.$router.push("/index");
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                      return;
                    }
                    this.$refs.fileUploadImg.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUploadImg.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                    }
                  });
            };
          })
          .catch((err) => {
            this.isShowNewUpload = true;
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            } else {
              this.$message.error("文件上传遇到了问题，请稍后再试！");
            }
          });
    },
    submitUploadMoreTmpFiles(tmpType) {
      const TOKEN_KEY = "token";
      translateServiceClient
          .checkUploadCountByDay(uploadCountRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isUploadDisabled = true;
              return;
            }
            this.isShowNewUpload = false;
            this.isUploadDisabled = false;
            if (res.getCount() >= 10) {
              this.count = 10;
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            const files = this.$refs.fileUploadExcel.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            //上传进度
            this.timer = setInterval(() => {
              if (this.processNum === 100) {
                this.processNum = 1;
              }
              if (this.processNum < 99) {
                this.processNum += 1;
              } else {
                clearInterval(this.timer);
              }
            }, 10);
            let request = uploadTmpRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            reader.onloadend = () => {
              request.setTmpType(tmpType);
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              request.setModel && request.setModel(this.aiMode.model);
              console.log(33);
              translateServiceClient
                  .uploadTmp(request, {
                    [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                  })
                  .then((res) => {
                    if (res.getStatus()) {
                      console.log(555, res.getUploadtmpfilesList());
                      this.tmpFileData = [];
                      res.getUploadtmpfilesList().forEach((item) => {
                        const data = {};
                        data["id"] = item.getId();
                        data["type"] = item.getType();
                        data["title"] = item.getTitle();
                        data["character"] = item.getCharacter();
                        this.tmpFileData.push(data);
                      });
                      this.isShowNewUploadList = true;
                      return;
                    }
                    this.$refs.fileUploadExcel.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUploadExcel.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: "error",
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage(),
                    });
                    if (files.length === 0) {
                      clearInterval(this.timer);
                      this.processNum = 100;
                      this.isShowNewUpload = true;
                      this.isUploadDisabled = false;
                    }
                  })
                  .catch((error) => {
                    this.isShowNewUpload = true;
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.$router.push("/index");
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                      return;
                    }
                    this.$refs.fileUploadExcel.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUploadExcel.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                    }
                  });
            };
          })
          .catch((err) => {
            this.isShowNewUpload = true;
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            } else {
              this.$message.error("文件上传遇到了问题，请稍后再试！");
            }
          });
    },
    submitUploadTmpFiles(tmpType) {
      const TOKEN_KEY = "token";
      translateServiceClient
          .checkUploadCountByDay(uploadCountRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isUploadDisabled = true;
              return;
            }
            this.isShowNewUpload = false;
            this.isUploadDisabled = false;
            if (res.getCount() >= 10) {
              this.count = 10;
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            //上传进度
            let unm = 0;
            if (this.uploadform.from === "原文语言") {
              this.uploadform.from = "auto";
            }
            if (this.uploadform.to === "目标语言") {
              this.uploadform.to = "zh";
            }
            const files = this.$refs.fileUpload.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            this.timer = setInterval(() => {
              if (this.processNum === 100) {
                this.processNum = 1;
              }
              if (this.processNum < 99) {
                this.processNum += 1;
              } else {
                clearInterval(this.timer);
              }
            }, 10);
            let request = uploadTmpRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            reader.onloadend = () => {
              request.setTmpType(tmpType);
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              request.setFrom(this.uploadform.from);
              request.setTo(this.uploadform.to);
              request.setDomain(this.domain);
              request.setTerminology(this.terminology);
              request.setModel && request.setModel(this.aiMode.model);
              console.log(44);
              translateServiceClient
                  .uploadTmp(request, {
                    [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                  })
                  .then((res) => {
                    if (res.getStatus()) {
                      console.log("000", res.getUploadtmpfilesList());
                      this.tmpFileData = [];
                      res.getUploadtmpfilesList().forEach((item) => {
                        const data = {};
                        data["id"] = item.getId();
                        data["type"] = item.getType();
                        data["title"] = item.getTitle();
                        data["page"] = item.getPage();
                        data["character"] = item.getCharacter();
                        data["from"] = item.getFrom();
                        data["to"] = item.getTo();
                        data["model"] = item.getModel();
                        data["domain"] = item.getDomain();
                        data["terminology"] =
                            item.getTerminology() === undefined ||
                            item.getTerminology() === null ||
                            item.getTerminology() === ""
                                ? "暂不使用术语"
                                : item.getTerminology();
                        this.tmpFileData.push(data);
                      });
                      this.isShowNewUploadList = true;
                      return;
                    }
                    this.$refs.fileUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUpload.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: "error",
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage(),
                    });
                    if (files.length === 0) {
                      clearInterval(this.timer);
                      this.processNum = 100;
                      this.isShowNewUpload = true;
                      this.isUploadDisabled = false;
                    }
                  })
                  .catch((error) => {
                    this.isShowNewUpload = true;
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.$router.push("/index");
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                      return;
                    }
                    this.$refs.fileUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUpload.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                    }
                  });
            };
          })
          .catch((err) => {
            this.isShowNewUpload = true;
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            } else {
              this.$message.error("文件上传遇到了问题，请稍后再试！");
            }
          });
    },
    submitUploadFiles(event) {
      let time;
      const TOKEN_KEY = "token";
      translateServiceClient
          .checkUploadCountByDay(uploadCountRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isUploadDisabled = true;
              if (this.hasH5) {
                this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
              } else {
                this.elUploadMdjy = "new-el-upload-mdjy-none";
              }
              return;
            }
            this.isShowupload = false;
            this.isUploadDisabled = false;
            if (this.hasH5) {
              this.elUploadMdjy = "new-el-upload-mdjy-h5";
            } else {
              this.elUploadMdjy = "new-el-upload-mdjy";
            }
            if (res.getCount() >= 10) {
              this.count = 10;
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            if (this.hasH5) {
              this.elUploadMdjy = "new-el-upload-mdjy-display-h5";
            } else {
              this.elUploadMdjy = "new-el-upload-mdjy-display";
            }
            //上传进度
            let unm = 0;
            event.onProgress({percent: unm});
            time = setInterval(function () {
              let Range = 5 - 1;
              let Rand = Math.random();
              unm = 1 + Math.round(Rand * Range) + unm;
              if (unm > 99) {
                unm = 99;
              }
              event.onProgress({percent: unm});
            }, 100);
            if (this.uploadform.from === "原文语言") {
              this.uploadform.from = "auto";
            }
            if (this.uploadform.to === "目标语言") {
              this.uploadform.to = "zh";
            }
            const files = this.$refs.fileUpload.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            let request = uploadRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            const thatEvent = event;
            reader.onloadend = () => {
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              request.setFrom(this.uploadform.from);
              request.setTo(this.uploadform.to);
              request.setSendMail(this.hasSendMail);
              translateServiceClient
                  .upload(request, {
                    [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                  })
                  .then((res) => {
                    clearInterval(time);
                    if (res.getStatus()) {
                      thatEvent.onProgress({percent: 100});
                      const file = res.getUploadfile();
                      const data = {};
                      data.id = file.getId();
                      data.title = file.getTitle();
                      data.page = file.getPage();
                      data.money = file.getOrderMoney();
                      this.gridData.push(data);
                      this.moneys = this.moneys + file.getMoney();
                      this.orderMoney = this.orderMoney + file.getOrderMoney();
                      this.pages = this.pages + file.getPage();
                      return;
                    }
                    this.$refs.fileUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUpload.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: "error",
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage(),
                    });
                    if (files.length === 0) {
                      this.isShowupload = true;
                      this.isUploadDisabled = false;
                      if (this.hasH5) {
                        this.elUploadMdjy = "new-el-upload-mdjy-h5";
                      } else {
                        this.elUploadMdjy = "new-el-upload-mdjy";
                      }
                    }
                  })
                  .catch((error) => {
                    this.isShowupload = true;
                    clearInterval(time);
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.$router.push("/index");
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                      return;
                    }
                    this.$refs.fileUpload.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUpload.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isUploadDisabled = false;
                      if (this.hasH5) {
                        this.elUploadMdjy = "new-el-upload-mdjy-h5";
                      } else {
                        this.elUploadMdjy = "new-el-upload-mdjy";
                      }
                    }
                  });
            };
          })
          .catch((err) => {
            this.isShowupload = true;
            clearInterval(time);
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            } else {
              this.$message.error("文件上传遇到了问题，请稍后再试！");
            }
          });
    },
    submitExcelUploadFiles(event) {
      let time;
      const TOKEN_KEY = "token";
      translateServiceClient
          .checkUploadCountByDay(uploadCountRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isExcelUploadDisabled = true;
              if (this.hasH5) {
                this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
              } else {
                this.elUploadMdjy = "new-el-upload-mdjy-none";
              }
              return;
            }
            this.isShowupload = false;
            this.isUploadDisabled = false;
            this.isExcelUploadDisabled = false;
            if (this.hasH5) {
              this.elUploadMdjy = "new-el-upload-mdjy-h5";
            } else {
              this.elUploadMdjy = "new-el-upload-mdjy";
            }
            if (res.getCount() >= 10) {
              this.count = 10;
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            if (this.hasH5) {
              this.elUploadMdjy = "new-el-upload-mdjy-display-h5";
            } else {
              this.elUploadMdjy = "new-el-upload-mdjy-display";
            }
            //上传进度
            let unm = 0;
            event.onProgress({percent: unm});
            time = setInterval(function () {
              let Range = 5 - 1;
              let Rand = Math.random();
              unm = 1 + Math.round(Rand * Range) + unm;
              if (unm > 99) {
                unm = 99;
              }
              event.onProgress({percent: unm});
            }, 100);
            if (this.uploadform.from === "原文语言") {
              this.uploadform.from = "auto";
            }
            if (this.uploadform.to === "目标语言") {
              this.uploadform.to = "zh";
            }
            const files = this.$refs.fileUploadExcel.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            let request = uploadRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            const thatEvent = event;
            reader.onloadend = () => {
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              request.setFrom(this.uploadform.from);
              request.setTo(this.uploadform.to);
              request.setFlag(1);
              translateServiceClient
                  .upload(request, {
                    [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                  })
                  .then((res) => {
                    clearInterval(time);
                    if (res.getStatus()) {
                      thatEvent.onProgress({percent: 100});
                      const file = res.getUploadfile();
                      const data = {};
                      data.id = file.getId();
                      data.title = file.getTitle();
                      data.page = file.getPage();
                      data.money = file.getOrderMoney();
                      this.gridData.push(data);
                      this.moneys = this.moneys + file.getMoney();
                      this.orderMoney = this.orderMoney + file.getOrderMoney();
                      this.pages = this.pages + file.getPage();
                      return;
                    }
                    this.$refs.fileUploadExcel.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUploadExcel.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: "error",
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage(),
                    });
                    if (files.length === 0) {
                      this.isExcelUploadDisabled = false;
                      this.isShowupload = true;
                      if (this.hasH5) {
                        this.elUploadMdjy = "new-el-upload-mdjy-h5";
                      } else {
                        this.elUploadMdjy = "new-el-upload-mdjy";
                      }
                    }
                  })
                  .catch((error) => {
                    this.isShowupload = true;
                    clearInterval(time);
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.$router.push("/index");
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                      return;
                    }
                    this.$refs.fileUploadExcel.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUploadExcel.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isExcelUploadDisabled = false;
                      if (this.hasH5) {
                        this.elUploadMdjy = "new-el-upload-mdjy-h5";
                      } else {
                        this.elUploadMdjy = "new-el-upload-mdjy";
                      }
                    }
                  });
            };
          })
          .catch((err) => {
            this.isShowupload = true;
            clearInterval(time);
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            } else {
              this.$message.error("文件上传遇到了问题，请稍后再试！");
            }
          });
    },
    submitImgUploadFiles(event) {
      const TOKEN_KEY = "token";
      translateServiceClient
          .checkUploadCountByDay(uploadCountRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (!res.getIsoverstepcount()) {
              this.$message.error(res.getMessage());
              this.isImgUploadDisabled = true;
              if (this.hasH5) {
                this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
              } else {
                this.elUploadMdjy = "new-el-upload-mdjy-none";
              }
              return;
            }
            this.isShowupload = false;
            this.isImgUploadDisabled = false;
            if (this.hasH5) {
              this.elUploadMdjy = "new-el-upload-mdjy-h5";
            } else {
              this.elUploadMdjy = "new-el-upload-mdjy";
            }
            if (res.getCount() >= 10) {
              this.count = 10;
              this.limitCount = res.getLimitcount();
            } else {
              this.count = res.getCount();
              this.limitCount = res.getLimitcount();
            }
            if (this.hasH5) {
              this.elUploadMdjy = "new-el-upload-mdjy-display-h5";
            } else {
              this.elUploadMdjy = "new-el-upload-mdjy-display";
            }
            //上传进度
            let unm = 0;
            event.onProgress({percent: unm});
            let time = setInterval(function () {
              let Range = 5 - 1;
              let Rand = Math.random();
              unm = 1 + Math.round(Rand * Range) + unm;
              if (unm > 99) {
                unm = 99;
              }
              event.onProgress({percent: unm});
            }, 100);
            if (this.uploadform.from === "原文语言") {
              this.uploadform.from = "auto";
            }
            if (this.uploadform.to === "目标语言") {
              this.uploadform.to = "zh";
            }
            const files = this.$refs.fileUploadImg.$data.uploadFiles;
            const file = files[this.uploadCount];
            this.uploadCount = ++this.uploadCount;
            let request = uploadRequest;
            let reader = new FileReader();
            reader.readAsArrayBuffer(file.raw, "utf-8");
            const thatEvent = event;
            reader.onloadend = () => {
              request.setFile(new Uint8Array(reader.result));
              request.setName(file.name);
              request.setSize(file.size);
              request.setFrom(this.uploadform.from);
              request.setTo(this.uploadform.to);
              translateServiceClient
                  .uploadImg(request, {
                    [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                  })
                  .then((res) => {
                    clearInterval(time);
                    if (res.getStatus()) {
                      thatEvent.onProgress({percent: 100});
                      const file = res.getUploadfile();
                      const data = {};
                      data.id = file.getId();
                      data.title = file.getTitle();
                      data.page = file.getPage();
                      data.money = file.getOrderMoney();
                      this.gridData.push(data);
                      this.moneys = this.moneys + file.getMoney();
                      this.orderMoney = this.orderMoney + file.getOrderMoney();
                      this.pages = this.pages + file.getPage();
                      return;
                    }
                    this.$refs.fileUploadImg.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUploadImg.$data.uploadFiles = files;
                    this.$message({
                      center: true,
                      type: "error",
                      showClose: true,
                      duration: 6000,
                      message: res.getMessage(),
                    });
                    if (files.length === 0) {
                      this.isShowupload = true;
                      this.isImgUploadDisabled = false;
                      if (this.hasH5) {
                        this.elUploadMdjy = "new-el-upload-mdjy-h5";
                      } else {
                        this.elUploadMdjy = "new-el-upload-mdjy";
                      }
                    }
                  })
                  .catch((error) => {
                    this.isShowupload = true;
                    clearInterval(time);
                    if (error && error.code === 5) {
                      localStorage.removeItem("token");
                      localStorage.removeItem("auth-context");
                      if (this.hasH5) {
                        this.$router.push("/h5/login");
                        return;
                      }
                      this.$router.push("/index");
                      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                      return;
                    }
                    this.$refs.fileUploadImg.clearFiles();
                    this.uploadCount = --this.uploadCount;
                    files.splice(this.uploadCount, 1);
                    this.$refs.fileUploadImg.$data.uploadFiles = files;
                    this.$message.error("上传文件失败");
                    if (files.length === 0) {
                      this.isImgUploadDisabled = false;
                      if (this.hasH5) {
                        this.elUploadMdjy = "new-el-upload-mdjy-h5";
                      } else {
                        this.elUploadMdjy = "new-el-upload-mdjy";
                      }
                    }
                  });
            };
          })
          .catch((err) => {
            this.isShowupload = true;
            clearInterval(time);
            if (err.code === 5) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            } else {
              this.$message.error("文件上传遇到了问题，请稍后再试！");
            }
          });
    },
    onExceed() {
      if (this.count === 10) {
        this.$message.error("仅支持批量上传10个文件！");
        this.isUploadDisabled = false;
        return;
      }
      if (this.count === 0) {
        this.$message.error(
            "当前账户仅支持24小时内上传" + this.limitCount + "篇文献"
        );
        this.isUploadDisabled = true;
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy-none";
        }
        return;
      }
      this.$message({
        center: true,
        type: "error",
        dangerouslyUseHTMLString: true,
        message:
            "<span style='font-size:14px;font-family: Microsoft YaHei;font-weight: 400;color: #EF6C6C;'>当前账户仅支持24小时内上传" +
            this.limitCount +
            "篇文献，您还剩余&nbsp;<span style='font-size:20px;'>" +
            this.count +
            "</span>&nbsp;篇</span>",
      });
      if (this.hasH5) {
        this.elUploadMdjy = "new-el-upload-mdjy-h5";
      } else {
        this.elUploadMdjy = "new-el-upload-mdjy";
      }
      this.isUploadDisabled = false;
    },
    onImgExceed() {
      if (this.count === 10) {
        this.$message.error("仅支持批量上传10张图片！");
        this.isImgUploadDisabled = false;
        return;
      }
      if (this.count === 0) {
        this.$message.error(
            "当前账户仅支持24小时内上传" + this.limitCount + "张图片"
        );
        this.isImgUploadDisabled = true;
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy-none";
        }
        return;
      }
      this.$message({
        center: true,
        type: "error",
        dangerouslyUseHTMLString: true,
        message:
            "<span style='font-size:14px;font-family: Microsoft YaHei;font-weight: 400;color: #EF6C6C;'>当前账户仅支持24小时内上传" +
            this.limitCount +
            "张图片，您还剩余&nbsp;<span style='font-size:20px;'>" +
            this.count +
            "</span>&nbsp;张</span>",
      });
      if (this.hasH5) {
        this.elUploadMdjy = "new-el-upload-mdjy-h5";
      } else {
        this.elUploadMdjy = "new-el-upload-mdjy";
      }
      this.isImgUploadDisabled = false;
    },
    beforeImgUpload(file) {
      if (!this.requireFeatureLogin()) {
        return false;
      }
      const testmsg = file.name
          .substring(file.name.lastIndexOf(".") + 1)
          .toLowerCase();
      const extension =
          testmsg === "jpg" || testmsg === "jpeg" || testmsg === "png";
      if (!extension) {
        this.$message.error("暂不支持" + testmsg + "图片类型");
      }
      if (file.size === 0) {
        this.$message.error("您上传的图片内容为空！");
        return false;
      }
      const islimit = file.size < 4194304;
      if (!islimit) {
        this.$message.error("图片上传大小不能超过4M！");
      }
      return extension && islimit;
    },
    onExcelExceed() {
      if (this.count === 10) {
        this.$message.error("仅支持批量上传10个文件！");
        this.isExcelUploadDisabled = false;
        return;
      }
      if (this.count === 0) {
        this.$message.error(
            "当前账户仅支持24小时内上传" + this.limitCount + "篇文献"
        );
        this.isExcelUploadDisabled = true;
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy-none";
        }
        return;
      }
      this.$message({
        center: true,
        type: "error",
        dangerouslyUseHTMLString: true,
        message:
            "<span style='font-size:14px;font-family: Microsoft YaHei;font-weight: 400;color: #EF6C6C;'>当前账户仅支持24小时内上传" +
            this.limitCount +
            "篇文献，您还剩余&nbsp;<span style='font-size:20px;'>" +
            this.count +
            "</span>&nbsp;篇</span>",
      });
      if (this.hasH5) {
        this.elUploadMdjy = "new-el-upload-mdjy-h5";
      } else {
        this.elUploadMdjy = "new-el-upload-mdjy";
      }
      this.isExcelUploadDisabled = false;
    },
    beforeExcelUpload(file) {
      if (!this.requireFeatureLogin()) {
        return false;
      }
      const testmsg = file.name
          .substring(file.name.lastIndexOf(".") + 1)
          .toLowerCase();
      const extension = testmsg === "xls" || testmsg === "xlsx";
      if (!extension) {
        this.$message.error("暂不支持" + testmsg + "文件类型");
      }
      if (file.size === 0) {
        this.$message.error("您上传的文件内容为空！");
        return false;
      }
      const islimit = file.size < 2097152000;
      if (!islimit) {
        this.$message.error("文件上传大小不能超过20M！");
      }
      let isSuccess = extension && islimit;
      if (isSuccess) {
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy-none";
        }
      }
      return isSuccess;
    },
    beforeConvertUpload(file) {
      if (!this.requireFeatureLogin()) {
        return false;
      }
      const testmsg = file.name
          .substring(file.name.lastIndexOf(".") + 1)
          .toLowerCase();
      const extension = testmsg === "pdf";
      if (!extension) {
        this.$message.error("暂不支持" + testmsg + "文件类型");
      }
      if (file.size === 0) {
        this.$message.error("您上传的文件内容为空！");
        return false;
      }
      const islimit = file.size < 2097152000;
      if (!islimit) {
        this.$message.error("文件上传大小不能超过20M！");
      }
      let isSuccess = extension && islimit;
      if (isSuccess) {
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy-none";
        }
      }
      return isSuccess;
    },
    beforeUpload(file) {
      if (!this.requireFeatureLogin()) {
        return false;
      }
      const testmsg = file.name
          .substring(file.name.lastIndexOf(".") + 1)
          .toLowerCase();
      const extension =
          testmsg === "xml" ||
          testmsg === "html" ||
          testmsg === "htm" ||
          testmsg === "xls" ||
          testmsg === "xlsx" ||
          testmsg === "pdf" ||
          testmsg === "ppt" ||
          testmsg === "pptx" ||
          testmsg === "doc" ||
          testmsg === "docx" ||
          testmsg === "txt";
      if (!extension) {
        this.$message.error("暂不支持" + testmsg + "文件类型");
      }
      if (file.size === 0) {
        this.$message.error("您上传的文件内容为空！");
        return false;
      }
      const islimit = file.size < 2097152000;
      if (!islimit) {
        this.$message.error("文件上传大小不能超过20M！");
      }
      let isSuccess = extension && islimit;
      if (isSuccess) {
        if (this.hasH5) {
          this.elUploadMdjy = "new-el-upload-mdjy-none-h5";
        } else {
          this.elUploadMdjy = "new-el-upload-mdjy-none";
        }
      }
      return isSuccess;
    },
  },
};
</script>


<style lang="less" scoped src="../assets/v2/css/trans/common.less"/>
<style lang="less" scoped src="../assets/v2/css/trans/index.less"/>

<style lang="less">
.loader {
  float: inline-end;
  border: 2px solid #f3f3f3; /* Light grey */
  border-top: 2px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes breathing-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes shaking-animation {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px) rotate(-5deg);
  }
  50% {
    transform: translateX(5px) rotate(5deg);
  }
  75% {
    transform: translateX(-5px) rotate(-5deg);
  }
  100% {
    transform: translateX(0);
  }
}

.breathing {
  animation: breathing-animation 3s ease-in-out infinite,
  shaking-animation 1s linear infinite;
}

.el-upload-list {
  display: none;
}

.loadClass {
  .el-loading-spinner .path {
    stroke: var(--primary-dark);
  }

  .el-loading-spinner .el-loading-text {
    color: var(--primary-dark);
  }
}

.hasSendMailClass {
  .el-checkbox__input {
    width: 17px;
    height: 17px;
    background: #fff;
    border: 1px solid #cccccc;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-checkbox__inner {
    border: 0px solid #dcdfe6;
    position: relative;
    border-radius: 0px;
    box-sizing: border-box;
    width: 11px;
    height: 11px;
    background-color: #fff;
    z-index: 1;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: var(--primary-dark);
    width: 11px;
    height: 11px;
    background: var(--primary-dark);
  }

  .el-checkbox__inner::after {
    display: none;
  }
}

.hasSendMailClassH5 {
  .el-checkbox__input {
    width: 24px;
    height: 24px;
    background: #fff;
    border: 1px solid #cccccc;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-checkbox__inner {
    border: 0px solid #dcdfe6;
    position: relative;
    border-radius: 0px;
    box-sizing: border-box;
    width: 11px;
    height: 11px;
    background-color: #fff;
    z-index: 1;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: var(--primary-dark);
    width: 11px;
    height: 11px;
    background: var(--primary-dark);
  }

  .el-checkbox__inner::after {
    display: none;
  }
}

.triangle {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 590px;
  height: 45px;
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.35);
  border-radius: 6px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  text-align: center;
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
  border: 0px solid #999999;
}

.triangle:before {
  position: absolute;
  content: "";
  top: -10px;
  left: 50%;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 12px solid #99999991;
}

/* 白色覆盖*/
.triangle:after {
  position: absolute;
  content: "";
  /*减少两像素*/
  top: -8px;
  left: 50%;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #ffffff;
}

.user-img {
  width: 16px;
  float: right;
  padding-left: 5px;
}

.selectOption {
  width: 1200px !important;
  top: 368px !important;
  left: 50% !important;
  transform: translate(-50%, 0px);

  .el-scrollbar {
    height: 577px !important;
  }

  .el-select-group__title {
    padding-left: 20px !important;
    font-size: 24px !important;
    color: #999999 !important;
    line-height: 60px !important;
  }

  .el-select-group .el-select-dropdown__item {
    padding-left: 20px;
    width: 14% !important;
  }

  .el-select-dropdown {
    width: 1200px !important;
    height: 720px !important;
  }

  .el-select-dropdown__wrap {
    max-height: 720px !important;
  }

  .popper__arrow {
    display: none !important;
  }

  .el-select-dropdown__item {
    float: left !important;
  }

  .el-select-group__wrap:not(:last-of-type) {
    width: 100% !important;
  }

  .el-select-group__wrap {
    float: left !important;
    width: 100% !important;
  }
}

.selectOption1 {
  width: 1200px !important;
  top: 368px !important;
  left: 50% !important;
  transform: translate(-50%, 0px);

  .el-scrollbar {
    height: 577px !important;
  }

  .el-select-group__title {
    padding-left: 20px !important;
    font-size: 24px !important;
    color: #999999 !important;
    line-height: 60px !important;
  }

  .el-select-group .el-select-dropdown__item {
    padding-left: 20px;
    width: 14% !important;
  }

  .el-select-dropdown {
    width: 1200px !important;
    height: 720px !important;
  }

  .el-select-dropdown__wrap {
    max-height: 720px !important;
  }

  .popper__arrow {
    display: none !important;
  }

  .el-select-dropdown__item {
    float: left !important;
  }

  .el-select-group__wrap:not(:last-of-type) {
    width: 100% !important;
  }

  .el-select-group__wrap {
    float: left !important;
    width: 100% !important;
  }
}

.selectOption .el-scrollbar__thumb {
  width: 8px !important;
}

.selectOption1 .el-scrollbar__thumb {
  width: 8px !important;
}

.terminology-spec-popper .el-select-dropdown__item.hover,
.terminology-spec-popper .el-select-dropdown__item:hover {
  background: #f0f6ff !important;
}

.terminology-spec-popper .el-select-dropdown__item.selected {
  color: var(--primary-dark) !important;
  font-weight: 600;
}
</style>

<style lang="less">
@media (max-width: 768px) {
  .new-upload-site-shell.workspace-fullscreen-page .box_4 {
    overflow-x: auto;
    overflow-y: visible;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_4::-webkit-scrollbar {
    display: none;
  }

  .new-upload-site-shell.workspace-fullscreen-page .section_3,
  .new-upload-site-shell.workspace-fullscreen-page .section_4,
  .new-upload-site-shell.workspace-fullscreen-page .section_5,
  .new-upload-site-shell.workspace-fullscreen-page .section_6,
  .new-upload-site-shell.workspace-fullscreen-page .demo-form-inline,
  .new-upload-site-shell.workspace-fullscreen-page .demo-form-inline > div,
  .new-upload-site-shell.workspace-fullscreen-page .new-upload-demo,
  .new-upload-site-shell.workspace-fullscreen-page .new-upload-demo .el-upload,
  .new-upload-site-shell.workspace-fullscreen-page .new-upload-demo .el-upload-dragger {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }
}
</style>

<style lang="less">
.hide-history {
  margin-left: 700px !important;
}
</style>

<style lang="less" scoped>
.new-upload-site-shell,
.new-upload-site-shell .page,
.new-upload-site-shell .group_1,
.new-upload-site-shell .box_1 {
  min-height: 100vh;
}

.terminology-ai-launcher {
  position: fixed;
  top: 160px;
  right: 24px;
  z-index: 120;
  line-height: 0;
  pointer-events: auto;
  cursor: grab;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.16s ease, filter 0.16s ease, box-shadow 0.16s ease;
}

.terminology-ai-launcher::after {
  position: absolute;
  top: 7px;
  right: 7px;
  width: 14px;
  height: 9px;
  content: "";
  pointer-events: none;
  opacity: 0.8;
  background-image: radial-gradient(circle, rgba(255, 255, 255, 0.92) 1.2px, transparent 1.4px);
  background-size: 5px 5px;
}

.terminology-ai-launcher:hover {
  filter: brightness(1.04);
}

.terminology-ai-launcher:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 3px;
  border-radius: 6px;
}

.terminology-ai-launcher.is-dragging {
  cursor: grabbing;
  filter: brightness(1.06);
  transform: scale(1.02);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.24);
}

.terminology-ai-launcher img {
  display: block;
  pointer-events: none;
  user-select: none;
  -webkit-user-drag: none;
}

.terminology-ai-panel {
  position: fixed;
  top: 104px;
  right: 24px;
  z-index: 130;
  pointer-events: auto;
}

.new-el-upload-mdjy-none-h5 {
  background-color: #f5f5f5;
  border: 1px dashed #cccccc;
  width: 350px;
  height: 224px;
  display: inline-block;
  text-align: center;
  padding-top: 20px;
}

.triangle-h5 {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 590px;
  height: 45px;
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.35);
  border-radius: 6px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  text-align: center;
  position: relative;
  border: 0px solid #999999;
}

.triangle-h5:before {
  position: absolute;
  content: "";
  top: -10px;
  left: 50%;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 12px solid #99999991;
}

/* 白色覆盖*/
.triangle-h5:after {
  position: absolute;
  content: "";
  /*减少两像素*/
  top: -8px;
  left: 50%;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #ffffff;
}

.is-active {
  border-bottom: 4px solid var(--primary-dark);
}

/deep/ .shuru {
  position: absolute;
  bottom: 0;
  width: 289px;
  height: 118px;
  background: #ffffff;
  border-radius: 0px 0px 6px 6px;
  display: flex;
  flex-flow: column;
  align-items: flex-end;

  .el-textarea__inner {
    border: 0 !important;
    resize: none;
  }

  textarea {
    resize: none; /* 禁止用户调整 <textarea> 的大小 */
  }

  textarea::-webkit-resizer {
    display: none; /* 针对 WebKit 内核的浏览器，如 Chrome 和 Safari */
  }
}

/deep/ .new-el-upload-mdjy-display-h5 {
  .el-upload {
    display: none;
  }
}

.main-index {
  min-width: 768px;
  width: 100%;

  .header {
    width: 100%;
    height: 88px;
    background: #e6e6e6;
    display: flex;

    .title_hide {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      background: #e6e6e6;
    }

    .login {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      align-items: center;
      display: flex;
      height: 100%;
      margin-left: 33px;
    }

    .selected {
      position: fixed;
      width: 201px;
      background: #ffffff;
      box-shadow: 0px 5px 10px 0px rgba(116, 114, 114, 0.51);
      z-index: 100;
      top: 90px;
      right: 31px;
      text-align: center;

      div {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 72px;
      }
    }

    .select {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 1;
      margin-right: 30px;

      .select-option {
        width: 48px;
        height: 11px;
        display: flex;

        div {
          height: 11px;
          width: 11px;
          background: #333333;
          margin-left: 5px;
          border-radius: 50%;
        }
      }
    }
  }

  .trans-main {
    min-width: 765px;
    width: 100%;
    background: #f5f5f5;
    display: flex;
    flex-flow: column;
    align-items: center;
    border-bottom: 1px solid #dddddd;

    .trans-header {
      width: 100%;
      height: 80px;
      background: #ffffff;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      justify-content: center;

      .trans-header-select {
        width: 765px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        div {
          margin: 0 34px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 72px;
          height: 74px;
        }
      }
    }

    .trans-main-content {
      width: 768px;
      min-height: 993px;
      background: #ffffff;

      .trans-main-content-ok {
        height: 689px;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;

        .trans-main-content-ok-font {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          line-height: 1px;

          div:nth-child(1) {
            margin-right: 14px;
          }
        }

        .trans-main-content-ok-button {
          width: 261px;
          height: 60px;
          background: var(--primary-dark);
          border-radius: 35px 0px 35px 0px;
          margin-top: 48px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #f5f5f5;
          line-height: 52px;
          text-align: center;
        }
      }

      .trans-main-content-select {
        width: 100%;
        margin-top: 51px;
        margin-bottom: 113px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          margin: 0 90px;
        }

        /deep/ .el-select {
          .el-input {
            width: 200px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #666666;

            input {
              border: 0;
              padding: 0;
              text-align: center;
            }

            .el-input__suffix {
              display: none;
            }
          }
        }
      }

      /deep/ .demo-form-inline-h5 {
        .el-upload-dragger {
          height: 415px;
          width: 711px;
          border: 2px dashed #d9d9d9;

          .new-el-upload-mdjy-h5 {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            line-height: 30px;
            cursor: pointer;

            .content {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              .el-upload-titjy {
                font-family: "Microsoft YaHei";
                font-weight: 400;
                font-size: 24px;
                color: #333333;
                margin-bottom: 20px;
              }

              .scbncg {
                font-family: "Microsoft YaHei";
                font-weight: 400;
              }

              .uptitle {
                margin-top: 40px;
                font-family: "Source Han Sans CN";
                font-weight: 400;
                font-size: 24px;
                display: flex;
                width: 261px;
                height: 60px;
                align-items: center;
                justify-content: center;
                background: var(--primary-dark);
                border-radius: 26px 0px 26px 0px;
                color: #f5f5f5;
              }
            }
          }
        }

        .el-upload-list {
          margin-bottom: 30px !important;
          margin-right: -55px;
          margin-top: -60px;

          .el-upload-list__item .el-progress {
            position: absolute;
            top: 38px;
            width: 623px;
          }

          .el-progress__text {
            font-size: 24px !important;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }

          .el-upload-list__item .el-progress__text {
            position: absolute;
            right: 0;
            top: -26px;
          }

          .el-upload-list__item {
            text-align: left;
            transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 1.8;
            margin-top: 53px;
            position: relative;
            box-sizing: border-box;
            border-radius: 4px;
            width: 623px;

            .el-upload-list__item-name {
              color: #999999 !important;
              width: 560px;
            }

            .el-icon-document {
              position: absolute;
              margin-left: -69px;
              margin-top: -2.5px;
              font-size: 45px;
              color: #bebebe;
            }

            .el-progress-bar__outer {
              height: 17px !important;
            }

            .el-progress-bar__inner {
              background-color: #4dbe92 !important;
            }

            .el-icon-upload-success {
              display: none;
              color: #67c23a;
              position: absolute;
              margin-left: 19px;
              margin-top: 7.5px;
              font-size: 26px;
            }
          }
        }
      }

      /deep/ .new-el-upload-manjy-h5 {
        margin-bottom: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .el-divider.el-divider--horizontal {
          width: 470px;
          margin: 0;

          .el-divider__text.is-center {
            font-size: 24px;
            font-family: "Microsoft YaHei";
            color: #999999;
          }
        }
      }

      .list {
        margin-top: 70px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 80%;

        div {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #999999;

          span {
            margin-top: 10px;
          }
        }
      }

      .text-input {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        /deep/ .originaltext {
          width: 704px;

          /deep/ .el-input__count {
            color: #909399;
            position: absolute;
            font-size: 24px;
            bottom: 5px;
            right: 10px;
          }

          .el-textarea__inner {
            border: 0;
          }
        }
      }
    }

    .trans-main-content-text {
      width: 704px;
      height: 480px;
      background: #ffffff;
      box-shadow: 0px 5px 5px 0px rgba(3, 27, 63, 0.1);

      .trans-main-content-select {
        width: 100%;
        margin-top: 51px;
        margin-bottom: 50px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          margin: 0 90px;
        }

        /deep/ .el-select {
          .el-input {
            width: 200px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #666666;

            input {
              border: 0;
              padding: 0;
              text-align: center;
            }

            .el-input__suffix {
              display: none;
            }
          }
        }
      }

      /deep/ .demo-form-inline-h5 {
        .el-upload-dragger {
          height: 320px;
          width: 711px;
          border: 2px dashed #d9d9d9;

          .new-el-upload-mdjy-h5 {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            line-height: 30px;
            cursor: pointer;

            .content {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              .el-upload-titjy {
                font-family: "Microsoft YaHei";
                font-weight: 400;
                font-size: 24px;
                color: #333333;
                margin-bottom: 20px;
              }

              .scbncg {
                font-family: "Microsoft YaHei";
                font-weight: 400;
              }

              .uptitle {
                margin-top: 40px;
                font-family: "Source Han Sans CN";
                font-weight: 400;
                font-size: 24px;
                display: flex;
                width: 261px;
                height: 60px;
                align-items: center;
                justify-content: center;
                background: var(--primary-dark);
                border-radius: 26px 0px 26px 0px;
                color: #f5f5f5;
              }
            }
          }
        }

        .el-upload-list {
          margin-bottom: 30px !important;
          margin-right: -55px;
          margin-top: -60px;

          .el-upload-list__item .el-progress {
            position: absolute;
            top: 38px;
            width: 623px;
          }

          .el-progress__text {
            font-size: 24px !important;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }

          .el-upload-list__item .el-progress__text {
            position: absolute;
            right: 0;
            top: -26px;
          }

          .el-upload-list__item {
            text-align: left;
            transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 1.8;
            margin-top: 53px;
            position: relative;
            box-sizing: border-box;
            border-radius: 4px;
            width: 623px;

            .el-upload-list__item-name {
              color: #999999 !important;
              width: 560px;
            }

            .el-icon-document {
              position: absolute;
              margin-left: -69px;
              margin-top: -2.5px;
              font-size: 45px;
              color: #bebebe;
            }

            .el-progress-bar__outer {
              height: 17px !important;
            }

            .el-progress-bar__inner {
              background-color: #4dbe92 !important;
            }

            .el-icon-upload-success {
              display: none;
              color: #67c23a;
              position: absolute;
              margin-left: 19px;
              margin-top: 7.5px;
              font-size: 26px;
            }
          }
        }
      }

      /deep/ .new-el-upload-manjy-h5 {
        margin-bottom: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .el-divider.el-divider--horizontal {
          width: 470px;
          margin: 0;

          .el-divider__text.is-center {
            font-size: 24px;
            font-family: "Microsoft YaHei";
            color: #999999;
          }
        }
      }

      .list {
        margin-top: 70px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 80%;

        div {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #999999;

          span {
            margin-top: 10px;
          }
        }
      }

      .text-input {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        /deep/ .originaltext {
          width: 704px;

          .el-input__count {
            color: #909399;
            position: absolute;
            font-size: 24px;
            bottom: 5px;
            right: 10px;
          }

          .el-textarea__inner {
            border: 0;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
          }
        }
      }
    }

    .trans-main-content-text-tip {
      margin-bottom: 474px;
      margin-top: 20px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
      width: 704px;
    }
  }

  .main-foot {
    height: 149px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 667px;
      height: 64px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #00233e;
      line-height: 36px;
    }
  }
}

/deep/ .payClass1 {
  .el-dialog {
    min-width: 800px;
  }

  .okTranslate {
    color: #ffffff !important;
    border-color: var(--primary) !important;
    background: var(--primary) !important;
  }

  .el-dialog__footer {
    padding: 10px 30px 20px !important;
    line-height: 41px;
  }

  .el-dialog__body {
    padding: 30px 30px !important;
  }

  .el-dialog__header {
    padding: 20px 30px 10px !important;
    line-height: 50px;
  }
}

/deep/ .payClass2 {
  .el-dialog {
    width: 600px;
  }

  .el-dialog__footer {
    padding: 10px 30px 20px !important;
    line-height: 41px;
  }

  .el-dialog__body {
    padding: 10px 30px !important;
  }

  .el-dialog__header {
    padding: 5px 30px 10px !important;
    line-height: 50px;
  }
}

/deep/ .dialog-title {
  text-align: left;
  width: 100%;
  margin-bottom: 30px;

  .el-form--inline .el-form-item,
  .el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: baseline;
    margin: 0;
    padding: 0;
  }
}

.demo-form-inline {
  float: left;
}

.okTranslate.convert-order-action {
  border-color: var(--primary-dark);
  background: var(--primary-dark);
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.18);
  transition: border-color 0.16s ease, background-color 0.16s ease, box-shadow 0.16s ease;
}

.okTranslate.convert-order-action:hover,
.okTranslate.convert-order-action:focus {
  border-color: var(--primary);
  background: var(--primary);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

/deep/ .borderSelect {
  .el-input--suffix .el-input__inner {
    border: 0;
    width: 125px;
    font-size: 16px;
    font-family: Noto Sans S Chinese;
    font-weight: 400;
    color: #333333;
  }

  .el-input__suffix {
    right: 0px;
  }
}

/deep/ .borderNewSelect {
  .el-select {
    width: 150px !important;
  }
}

.borderNewSelect2 {
  .el-select {
    width: 115px !important;
  }

  .el-select {
    background: var(--primary-alpha-08);
    border-radius: 4px;

    /deep/ .el-input {
      border-radius: 4px;
    }

    /deep/ .el-input__inner {
      background: var(--primary-alpha-08);
      border: none;
      border-radius: 4px;
    }
  }
}

/deep/ .borderNewSelect3 {
  .el-select {
    width: 120px !important;
  }
}

/deep/ .query {
  .el-input-group__append {
    background-color: #10b981;
    color: #fff;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
  }
}

.left-yijian-wx {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 55px;
  right: 0;
  font-family: "Microsoft YaHei";
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #eaeaea;
}

.left-yijian-qq {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 105px;
  right: 0;
  font-family: "Microsoft YaHei";
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #eaeaea;
}

.left-yijian {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 166px;
  right: 0;
  font-family: "Microsoft YaHei";
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
}

.active-lab {
  background: var(--primary-dark) !important;
  color: #f5f5f5 !important;
  z-index: 1 !important;
}

/deep/ .new-el-upload-mdjy-display {
  .el-upload {
    display: none;
  }
}

.new-el-upload-mdjy-none {
  //background-color: #f5f5f5;
  //border: 1px dashed #cccccc;
  //width: 350px;
  //height: 224px;
  display: inline-block;
  text-align: center;
  //padding-top: 20px;
}

.mains {
  min-width: 1250px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  //background: url("../assets/img/trans1.jpg") #F5F5F5 no-repeat center top;
  background-size: 100% 1080px;

  .header {
    display: flex;
    width: 1200px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 80px;

    .header-left {
      display: flex;
      width: 135px;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
    }

    .header-right {
      display: flex;
      flex: 1;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;

      .title_hide {
      }

      div:nth-child(3) {
        height: 30px;
        width: 68px;
        background-color: var(--primary-dark);
        border-radius: 3px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-right: 10px;
        cursor: pointer;
      }

      div:nth-child(4) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-right: 10px;
        margin-left: 10px;
        cursor: pointer;
      }

      div:nth-child(5) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #dddddd;
        cursor: pointer;
      }

      div:nth-child(7) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
      }

      div:nth-child(6) {
        height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
        margin-right: 10px;

        .el-button--text {
          color: #333333;
        }
      }

      div:nth-child(3):hover {
        background-color: #1565dc;
      }
    }
  }

  .line-hr {
    display: flex;
    width: 100%;
    height: 1px;
    background: #dddddd;
    border: 0;
  }

  .nav {
    display: flex;
    width: 100%;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 58px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    cursor: pointer;
    //background: #ffffff;
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;

    .nav-border {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      height: 56px;
      background: #e6e6e6;

      div {
        display: flex;
        width: 1200px;
        justify-content: flex-start;
        align-items: center;

        label {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-items: center;
          width: 10%;
          cursor: pointer;

          .index {
            display: flex;
            width: 64px;
            height: 58px;
            color: #0049b9;
            border-bottom: 2px solid #0049b9;
            justify-content: center;
            align-items: center;
            padding: 0;
          }

          div:nth-child(1):hover {
            width: 38px;
            height: 58px;
            color: #0049b9;
            border-bottom: 2px solid #0049b9;
            justify-content: center;
            align-items: center;
          }
        }

        label:nth-child(1) {
          width: 7%;
        }

        label:nth-child(2) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            color: #0049b9;
            border-bottom: 2px solid #0049b9;
          }
        }

        label:nth-child(3) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            color: #0049b9;
            border-bottom: 2px solid #0049b9;
          }
        }

        label:nth-child(4) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            color: #0049b9;
            border-bottom: 2px solid #0049b9;
          }
        }

        label:nth-child(5) {
          div:nth-child(1):hover {
            width: 64px;
            height: 58px;
            color: #0049b9;
            border-bottom: 2px solid #0049b9;
          }
        }
      }
    }
  }

  /deep/ .tip-alert {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;

    .el-alert.is-center {
      background: #ffe4cc !important;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffa557;
      height: 37px;
    }
  }

  .title {
    display: flex;
    width: 100%;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 31px;
    margin-bottom: 54px;
    font-size: 36px;
    font-family: "Source Han Sans CN";
    font-weight: bold;
    color: #373737;
    cursor: pointer;

    div {
      display: flex;
      width: 1200px;
      justify-content: center;
      align-items: center;
    }
  }

  .check-lab {
    margin-top: 60px;
    display: flex;
    width: 100%;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    min-height: 860px;

    .lab {
      display: flex;
      width: 1200px;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-bottom: 40px;

      div {
        justify-content: center;
        align-items: center;
        display: flex;
        width: 260px;
        height: 48px;
        font-size: 18px;
        font-family: "Source Han Sans CN";
        font-weight: 400;
        background: white;
        border-radius: 26px 0px 26px 0px;
        cursor: pointer;
        color: #333333;
      }

      div:nth-child(2) {
        margin: 0px -30px;
      }
    }

    .uploads {
      display: flex;
      width: 1200px;
      min-height: 770px;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background: white;

      .uploads-main {
        display: flex;
        width: 1200px;
        min-height: 720px;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        .new-form-jy {
          display: flex;
          width: 1200px;
          height: 60px;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          font-family: "Source Han Sans CN";
          font-size: 14px;
          color: #333333;
          border-bottom: 1px solid #dddddd;

          div {
            display: flex;
            width: 1170px;
            align-items: center;
            justify-content: center;
            margin-bottom: 13px;

            div {
              display: flex;
              width: 100%;
              align-items: center;
              justify-content: space-around;
            }

            div:nth-child(2) {
              width: 80%;
            }
          }
        }

        /deep/ .new-upload-demo {
          display: flex;
          width: 100%;
          justify-content: center;
          align-items: center;

          .el-upload-dragger {
            height: 281px;
            width: 1075px;
            border: 2px dashed #d9d9d9;

            .new-el-upload-mdjy {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              height: 100%;
              line-height: 30px;
              cursor: pointer;

              .content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .el-upload-titjy {
                  font-family: "Microsoft YaHei";
                  font-weight: 400;
                  font-size: 16px;
                  color: #333333;
                }

                .scbncg {
                  font-family: "Microsoft YaHei";
                  font-weight: 400;
                }

                .uptitle {
                  margin-top: 40px;
                  font-family: "Source Han Sans CN";
                  font-weight: 400;
                  font-size: 18px;
                  display: flex;
                  width: 260px;
                  height: 48px;
                  align-items: center;
                  justify-content: center;
                  background: var(--primary-dark);
                  border-radius: 26px 0px 26px 0px;
                  color: #f5f5f5;
                }
              }
            }
          }

          .el-upload-list {
            margin-bottom: 30px !important;

            .el-upload-list__item {
              text-align: left;
              transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
              font-size: 14px;
              color: #606266;
              line-height: 1.8;
              margin-top: 20px;
              position: relative;
              box-sizing: border-box;
              border-radius: 4px;
              width: 300px;

              .el-icon-document {
                position: absolute;
                margin-left: -49px;
                margin-top: -2.5px;
                font-size: 26px;
                color: #bebebe;
              }

              .el-progress-bar__outer {
                height: 7px !important;
              }

              .el-progress-bar__inner {
                background-color: #4dbe92 !important;
              }

              .el-icon-upload-success {
                color: #67c23a;
                position: absolute;
                margin-left: 19px;
                margin-top: 7.5px;
                font-size: 26px;
              }
            }
          }
        }

        /deep/ .new-upload-demo2 {
          display: flex;
          width: 100%;
          justify-content: center;
          align-items: center;

          .el-upload-dragger {
            height: 281px;
            width: 1075px;
            border: 2px dashed #d9d9d9;

            .new-el-upload-mdjy {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              height: 100%;
              line-height: 30px;
              cursor: pointer;

              .content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .el-upload-titjy {
                  font-family: "Microsoft YaHei";
                  font-weight: 400;
                  font-size: 16px;
                  color: #333333;
                }

                .scbncg {
                  font-family: "Microsoft YaHei";
                  font-weight: 400;
                }

                .uptitle {
                  margin-top: 40px;
                  font-family: "Source Han Sans CN";
                  font-weight: 400;
                  font-size: 18px;
                  display: flex;
                  width: 260px;
                  height: 48px;
                  align-items: center;
                  justify-content: center;
                  background: var(--primary-dark);
                  border-radius: 26px 0px 26px 0px;
                  color: #f5f5f5;
                }
              }
            }
          }

          .el-upload-list {
            margin-bottom: 30px !important;

            .el-upload-list__item {
              text-align: left;
              transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
              font-size: 14px;
              color: #606266;
              line-height: 1.8;
              margin-top: 20px;
              position: relative;
              box-sizing: border-box;
              border-radius: 4px;
              width: 300px;

              .el-icon-document {
                position: absolute;
                margin-left: -49px;
                margin-top: -2.5px;
                font-size: 26px;
                color: #bebebe;
              }

              .el-progress-bar__outer {
                height: 7px !important;
              }

              .el-progress-bar__inner {
                background-color: #4dbe92 !important;
              }

              .el-icon-upload-success {
                color: #67c23a;
                position: absolute;
                margin-left: 19px;
                margin-top: 7.5px;
                font-size: 26px;
              }
            }
          }
        }

        /deep/ .new-el-upload-manjy {
          width: 560px;
          margin-bottom: 40px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .el-divider.el-divider--horizontal {
            width: 470px;
            margin: 0;

            .el-divider__text.is-center {
              font-size: 16px;
              font-family: "Microsoft YaHei";
              color: #999999;
            }
          }
        }

        .list {
          margin-top: 45px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          width: 90%;

          div {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #999999;

            span {
              margin-top: 10px;
            }
          }
        }

        .text-input {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          /deep/ .originaltext {
            width: 600px;

            .el-textarea__inner {
              border: 0;
            }
          }
        }
      }
    }
  }

  .active {
    color: var(--primary-dark) !important;
  }

  /deep/ .languages {
    width: 66px;
    padding: 0px 15px;
    float: left;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    overflow: hidden;
    cursor: pointer;

    .el-input__suffix {
      background: url("../assets/img/sanjiao.png") no-repeat;
      transform: translate(15px, 18px);
    }

    .el-icon-arrow-up:before {
      content: "";
    }

    .el-input__icon:after {
      content: "";
    }

    .el-input__inner {
      width: 0 !important;
      border: 0;
      padding: 0;
      margin: 0;
    }
  }

  /deep/ .openlanguages {
    width: 66px;
    padding: 0px 15px;
    float: left;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    overflow: hidden;
    cursor: pointer;

    .el-input__inner {
      width: 0 !important;
      border: 0;
      padding: 0;
      margin: 0;
    }
  }

  .foot {
    display: flex;
    width: 100%;
    background: #f5f5f5;
    height: 80px;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #dddddd;
    flex-flow: column;

    span {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #00233e;
      line-height: 28px;
    }
  }
}

/* 图片翻译上传区：统一绿色主题变量，上传、校验与翻译事件保持原样。 */
.workspace-fullscreen-page.workspace-mode-img .image-workbench-output {
  display: flex;
  align-items: center;
  min-width: 0;
  margin-left: 20px;
}

.workspace-fullscreen-page.workspace-mode-img .image-workbench-output-label {
  color: var(--foreground);
  margin-right: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 32px;
  white-space: nowrap;
}

.workspace-fullscreen-page.workspace-mode-img .image-output-switch {
  display: inline-flex;
  align-items: center;
  gap: 0;

  .switch-item {
    padding: 8px 20px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    color: var(--muted-foreground);
    background: var(--bg-card);
    border: 1px solid var(--border);
    position: relative;
    transition: background-color .15s, color .15s, border-color .15s;

    &.active {
      background: var(--primary);
      color: #ffffff;
      border-color: var(--primary);
      z-index: 9;
    }

    &:first-child {
      border-radius: var(--radius-xl) 0 0 var(--radius-xl);
      border-right: none;
    }

    &:last-child {
      border-radius: 0 var(--radius-xl) var(--radius-xl) 0;
    }
  }
}

.workspace-fullscreen-page.workspace-mode-img .image-upload-section {
  background: transparent;
  box-shadow: none !important;
}

.workspace-fullscreen-page.workspace-mode-img .image-upload-dropzone .text_21 {
  color: var(--foreground) !important;
}

.workspace-fullscreen-page.workspace-mode-img .image-upload-dropzone .text_22 {
  color: var(--muted-foreground) !important;
}

.workspace-fullscreen-page.workspace-mode-img .image-upload-size-limit {
  color: var(--primary) !important;
  font-weight: 600;
}

.workspace-fullscreen-page.workspace-mode-img .image-upload-button {
  background: var(--primary-dark) !important;
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.18);
  transition: background-color 0.16s ease, box-shadow 0.16s ease, opacity 0.16s ease;
}

.workspace-fullscreen-page.workspace-mode-img /deep/ .el-upload-dragger:hover .image-upload-button,
.workspace-fullscreen-page.workspace-mode-img /deep/ .el-upload-dragger:focus-within .image-upload-button {
  background: var(--primary) !important;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.workspace-fullscreen-page.workspace-mode-img /deep/ .el-upload.is-disabled .image-upload-button {
  opacity: 0.55;
}

.workspace-fullscreen-page.workspace-mode-img .image-upload-help {
  color: var(--muted-foreground) !important;
}

.workspace-fullscreen-page.workspace-mode-img .image-upload-help > div:first-child {
  color: var(--primary-dark);
  font-weight: 600;
}

.workspace-fullscreen-page.workspace-mode-img .image-upload-section .box_11 > .text_15 {
  color: var(--primary-dark) !important;
}

.workspace-fullscreen-page.workspace-mode-img .image-upload-section .box_11 > .group_4 {
  background-color: var(--primary-alpha-08) !important;
}

.workspace-fullscreen-page.workspace-mode-img .image-upload-section .box_11 > .group_4 > .block_6,
.workspace-fullscreen-page.workspace-mode-img .image-upload-section .text-wrapper_8 {
  background-color: var(--primary) !important;
}

/* 文档转换沿用首页蓝色主题，上传、列表与转换事件保持原样。 */
.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-title {
  color: var(--primary-dark) !important;
  font-weight: 500 !important;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card {
  border: 1px solid #dce4e7;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08) !important;
}

/* 上传框风格对齐 img 模式：dragger 作为白底灰色虚线卡片 */
.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card /deep/ .new-upload-demo {
  flex: 0 0 auto;
  width: calc(100% - 60px) !important;
  cursor: pointer;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card /deep/ .new-upload-demo .el-upload {
  width: 100%;
  height: 100%;
  background: transparent !important;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card /deep/ .el-upload-dragger {
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
  max-width: none !important;
  padding: 20px 32px 16px;
  background: var(--bg-card) !important;
  border: 2px dashed #c0c4cc !important;
  border-radius: 16px !important;
  box-sizing: border-box;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden !important;
  transition: border-color 0.16s ease, box-shadow 0.16s ease;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card /deep/ .el-upload-dragger:hover {
  border-color: var(--primary) !important;
  box-shadow: 0 0 0 2px var(--primary-alpha-08) !important;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card /deep/ .el-upload-dragger .block_3 {
  height: 100% !important;
  width: 100% !important;
  margin-top: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  background: transparent !important;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card /deep/ .el-upload-dragger .block_3 > .convert-workspace-dropzone {
  width: 100% !important;
  max-width: none !important;
  height: auto !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  background: transparent !important;
  border: none !important;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .convert-workspace-dropzone .text_21 {
  color: var(--foreground) !important;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-links,
.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-link {
  color: var(--foreground) !important;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-link {
  cursor: pointer;
  transition: color 0.16s ease;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-link:hover {
  color: var(--primary-dark) !important;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-link-icon {
  display: none !important;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-primary {
  background: var(--primary-dark) !important;
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.18);
  transition: background-color 0.16s ease, box-shadow 0.16s ease, opacity 0.16s ease;
}

.workspace-fullscreen-page.workspace-mode-convert /deep/ .el-upload-dragger:hover .convert-workspace-primary,
.workspace-fullscreen-page.workspace-mode-convert /deep/ .el-upload-dragger:focus-within .convert-workspace-primary {
  background: var(--primary) !important;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.workspace-fullscreen-page.workspace-mode-convert /deep/ .el-upload.is-disabled .convert-workspace-primary {
  opacity: 0.55;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-help {
  color: #5f7186 !important;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-help > div:first-child {
  color: var(--primary-dark);
  font-weight: 600;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .box_11 > .text_15 {
  color: var(--primary-dark) !important;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .box_11 > .group_4 {
  background-color: #e4eef9 !important;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .box_11 > .group_4 > .block_6 {
  background-color: var(--primary) !important;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .group_11 .item {
  border-color: #dce4e7 !important;
  transition: background-color 0.16s ease, border-color 0.16s ease;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .group_11 .item:hover {
  border-color: var(--primary) !important;
  background: #f8fbff;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-file-type {
  padding: 0 8px;
  color: #909399 !important;
  background: #f4f4f5 !important;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-submit {
  background: var(--primary) !important;
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.16);
  transition: background-color 0.16s ease, box-shadow 0.16s ease;
}

.workspace-fullscreen-page.workspace-mode-convert .convert-workspace-submit:hover {
  background: var(--primary-dark) !important;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

/* 术语词库沿用首页蓝色主题，检索、分页与 AI 会话事件保持原样。 */
.workspace-fullscreen-page.workspace-mode-setting /deep/ .terminology-toolbar .query .el-input-group__append {
  border-color: var(--primary-dark) !important;
  background-color: var(--primary-dark) !important;
  transition: border-color 0.16s ease, background-color 0.16s ease;
}

.workspace-fullscreen-page.workspace-mode-setting /deep/ .terminology-toolbar .query .el-input-group__append:hover {
  border-color: var(--primary) !important;
  background-color: var(--primary) !important;
}

.workspace-fullscreen-page.workspace-mode-setting /deep/ .terminology-toolbar .el-input__inner:focus,
.workspace-fullscreen-page.workspace-mode-setting /deep/ .terminology-toolbar .el-select .el-input.is-focus .el-input__inner {
  border-color: var(--primary) !important;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-count {
  color: var(--primary) !important;
  font-weight: 600;
}

/* ===== 术语词库列表 — 对齐文档上传列表风格 ===== */
/* 列表区撑满工作台：span 关闭外层滚动，section/shell/card 逐级 flex 撑满 */
.workspace-fullscreen-page.workspace-mode-setting .box_5 > span:not(.text-workbench-content) {
  align-items: stretch;
  overflow: hidden;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-table-section {
  display: flex;
  flex: 1 1 auto;
  align-items: stretch;
  width: 100% !important;
  max-width: none !important;
  height: 100% !important;
  min-width: 0;
  min-height: 0;
  margin: 0 !important;
  padding: 0;
  background: transparent;
  box-shadow: none !important;
  box-sizing: border-box;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-list-shell {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: stretch;
  width: 100% !important;
  max-width: none !important;
  height: 100% !important;
  min-width: 0;
  min-height: 0;
  margin: 0 !important;
  box-sizing: border-box;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-list-card {
  --terminology-grid: minmax(200px, 1fr) minmax(280px, 1.4fr);
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: stretch;
  width: 100% !important;
  max-width: none !important;
  height: 100% !important;
  min-width: 0;
  min-height: 0;
  margin: 0 !important;
  padding: 0;
  overflow: hidden;
  border: 1px solid #dcdfe6;
  border-radius: var(--radius-lg);
  background: #ffffff;
  box-sizing: border-box;
}

/* 表头 */
.workspace-fullscreen-page.workspace-mode-setting .terminology-list-header {
  flex: 0 0 46px;
  display: flex;
  align-items: stretch;
  width: 100% !important;
  height: 46px !important;
  margin: 0 !important;
  padding: 0 !important;
  border-bottom: 1px solid #ebeef5;
  background: #f5f7fa;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-list-header .text_16 {
  display: grid !important;
  grid-template-columns: var(--terminology-grid);
  align-items: center;
  width: 100% !important;
  height: 46px !important;
  margin: 0 !important;
  padding: 0 24px;
  box-sizing: border-box;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-list-header .text_16 > div {
  color: #303133;
  font-size: 13px;
  font-weight: 600;
  text-align: left;
}

/* 列表 */
.workspace-fullscreen-page.workspace-mode-setting .terminology-list {
  flex: 1 1 auto;
  width: 100% !important;
  max-width: none !important;
  max-height: none !important;
  min-height: 0;
  margin: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(16, 185, 129, 0.28) transparent;
}

/* 列表行 */
.workspace-fullscreen-page.workspace-mode-setting .terminology-list-row {
  display: grid !important;
  grid-template-columns: var(--terminology-grid);
  align-items: center;
  width: 100% !important;
  min-height: 56px;
  margin: 0 !important;
  padding: 0 24px !important;
  box-sizing: border-box;
  border-bottom: 1px solid #ebeef5;
  transition: background-color 0.16s ease;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-list-row:last-of-type {
  border-bottom: none;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-list-row:hover {
  background: var(--primary-alpha-05);
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-list-row .terminology-cell {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  cursor: pointer;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-list-row .terminology-cell-value {
  flex: 1 1 auto;
  display: block;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 0.16s ease;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-list-row .terminology-cell:hover .terminology-cell-value {
  color: var(--primary);
}

/* 分页 */
.workspace-fullscreen-page.workspace-mode-setting .terminology-pagination {
  height: auto;
  margin-top: 24px;
  font-size: 12px;
  color: #5f7186;
  display: flex;
  justify-content: center;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-ai-shell {
  background: #f8fbff !important;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18) !important;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-ai-header,
.workspace-fullscreen-page.workspace-mode-setting .terminology-ai-question,
.workspace-fullscreen-page.workspace-mode-setting .terminology-ai-action {
  background: var(--primary-dark) !important;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-ai-action {
  transition: background-color 0.16s ease;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-ai-action:hover {
  background: var(--primary) !important;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-ai-answer {
  border-color: #9bb7d8 !important;
  background: #ffffff !important;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-ai-new-chat {
  border-color: var(--primary) !important;
  transition: background-color 0.16s ease, border-color 0.16s ease;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-ai-new-chat:hover {
  border-color: var(--primary-dark) !important;
  background: #f0f6ff !important;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-ai-new-chat > span,
.workspace-fullscreen-page.workspace-mode-setting .terminology-ai-history-title {
  color: var(--primary-dark) !important;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-ai-divider {
  border-color: #dce4e7 !important;
  background: #dce4e7 !important;
}

.workspace-fullscreen-page.workspace-mode-setting .terminology-ai-panel /deep/ .shuru .el-textarea__inner:focus {
  border-color: var(--primary) !important;
}

/* 翻译功能桌面工作台：通用外壳全屏，文本模式保留专属双栏规则。 */
@media (min-width: 768.01px) {
  /* 全局：语言选择器文字宽度自适应 */
  .text-wrapper_1 .text_6,
  .text-wrapper_1 .text_8 {
    width: auto !important;
    min-width: 90px !important;
  }

  /* 语言选择器：左侧统一为右侧样式 */
  .image-wrapper_1 .text-wrapper_1 {
    padding: 6px 12px !important;
    border: 1px solid var(--border) !important;
    border-radius: var(--radius-lg) !important;
    background: #fff !important;
    min-width: 110px !important;
    transition: border-color .15s, box-shadow .15s;
  }
  .image-wrapper_1 .text-wrapper_1:hover {
    border-color: var(--primary) !important;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, .1) !important;
  }
  .image-wrapper_1 .text-wrapper_1 .text_6 {
    width: auto !important;
    height: auto !important;
    color: rgba(102, 102, 102, 1) !important;
    font-size: 14px !important;
    line-height: 24px !important;
  }
  .image-wrapper_1 .thumbnail_5 {
    vertical-align: unset !important;
  }

  .new-upload-site-shell.workspace-fullscreen-page {
    height: 100vh;
    height: 100dvh;
    min-height: 640px;
    overflow: hidden;
    background: #f5f7fa;
  }

  .workspace-fullscreen-page > div:first-child,
  .workspace-fullscreen-page .page,
  .workspace-fullscreen-page .group_1,
  .workspace-fullscreen-page .box_1 {
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
  }

  .workspace-fullscreen-page .page {
    overflow: hidden;
  }

  .workspace-fullscreen-page .group_1,
  .workspace-fullscreen-page .box_1 {
    background: #f5f7fa;
  }

  .workspace-fullscreen-page .box_1 {
    justify-content: flex-start !important;
    margin: 0;
  }

  .workspace-fullscreen-page .translate-site-footer {
    display: block;
    flex: 0 0 64px;
    width: 100%;
    min-height: 64px;
    margin-top: 0;
    position: relative;
    z-index: 20;
  }

  .workspace-fullscreen-page .group_3 {
    flex: 1 1 auto;
    align-items: stretch;
    width: 100%;
    min-width: 0;
    min-height: 0;
    margin: 0;
    overflow: hidden;
  }

  .workspace-fullscreen-page .new-container {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    width: 100%;
    min-width: 0;
    min-height: 0;
    margin: 0;
    padding: 0;
    overflow: visible;
    border-radius: 0;
    box-shadow: none;
  }

  .workspace-fullscreen-page .box_4 {
    position: relative;
    z-index: 12;
    display: flex;
    flex: 0 0 60px;
    align-items: center;
    width: calc(100% - 200px);
    height: 60px;
    min-width: 0;
    margin: 0 0 0 200px;
    background: #ffffff;
    border-bottom: 1px solid #e7eaed;
  }

  .text-fullscreen-page .text-workbench-toolbar {
    display: flex !important;
    flex: 1 1 auto;
    justify-content: space-between;
    width: 100% !important;
    min-width: 0;
    padding: 0 20px;
  }

  .text-fullscreen-page .text-workbench-language {
    margin-left: 0 !important;
  }

  .workspace-fullscreen-page .box_4 .block_1,
  .text-fullscreen-page .box_4 .hide-history {
    margin-right: 0;
    margin-left: auto !important;
  }

  .workspace-fullscreen-page .box_4 .divider {
    position: absolute;
    right: 0;
    bottom: -1px;
    left: 0;
    width: 100%;
    margin: 0;
  }

  .workspace-fullscreen-page /deep/ .lang-panel {
    width: 100% !important;
    max-width: 100%;
    border-radius: 0 0 10px 10px;
  }

  .workspace-fullscreen-page .box_5 {
    display: flex;
    flex: 1 1 auto;
    width: 100%;
    min-width: 0;
    min-height: 0;
    margin: 0;
  }

  .workspace-fullscreen-page .box_5 .section_1 {
    flex: 0 0 200px;
    width: 200px;
    height: calc(100% + 60px);
    min-height: 0;
    margin-top: -60px;
    overflow-x: hidden;
    overflow-y: auto;
    background: #ffffff;
    border-right: 1px solid #e7eaed;
  }

  .workspace-fullscreen-page .box_5 .section_1 .menu {
    width: 100%;
    min-height: 100%;
    margin: 0;
    padding: 18px 14px 24px;
  }

  .workspace-fullscreen-page .menu-type .title {
    margin: 8px 10px 12px;
    font-size: 16px;
    line-height: 24px;
  }

  .workspace-fullscreen-page .menu-type .menu-item {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 40px;
    margin-bottom: 4px;
    padding: 0 12px;
  }

  .workspace-fullscreen-page .menu-type .menu-item .menu-name {
    line-height: 40px;
  }

  /* 桌面工具侧栏：使用站点蓝色体系，并补齐 hover、focus 与按压反馈。 */
  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 {
    border-right-color: #dce4e7 !important;
    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    scrollbar-width: thin;
    scrollbar-color: rgba(16, 185, 129, 0.24) transparent;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1::-webkit-scrollbar {
    width: 5px;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1::-webkit-scrollbar-track {
    background: transparent;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgba(16, 185, 129, 0.24);
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu {
    padding: 14px 14px 24px !important;
    border-right: 0 !important;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type {
    width: 100% !important;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type + .menu-type {
    position: relative;
    margin-top: 8px;
    padding-top: 7px;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type + .menu-type::before {
    position: absolute;
    top: 0;
    right: 8px;
    left: 8px;
    height: 1px;
    background: #edf2f7;
    content: "";
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 12px 8px 8px !important;
    color: var(--primary-dark) !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    line-height: 20px !important;
    letter-spacing: 0.04em;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .title::before {
    flex: 0 0 3px;
    width: 3px;
    height: 14px;
    border-radius: 999px;
    background: var(--primary-gradient);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.22);
    content: "";
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item {
    position: relative;
    gap: 8px;
    width: 100% !important;
    min-width: 0;
    min-height: 42px !important;
    margin-bottom: 4px;
    padding: 0 8px !important;
    overflow: hidden;
    box-sizing: border-box;
    color: #425466;
    border: 1px solid transparent;
    border-radius: 9px;
    background: transparent;
    transition: color 0.16s ease, border-color 0.16s ease, background-color 0.16s ease, box-shadow 0.16s ease, filter 0.16s ease;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item .menu-icon {
    flex: 0 0 18px;
    width: 18px;
    height: 18px;
    margin: 0 !important;
    color: #7b8da1 !important;
    font-size: 16px !important;
    transition: color 0.16s ease;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item .menu-name {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    color: inherit !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 40px !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color 0.16s ease;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item::after {
    flex: 0 0 5px;
    width: 5px;
    height: 5px;
    margin-left: auto;
    opacity: 0;
    border-top: 1.5px solid currentColor;
    border-right: 1.5px solid currentColor;
    content: "";
    transform: rotate(45deg);
    transition: opacity 0.16s ease;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item:not(.active):hover,
  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item:not(.active):focus-visible {
    color: var(--primary-dark);
    border-color: rgba(16, 185, 129, .2);
    background: rgba(16, 185, 129, .08);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item:not(.active):hover .menu-icon,
  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item:not(.active):focus-visible .menu-icon {
    color: var(--primary);
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item:hover::after,
  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item:focus-visible::after,
  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item.active::after {
    opacity: 0.8;
    transform: rotate(45deg);
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item:focus-visible {
    outline: 2px solid rgba(16, 185, 129, 0.3);
    outline-offset: 1px;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item.active {
    color: #ffffff !important;
    border-color: transparent !important;
    border-radius: 9px !important;
    background: var(--primary-gradient) !important;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    font-weight: 600 !important;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item.active .menu-icon,
  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item.active .menu-name {
    color: #ffffff !important;
    font-weight: 600 !important;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item.active:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item:active {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
    filter: brightness(0.96);
  }

  @media (prefers-reduced-motion: reduce) {
    .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item,
    .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item .menu-icon,
    .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu .menu-type .menu-item::after {
      transition: none;
    }
  }

  .text-fullscreen-page .text-workbench-content {
    display: flex !important;
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
    min-height: 0;
  }

  .workspace-fullscreen-page .section_2 {
    display: flex;
    flex: 1 1 auto;
    align-items: stretch;
    width: 100% !important;
    height: 100%;
    min-width: 0;
    min-height: 0;
    margin: 0;
    overflow: hidden;
    background: #ffffff;
  }

  .text-fullscreen-page /deep/ .text_12 {
    display: flex;
    flex: 1 1 50%;
    flex-direction: column;
    width: auto;
    height: 100%;
    min-width: 0;
    min-height: 0;
    margin: 0;
    position: relative;
  }

  .text-fullscreen-page /deep/ .text_12 .el-textarea__inner {
    flex: 1 1 auto;
    width: 100%;
    height: 100% !important;
    min-height: 0;
    margin: 0;
    padding: 24px;
    border: 0 !important;
    border-radius: 0;
  }

  .text-fullscreen-page /deep/ .text_12 .el-input__count {
    position: absolute;
    right: 20px;
    bottom: 14px;
    margin: 0;
    padding: 2px 6px;
    background: rgba(255, 255, 255, 0.86);
  }

  .text-fullscreen-page .section_2 > .group_4 {
    display: flex;
    flex: 0 0 28px;
    align-items: center;
    width: 28px;
    height: 100%;
    margin: 0;
    padding-top: 22px;
    background: #ffffff;
  }

  .text-fullscreen-page .section_2 > .group_5 {
    flex: 1 1 50% !important;
    width: auto;
    height: 100%;
    min-width: 0;
    min-height: 0;
    margin: 0;
    padding: 24px;
    overflow: auto;
    border-left: 1px solid #e7eaed;
  }

  .text-fullscreen-page .text-workbench-content /deep/ .ai-history {
    flex: 0 0 270px;
    height: 100%;
    min-height: 0;
    margin-top: 0;
  }

  .text-fullscreen-page /deep/ .file-translate-entry {
    bottom: 40px;
    left: calc((100% - 298px) / 4);
    transform: translateX(-50%);
    width: calc((100% - 298px) / 2 - 48px);
    max-width: 460px;
  }

  .text-fullscreen-page /deep/ .file-translate-entry.full {
    left: calc((100% - 28px) / 4);
    width: calc(50% - 48px);
  }

  /* 覆盖旧版多层固定画布规则，避免其更高选择器权重恢复固定尺寸。 */
  .new-upload-site-shell.workspace-fullscreen-page .page .group_1 .box_1 .group_3 {
    width: 100% !important;
    min-width: 0 !important;
    min-height: 0 !important;
    margin: 0 !important;
  }

  .new-upload-site-shell.workspace-fullscreen-page .page .group_1 .box_1 {
    width: 100% !important;
    height: 100% !important;
    min-width: 0 !important;
    min-height: 0 !important;
    margin: 0 !important;
  }

  .new-upload-site-shell.workspace-fullscreen-page .page .group_1 .box_1 .group_3 .new-container {
    width: 100% !important;
    min-width: 0 !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .new-upload-site-shell.workspace-fullscreen-page .page .group_1 .box_1 .group_3 .new-container .box_4 {
    width: calc(100% - 200px) !important;
    height: 60px !important;
    min-width: 0 !important;
    margin: 0 0 0 200px !important;
  }

  .new-upload-site-shell.workspace-fullscreen-page .page .group_1 .box_1 .group_3 .new-container .box_5 {
    width: 100% !important;
    min-width: 0 !important;
    min-height: 0 !important;
    margin: 0 !important;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 {
    width: 200px !important;
    height: calc(100% + 60px) !important;
    min-height: 0 !important;
    margin-top: -60px !important;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_1 .menu {
    width: 100% !important;
    margin: 0 !important;
    padding: 14px 14px 24px !important;
  }

  .new-upload-site-shell.text-fullscreen-page .box_5 .text-workbench-content {
    display: flex !important;
    flex: 1 1 auto !important;
    width: auto !important;
    min-width: 0 !important;
    min-height: 0 !important;
  }

  .new-upload-site-shell.workspace-fullscreen-page .box_5 .section_2 {
    width: 100% !important;
    height: 100% !important;
    min-width: 0 !important;
    min-height: 0 !important;
    margin: 0 !important;
  }

  .new-upload-site-shell.text-fullscreen-page .box_5 /deep/ .text_12 {
    flex: 0 1 auto !important;
    width: calc((100% - 28px) / 2) !important;
    height: 100% !important;
    min-width: 0 !important;
    min-height: 0 !important;
    margin: 0 !important;
  }

  .new-upload-site-shell.text-fullscreen-page .box_5 /deep/ .text_12 .el-textarea__inner {
    margin: 0 !important;
    padding: 24px !important;
    line-height: 27px;
  }

  .new-upload-site-shell.text-fullscreen-page .box_5 .section_2 > .group_4 {
    width: 28px !important;
    height: 100% !important;
    margin: 0 !important;
  }

  .new-upload-site-shell.text-fullscreen-page .box_5 .section_2 > .group_5 {
    flex: 0 1 auto !important;
    width: calc((100% - 28px) / 2) !important;
    height: 100% !important;
    min-width: 0 !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 24px !important;
    line-height: 27px;
  }

  .new-upload-site-shell.text-fullscreen-page .box_5 .section_2.history-open /deep/ .text_12,
  .new-upload-site-shell.text-fullscreen-page .box_5 .section_2.history-open > .group_5 {
    width: calc((100% - 298px) / 2) !important;
  }

  /* 其它侧栏功能复用同一全屏框架，内部固定表单保持原比例并在工作区内滚动。 */
  .workspace-fullscreen-page .box_4 > div {
    flex: 1 1 auto;
    width: 100% !important;
    max-width: 100%;
    min-width: 0;
    height: 100%;
    margin-bottom: 0 !important;
    padding: 0 20px;
    box-sizing: border-box;
  }

  /* 仅文档翻译列表页 toolbar 去除左右内边距 */
  .workspace-fullscreen-page.workspace-mode-doc.doc-upload-list-page .box_4 > div {
    padding: 0 !important;
  }

  /* 统一各翻译模式 toolbar 左侧按钮组左对齐，去除额外缩进 */
  .workspace-fullscreen-page .doc-workbench-main,
  .workspace-fullscreen-page .image-workbench-language,
  .workspace-fullscreen-page .more-workbench-main {
    margin-left: 0 !important;
  }

  /* actions 取消固定 330px 宽与右对齐，按钮靠左排列 */
  .workspace-fullscreen-page .doc-workbench-actions,
  .workspace-fullscreen-page .image-workbench-actions,
  .workspace-fullscreen-page .more-workbench-actions {
    width: auto !important;
    justify-content: flex-start !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .box_4 > div > span {
    width: 100% !important;
    margin-left: 0 !important;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    align-items: center;
    width: auto !important;
    height: 100%;
    min-width: 0;
    min-height: 0;
    padding: 24px 30px;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_3,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_4,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_5,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_6 {
    width: 100% !important;
    max-width: 1200px;
    margin-right: auto !important;
    margin-left: auto !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) .demo-form-inline,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) .demo-form-inline > div,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) /deep/ .new-upload-demo,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) /deep/ .new-upload-demo .el-upload,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) /deep/ .new-upload-demo .el-upload-dragger {
    max-width: 100% !important;
  }

  /* ===== 文档/多语种/图片上传卡片 — 背景色放在父 span，确保虚线外区域覆盖完整 ===== */
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) {
    background-color: var(--bg-page) !important;
    overflow: visible !important;
  }

  .workspace-fullscreen-page .box_5 > span.more-translation-panel,
  .workspace-fullscreen-page .box_5 > span.image-translation-panel {
    background-color: var(--bg-page) !important;
  }

  .workspace-fullscreen-page .box_5 > span.more-translation-panel > .more-upload-section,
  .workspace-fullscreen-page .box_5 > span.image-translation-panel > .image-upload-section {
    background-color: transparent !important;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_3 {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background-color: transparent !important;
    height: auto !important;
    min-height: auto !important;
    padding: 40px 0 !important;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_3 /deep/ .el-upload-dragger {
    max-width: 720px !important;
    min-height: 380px !important;
    margin: 80px auto 0 auto !important;
    padding: 48px 40px 40px !important;
    background: var(--bg-card) !important;
    border: 2px dashed #c0c4cc !important;
    border-radius: 16px !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_3 .block_3 .image-wrapper_11,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_3 .block_3 .text-wrapper_4 {
    display: none !important;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_3 .doc-file-type-grid {
    display: flex !important;
    flex-wrap: wrap !important;
    align-items: flex-end !important;
    justify-content: center !important;
    gap: 24px !important;
    margin-bottom: 32px !important;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_3 .doc-file-type-item {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 8px !important;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_3 .doc-file-type-item > img {
    width: 24px !important;
    height: auto !important;
    margin: 0 !important;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_3 .doc-file-type-item > span {
    font-size: 12px !important;
    color: var(--foreground-secondary) !important;
    margin: 0 !important;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_3 .doc-upload-prompt {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 8px !important;
    margin: 0 0 8px 0 !important;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_3 .doc-upload-icon {
    width: 20px !important;
    height: 20px !important;
    margin: 0 !important;
    color: var(--primary);
    flex-shrink: 0;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_3 .text_21 {
    margin: 0 !important;
    width: auto !important;
    height: auto !important;
    line-height: 20px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    color: var(--foreground) !important;
    text-align: left !important;
    white-space: nowrap !important;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) > .section_3 .text_22 {
    margin: 0 auto !important;
    width: 100% !important;
    height: auto !important;
    white-space: normal !important;
    text-align: center !important;
    font-size: 13px !important;
    color: var(--muted-foreground) !important;
    line-height: 1.6 !important;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) .block_3 > div {
    max-width: calc(100% - 32px) !important;
  }

  /* 文档上传列表：解除旧版 1200px 画布与固定列宽，铺满侧栏右侧工作区。 */
  .workspace-fullscreen-page.workspace-mode-doc.doc-upload-list-page .box_5 > span:not(.text-workbench-content) {
    align-items: stretch;
    padding: 0 24px 20px;
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active {
    display: flex;
    flex: 1 1 auto;
    align-items: stretch;
    width: 100% !important;
    max-width: none !important;
    height: 100% !important;
    min-width: 0;
    min-height: 0;
    margin: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-list-shell,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-list-card {
    display: flex;
    flex: 1 1 auto;
    align-items: stretch;
    width: 100% !important;
    max-width: none !important;
    height: 100% !important;
    min-width: 0;
    min-height: 0;
    margin: 0 !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-list-card {
    --doc-upload-grid:
      32px minmax(280px, 2fr) 76px 64px minmax(150px, 1fr)
      minmax(110px, 0.75fr) 150px 28px 150px 32px;

    padding: 0;
    overflow: hidden;
    border: 1px solid #dcdfe6;
    border-radius: var(--radius-lg);
    background: #ffffff;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-list-header {
    flex: 0 0 46px;
    display: flex;
    align-items: stretch !important;
    justify-content: center;
    width: 100% !important;
    height: 46px !important;
    min-width: 0;
    min-height: 46px;
    margin: 0 !important;
    padding: 0 !important;
    position: relative;
    z-index: 2;
    border-bottom: 1px solid #ebeef5;
    background: #f5f7fa;
    box-shadow: none;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-list-header .text_16 {
    display: grid !important;
    grid-template-columns: var(--doc-upload-grid);
    align-items: center;
    align-content: stretch;
    width: 100% !important;
    height: 46px !important;
    min-height: 46px;
    min-width: 0;
    margin: 0 !important;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-list-header .text_16 > div {
    display: flex !important;
    align-items: center;
    justify-content: center;
    width: auto !important;
    height: 46px;
    min-width: 0;
    margin: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    overflow: hidden;
    color: #303133;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.02em;
    text-align: center !important;
    text-overflow: ellipsis;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-list-header .text_16 > div:nth-child(2) {
    justify-content: flex-start;
    padding-left: 32px;
    box-sizing: border-box;
    text-align: left !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-select-header {
    height: 16px;
    border-right: 1px solid #ebeef5;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-list {
    flex: 1 1 auto;
    width: 100% !important;
    max-width: none !important;
    max-height: none !important;
    min-width: 0;
    min-height: 0;
    margin: 0 !important;
    overflow-x: auto;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(16, 185, 129, 0.28) transparent;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-list /deep/ .el-checkbox-group {
    display: block;
    width: 100%;
    min-width: 1180px;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-list-item {
    display: grid !important;
    grid-template-columns: var(--doc-upload-grid);
    align-items: center;
    width: 100% !important;
    min-width: 1180px;
    min-height: 60px;
    margin: 0 !important;
    padding: 7px 20px !important;
    box-sizing: border-box;
    border-bottom: 1px solid #ebeef5;
    transition: background-color 0.16s ease;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-list-item:hover {
    background: var(--primary-alpha-05);
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-list-item > * {
    width: auto !important;
    min-width: 0;
    margin: 0 !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-file {
    display: flex;
    align-items: center;
    padding: 6px 14px 6px 0 !important;
    overflow: hidden;
    line-height: 18px;
    overflow-wrap: anywhere;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-file img {
    flex: 0 0 22px;
    width: 22px;
    height: 22px;
    margin-right: 10px !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-character,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-page,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-model,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-terminology,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-delete {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 8px !important;
    text-align: center;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-model {
    color: var(--primary) !important;
    cursor: pointer;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-language {
    width: 100% !important;
    padding: 0 4px !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-language /deep/ .el-select {
    width: 100% !important;
    margin: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-swap {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 0 !important;
    width: 28px !important;
    height: 40px !important;
    padding: 0 !important;
    background: transparent !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-swap img,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-delete img {
    cursor: pointer;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-submit {
    flex: 0 0 41px;
    width: 140px !important;
    height: 41px !important;
    margin: 18px auto !important;
    background: var(--primary) !important;
    border-radius: var(--radius-md) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
    cursor: pointer;
    transition: background .15s, box-shadow .15s;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active .doc-upload-submit:hover {
    background: var(--primary-dark) !important;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.24);
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-active /deep/ .el-empty {
    flex: 1 1 auto;
    justify-content: center;
  }

  /* 多语种翻译桌面工作区 — 居中卡片式上传区域，参照 image-upload 设计。 */
  .workspace-fullscreen-page .box_5 > span.more-translation-panel > .more-upload-section {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    height: auto !important;
    min-height: 0;
    margin: 0 !important;
    padding: 24px 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .workspace-fullscreen-page .box_5 > span.more-translation-panel > .more-upload-section > .demo-form-inline,
  .workspace-fullscreen-page .box_5 > span.more-translation-panel > .more-upload-section > .demo-form-inline > div {
    width: 100% !important;
    min-width: 0 !important;
    min-height: 0 !important;
    max-width: none !important;
    box-sizing: border-box;
    background: transparent !important;
  }

  .workspace-fullscreen-page .box_5 > span.more-translation-panel > .more-upload-section /deep/ .new-upload-demo {
    flex: 0 0 auto;
    width: calc(100% - 60px) !important;
    max-width: 680px !important;
    height: 200px !important;
    min-height: 200px !important;
    margin: 0 auto;
    cursor: pointer;
  }

  .workspace-fullscreen-page .box_5 > span.more-translation-panel > .more-upload-section /deep/ .new-upload-demo .el-upload {
    width: 100%;
    height: 100%;
    background: transparent !important;
  }

  .workspace-fullscreen-page .box_5 > span.more-translation-panel > .more-upload-section /deep/ .el-upload-dragger {
    width: 100% !important;
    height: 100% !important;
    min-height: 0 !important;
    max-width: none !important;
    padding: 20px 32px 16px;
    background: var(--bg-card) !important;
    border: 2px dashed #c0c4cc !important;
    border-radius: 16px !important;
    box-sizing: border-box;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    overflow: hidden !important;
    transition: border-color 0.16s ease, box-shadow 0.16s ease;
  }

  .workspace-fullscreen-page .box_5 > span.more-translation-panel > .more-upload-section /deep/ .el-upload-dragger:hover {
    border-color: var(--primary) !important;
    box-shadow: 0 0 0 2px var(--primary-alpha-08) !important;
  }

  .workspace-fullscreen-page .box_5 > span.more-translation-panel > .more-upload-section /deep/ .block_3 {
    height: 100% !important;
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    background: transparent !important;
  }

  .workspace-fullscreen-page .box_5 > span.more-translation-panel > .more-upload-section /deep/ .block_3 > .more-upload-dropzone {
    width: 100% !important;
    max-width: none !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    background: transparent !important;
    border: none !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-dropzone .text_21 {
    color: var(--foreground) !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-dropzone .text_22 {
    color: var(--primary) !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-button {
    flex: 0 0 41px;
    margin-top: 20px !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-help {
    flex: 0 0 auto;
    width: 100% !important;
    height: auto !important;
    margin: 16px 0 0 !important;
    padding: 0 4px;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-help > div:first-child {
    color: var(--primary-dark);
    font-weight: 600;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .box_11,
  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .box_7,
  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .group_11 {
    width: 100% !important;
    height: 100% !important;
    min-width: 0;
    max-width: none !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-shell {
    align-items: stretch !important;
    padding: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-card {
    --more-upload-grid: 32px minmax(320px, 1fr) 140px 48px;

    display: flex;
    flex: 1 1 auto;
    align-items: stretch;
    width: 100% !important;
    height: 100% !important;
    min-width: 0;
    min-height: 0;
    padding: 0;
    overflow: hidden;
    box-sizing: border-box;
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    background: var(--bg-card);
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-header {
    display: flex;
    flex: 0 0 46px;
    align-items: stretch !important;
    justify-content: center;
    width: 100% !important;
    height: 46px !important;
    min-width: 0;
    min-height: 46px;
    margin: 0 !important;
    padding: 0 !important;
    border-bottom: 1px solid var(--border);
    background: var(--bg-subtle);
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-columns {
    display: grid !important;
    grid-template-columns: var(--more-upload-grid);
    align-items: center;
    width: 100% !important;
    height: 46px !important;
    min-width: 0;
    min-height: 46px;
    margin: 0 !important;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-columns > div {
    display: flex !important;
    align-items: center;
    justify-content: center;
    width: auto !important;
    height: 46px;
    min-width: 0;
    margin: 0 !important;
    padding: 0 !important;
    color: var(--foreground-secondary);
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    text-align: center !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-columns > div:nth-child(2) {
    justify-content: flex-start;
    padding-left: 32px !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list {
    flex: 1 1 auto;
    width: 100% !important;
    max-width: none !important;
    max-height: none !important;
    min-width: 0;
    min-height: 0;
    margin: 0 !important;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list /deep/ .el-checkbox-group {
    display: block;
    width: 100%;
    min-width: 0;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-item {
    display: grid !important;
    grid-template-columns: var(--more-upload-grid);
    align-items: center;
    width: 100% !important;
    min-width: 0;
    min-height: 60px;
    margin: 0 !important;
    padding: 7px 20px !important;
    box-sizing: border-box;
    border-bottom: 1px solid var(--border-light);
    transition: background-color 0.16s ease;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-item:hover {
    background: var(--primary-alpha-05);
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-item > * {
    width: auto !important;
    min-width: 0;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-file {
    display: flex;
    align-items: center;
    padding-right: 14px !important;
    overflow: hidden;
    line-height: 18px;
    overflow-wrap: anywhere;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-file img {
    flex: 0 0 22px;
    width: 22px;
    height: 22px;
    margin-right: 10px;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-count,
  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-delete {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-delete img {
    cursor: pointer;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-submit {
    flex: 0 0 41px;
    width: 140px !important;
    height: 41px !important;
    margin: 18px auto !important;
    background: var(--primary) !important;
    border-radius: var(--radius-md) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
    cursor: pointer;
    transition: background .15s, box-shadow .15s;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-submit:hover {
    background: var(--primary-dark) !important;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.24);
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-list-card /deep/ .el-empty {
    flex: 1 1 auto;
    justify-content: center;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-help {
    flex: 0 0 auto;
    width: 100% !important;
    height: auto !important;
    margin: 16px 0 0 !important;
    padding: 0 4px;
    box-sizing: border-box;
  }

  /* 图片翻译桌面工作区：上传区虚线卡片，与文档翻译保持一致。 */
  .workspace-fullscreen-page .box_5 > span.image-translation-panel {
    flex: 1 1 auto;
    padding: 20px 24px;
  }

  .workspace-fullscreen-page .box_5 > span.image-translation-panel > .image-upload-section {
    justify-content: center !important;
    width: 100% !important;
    min-height: 0;
    margin: 0 !important;
    padding: 24px 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .workspace-fullscreen-page .box_5 > span.image-translation-panel > .image-upload-section > .demo-form-inline,
  .workspace-fullscreen-page .box_5 > span.image-translation-panel > .image-upload-section > .demo-form-inline > div {
    width: 100% !important;
    height: auto !important;
    min-width: 0 !important;
    min-height: 0 !important;
    max-width: none !important;
    box-sizing: border-box;
    background: transparent !important;
  }

  .workspace-fullscreen-page .box_5 > span.image-translation-panel > .image-upload-section /deep/ .new-upload-demo {
    flex: 0 0 auto;
    width: calc(100% - 60px) !important;
    max-width: 680px !important;
    height: 120px !important;
    min-height: 120px !important;
    margin: 0 auto;
    cursor: pointer;
  }

  .workspace-fullscreen-page .box_5 > span.image-translation-panel > .image-upload-section /deep/ .new-upload-demo .el-upload {
    width: 100%;
    height: 100%;
    background: transparent !important;
  }

  .workspace-fullscreen-page .box_5 > span.image-translation-panel > .image-upload-section /deep/ .el-upload-dragger {
    width: 100% !important;
    height: 100% !important;
    min-height: 0 !important;
    max-width: none !important;
    padding: 20px 32px 16px;
    background: var(--bg-card) !important;
    border: 2px dashed #c0c4cc !important;
    border-radius: 16px !important;
    box-sizing: border-box;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    overflow: hidden !important;
    transition: border-color 0.16s ease, box-shadow 0.16s ease;
  }

  .workspace-fullscreen-page .box_5 > span.image-translation-panel > .image-upload-section /deep/ .el-upload-dragger:hover {
    border-color: var(--primary) !important;
    box-shadow: 0 0 0 2px var(--primary-alpha-08) !important;
  }

  .workspace-fullscreen-page .box_5 > span.image-translation-panel > .image-upload-section /deep/ .block_3 {
    height: 100% !important;
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    background: transparent !important;
  }

  .workspace-fullscreen-page .box_5 > span.image-translation-panel > .image-upload-section /deep/ .block_3 > .image-upload-dropzone {
    width: 100% !important;
    max-width: none !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    background: transparent !important;
    border: none !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-button {
    flex: 0 0 41px;
    margin-top: 20px !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .box_11,
  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .box_7,
  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 {
    width: 100% !important;
    height: 100% !important;
    min-width: 0;
    max-width: none !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-shell {
    align-items: stretch !important;
    padding: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-card {
    --image-upload-grid:
      32px minmax(320px, 1fr) 80px 160px 28px 160px 48px;

    display: flex;
    flex: 1 1 auto;
    align-items: stretch;
    width: 100% !important;
    height: 100% !important;
    min-width: 0;
    min-height: 0;
    padding: 0;
    overflow: hidden;
    box-sizing: border-box;
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    background: var(--bg-card);
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-header {
    display: flex;
    flex: 0 0 46px;
    align-items: stretch !important;
    justify-content: center;
    width: 100% !important;
    height: 46px !important;
    min-width: 0;
    min-height: 46px;
    margin: 0 !important;
    padding: 0 !important;
    border-bottom: 1px solid var(--border);
    background: var(--bg-subtle);
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-columns {
    display: grid !important;
    grid-template-columns: var(--image-upload-grid);
    align-items: center;
    width: 100% !important;
    height: 46px !important;
    min-width: 0;
    min-height: 46px;
    margin: 0 !important;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-columns > div {
    display: flex !important;
    align-items: center;
    justify-content: center;
    width: auto !important;
    height: 46px;
    min-width: 0;
    margin: 0 !important;
    padding: 0 !important;
    color: var(--foreground-secondary);
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    text-align: center !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-columns > div:nth-child(2) {
    justify-content: flex-start;
    padding-left: 32px !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list {
    flex: 1 1 auto;
    width: 100% !important;
    max-width: none !important;
    max-height: none !important;
    min-width: 0;
    min-height: 0;
    margin: 0 !important;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list /deep/ .el-checkbox-group {
    display: block;
    width: 100%;
    min-width: 0;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-item {
    display: grid !important;
    grid-template-columns: var(--image-upload-grid);
    align-items: center;
    width: 100% !important;
    min-width: 0;
    min-height: 60px;
    margin: 0 !important;
    padding: 7px 20px !important;
    box-sizing: border-box;
    border-bottom: 1px solid var(--border-light);
    transition: background-color 0.16s ease;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-item:hover {
    background: var(--primary-alpha-05);
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-item > * {
    width: auto !important;
    min-width: 0;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-file {
    display: flex;
    align-items: center;
    padding-right: 14px !important;
    overflow: hidden;
    line-height: 18px;
    overflow-wrap: anywhere;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-file img {
    flex: 0 0 22px;
    width: 22px;
    height: 22px;
    margin-right: 10px;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-page,
  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-swap,
  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-delete {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-language {
    width: 100% !important;
    padding: 0 4px !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-language /deep/ .el-select {
    width: 100% !important;
    margin: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-swap {
    position: relative;
    z-index: 0;
    width: 28px !important;
    height: 40px !important;
    background: var(--border-light);
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-swap img,
  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-delete img {
    cursor: pointer;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-submit {
    flex: 0 0 41px;
    width: 140px !important;
    height: 41px !important;
    margin: 18px auto !important;
    background: var(--primary) !important;
    border-radius: var(--radius-md) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
    cursor: pointer;
    transition: background .15s, box-shadow .15s;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-submit:hover {
    background: var(--primary-dark) !important;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.24);
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-list-card /deep/ .el-empty {
    flex: 1 1 auto;
    justify-content: center;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-help {
    flex: 0 0 auto;
    width: 100% !important;
    height: auto !important;
    margin: 16px 0 0 !important;
    padding: 0 4px;
    box-sizing: border-box;
  }

  /* 文档转换桌面工作区铺满侧栏之外的全部可用空间。 */
  .workspace-fullscreen-page.workspace-mode-convert .box_5 > span.convert-workspace-panel {
    align-items: stretch;
    padding: 20px 24px;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-title {
    flex: 0 0 auto;
    width: 100% !important;
    max-width: none !important;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card {
    flex: 1 1 auto;
    align-items: stretch !important;
    width: 100% !important;
    max-width: none !important;
    height: auto !important;
    min-height: 360px;
    margin: 16px 0 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-links {
    flex: 0 0 auto;
    width: 100% !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 20px 24px 0;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .demo-form-inline,
  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .demo-form-inline > div,
  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .block_3 {
    width: 100% !important;
    min-width: 0;
    min-height: 0;
    max-width: none !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card /deep/ .new-upload-demo {
    width: calc(100% - 60px) !important;
    max-width: 680px !important;
    height: 120px !important;
    min-height: 120px !important;
    margin: 30px auto 0;
    cursor: pointer;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card /deep/ .new-upload-demo .el-upload,
  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card /deep/ .new-upload-demo .el-upload-dragger {
    width: 100% !important;
    height: 100% !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .block_3 {
    margin-top: 0 !important;
    padding: 16px 24px 24px;
  }

  .workspace-fullscreen-page.workspace-mode-convert .box_5 > span.convert-workspace-panel .convert-workspace-card .block_3 > .convert-workspace-dropzone {
    flex: 1 1 auto;
    width: 100% !important;
    height: auto !important;
    min-height: 0;
    max-width: none !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-primary {
    flex: 0 0 41px;
    margin-top: 20px !important;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .box_11,
  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .box_7,
  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .group_11 {
    width: 100% !important;
    height: auto !important;
    min-width: 0;
    max-width: 100% !important;
    max-height: none !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .group_11 .item {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert.convert-upload-list-page .convert-workspace-card {
    display: flex !important;
    flex-direction: column !important;
    height: calc(100% - 16px) !important;
    overflow: hidden;
  }

  /* 列表页强制隐藏上传表单，确保它不占空间影响列表区高度 */
  .workspace-fullscreen-page.workspace-mode-convert.convert-upload-list-page .convert-workspace-card > .demo-form-inline {
    display: none !important;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list-shell {
    display: flex !important;
    flex-direction: column;
    flex: 1 1 auto;
    align-items: stretch !important;
    width: 100% !important;
    height: auto !important;
    min-width: 0;
    min-height: 0;
    margin: 0 !important;
    padding: 24px;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list-card {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    align-items: stretch;
    width: 100% !important;
    min-width: 0;
    min-height: 0;
    margin: 0 !important;
    padding: 0;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100% !important;
    height: auto !important;
    max-width: none !important;
    max-height: none !important;
    min-width: 0;
    min-height: 0;
    padding: 0;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list /deep/ .el-checkbox-group {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 0;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list .convert-upload-list-item {
    display: grid !important;
    grid-template-columns: 32px minmax(280px, 1fr) minmax(110px, 0.18fr) 32px;
    align-items: center;
    width: 100% !important;
    max-width: none !important;
    min-height: 72px;
    margin: 0 0 12px !important;
    padding: 0 20px;
    border: 1px solid transparent !important;
    border-radius: 6px;
    box-sizing: border-box;
    transition: border-color 0.16s ease;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list .convert-upload-list-item:hover {
    border-color: var(--primary) !important;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list .convert-upload-list-item > label,
  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list .convert-upload-list-item > div {
    width: auto !important;
    min-width: 0;
    margin: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list-file {
    display: flex;
    align-items: center;
    gap: 12px;
    overflow: hidden;
    color: #465467;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list-file img {
    flex: 0 0 auto;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list .convert-workspace-file-type {
    display: flex;
    align-items: center;
    justify-content: center;
    justify-self: center;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list-delete {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list-delete img {
    cursor: pointer;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list-submit {
    flex: 0 0 41px;
    width: 160px !important;
    height: 41px !important;
    margin: 18px auto 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list-card /deep/ .el-empty {
    flex: 1 1 auto;
    justify-content: center;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-help {
    flex: 0 0 auto;
    width: 100% !important;
    max-width: none !important;
    height: auto !important;
    margin: 16px 0 0 !important;
    padding: 0 4px;
    box-sizing: border-box;
  }

  /* 网页翻译安装页沿用统一工作台骨架，长内容只在中间区域滚动。 */
  .workspace-fullscreen-page.workspace-mode-plugin {
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .page {
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .box_5 {
    min-height: 0 !important;
    overflow: hidden !important;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .box_5 > span.plugin-translation-panel {
    min-height: 0;
    align-items: stretch;
    padding: 20px 24px;
    overflow-x: hidden !important;
    overflow-y: auto !important;
  }

  /* 工具条标题：token 化 + 居左 */
  .workspace-fullscreen-page.workspace-mode-plugin .plugin-workbench-title {
    display: flex;
    margin-left: 0;
    align-items: center;
    position: relative;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-workbench-label {
    margin-left: 6px;
    font-size: 16px;
    font-weight: bold;
    color: var(--foreground-secondary);
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-workbench-new {
    position: absolute;
    top: -10px;
    right: -30px;
    width: 24px;
    height: auto;
  }

  /* 文字层次：标题黑、说明灰、小标题深色 */
  .workspace-fullscreen-page.workspace-mode-plugin .plugin-page-title {
    font-size: var(--text-2xl);
    font-weight: 600;
    line-height: 32px;
    text-align: center;
    color: var(--foreground);
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-page-description {
    margin-top: 12px;
    padding: 0 40px;
    font-size: var(--text-base);
    line-height: 28px;
    text-align: center;
    color: var(--muted-foreground);
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-browser-heading {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    font-size: var(--text-lg);
    font-weight: 600;
    line-height: 30px;
    text-align: center;
    color: var(--foreground);
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-version-badge {
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
    padding: 0 10px;
    height: 22px;
    font-size: var(--text-xs);
    font-weight: 500;
    line-height: 22px;
    border-radius: var(--radius-2xl);
    color: #6b7280;
    background: #f3f4f6;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-install-entry {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .box_5 > span.plugin-translation-panel > .plugin-page-title,
  .workspace-fullscreen-page.workspace-mode-plugin .box_5 > span.plugin-translation-panel > .plugin-page-description,
  .workspace-fullscreen-page.workspace-mode-plugin .box_5 > span.plugin-translation-panel > .plugin-browser-heading,
  .workspace-fullscreen-page.workspace-mode-plugin .box_5 > span.plugin-translation-panel > .plugin-install-entry,
  .workspace-fullscreen-page.workspace-mode-plugin .box_5 > span.plugin-translation-panel > .plugin-guide-section {
    width: 100% !important;
    max-width: none !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-install-entry {
    flex: 0 0 auto;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-guide-section {
    flex: 1 1 auto;
    align-items: stretch !important;
    min-height: 360px;
    margin: 16px 0 0 !important;
    padding-top: 20px;
    padding-bottom: 20px;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-guide-section /deep/ .install-guide {
    width: 100% !important;
    max-width: none !important;
    margin: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-guide-section /deep/ .guide-body {
    min-height: 360px;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-guide-section /deep/ .steps-panel {
    flex-basis: clamp(320px, 28%, 420px);
  }

  .workspace-fullscreen-page.workspace-mode-AITranslate .box_5 > span,
  .workspace-fullscreen-page.workspace-mode-polish .box_5 > span,
  .workspace-fullscreen-page.workspace-mode-aiPPT .box_5 > span {
    align-items: stretch;
    padding: 0;
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-aiPPT .box_5 > span {
    overflow: visible;
  }

  .workspace-fullscreen-page.workspace-mode-AITranslate /deep/ .ai-chat {
    width: 100%;
    height: 100% !important;
    margin-top: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-AITranslate /deep/ .ai-chat .chat-box {
    padding-bottom: 15px;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-AITranslate /deep/ .ai-chat .chat-editor {
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-AITranslate .box_5 > span,
  .workspace-fullscreen-page.workspace-mode-AITranslate .box_5 > span > .section_2 {
    overflow: visible;
  }

  .workspace-fullscreen-page.workspace-mode-AITranslate /deep/ .ai-chat .ai-history {
    position: relative;
    z-index: 13;
  }

  .workspace-fullscreen-page.workspace-mode-AITranslate /deep/ .ai-chat .ai-history > .new-chat {
    position: absolute;
    top: -48px;
    left: 18px;
    margin: 0;
  }

  .workspace-fullscreen-page.workspace-mode-AITranslate /deep/ .ai-chat .ai-history > .history-container {
    height: calc(100% - 33px);
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-polish /deep/ .polish {
    width: 100%;
    height: 100%;
  }

  .workspace-fullscreen-page.workspace-mode-polish .box_5 > span,
  .workspace-fullscreen-page.workspace-mode-polish .box_5 > span > .section_2 {
    overflow: visible;
  }

  .workspace-fullscreen-page.workspace-mode-polish /deep/ .polish .switch-lang {
    position: absolute;
    top: -60px;
    right: 0;
    left: 0;
    z-index: 13;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    margin-top: 0;
    pointer-events: auto;
  }

  .workspace-fullscreen-page.workspace-mode-polish /deep/ .polish .polish-container {
    height: 100% !important;
    min-height: 0;
    margin-top: 0;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-aiPPT .box_5 > span > .flex-row {
    flex: 1 1 auto;
    align-items: stretch;
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
  }

  /* 术语词库使用工作区的完整宽度，保留原检索、分页和 AI 助手交互。 */
  .workspace-fullscreen-page.workspace-mode-setting .box_4 > div > span {
    width: 100% !important;
    min-width: 0;
    margin-left: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-setting .box_5 > span:not(.text-workbench-content) {
    align-items: stretch;
  }

  .workspace-fullscreen-page.workspace-mode-setting .box_5 > span:not(.text-workbench-content) > .section_5 {
    max-width: none;
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-setting .section_5 .box_11,
  .workspace-fullscreen-page.workspace-mode-setting .section_5 .box_7,
  .workspace-fullscreen-page.workspace-mode-setting .section_5 .text-wrapper_4 {
    width: 100% !important;
    max-width: none !important;
  }

  /* 术语列表表头/行使用 terminology-list-* 的 grid 布局，此处仅重置基础固定尺寸 */
  .workspace-fullscreen-page.workspace-mode-setting .section_5 .text-wrapper_4 > .text_16 {
    width: 100% !important;
    margin: 0 !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-setting .section_5 .text-wrapper_4 > .text_16 > div {
    min-width: 0;
  }

  /* 文件列表语言选择器：el-select 外观调整为紧凑按钮 */
  .doc-upload-language {
    z-index: 10;
  }

  .doc-upload-language /deep/ .el-select {
    width: 100% !important;
  }

  .doc-upload-language /deep/ .el-input__inner {
    height: 32px !important;
    line-height: 32px !important;
    padding: 0 8px !important;
    border: 1px solid var(--border) !important;
    border-radius: var(--radius-md) !important;
    background: var(--bg-card) !important;
    font-size: 13px !important;
    color: var(--foreground) !important;
    cursor: pointer;
    transition: border-color .15s, box-shadow .15s;
  }

  .doc-upload-language /deep/ .el-input__inner:hover,
  .doc-upload-language /deep/ .el-input__inner:focus {
    border-color: var(--primary) !important;
    box-shadow: 0 0 0 2px var(--primary-alpha-10) !important;
  }

  .doc-upload-language /deep/ .el-input__suffix {
    right: 6px !important;
  }

  .doc-upload-language /deep/ .el-input__icon {
    line-height: 32px !important;
  }

}

.mobile-tool-selector,
.mobile-tool-overlay,
.mobile-text-panel-label,
.doc-file-type-grid {
  display: none;
}

/* 小屏工具工作台：取消桌面固定画布，导航横向滚动，工作区按单列展示。 */
@media (max-width: 768px) {
  .new-upload-site-shell.workspace-fullscreen-page {
    width: 100% !important;
    min-width: 0 !important;
    overflow-x: hidden;
    background: #f5f7fa;
  }

  .workspace-fullscreen-page > div:first-child,
  .workspace-fullscreen-page .page,
  .workspace-fullscreen-page .group_1,
  .workspace-fullscreen-page .box_1,
  .workspace-fullscreen-page .group_3,
  .workspace-fullscreen-page .new-container {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page .box_1 {
    justify-content: flex-start !important;
    margin: 0 !important;
  }

  .workspace-fullscreen-page .group_3 {
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0;
    align-items: stretch !important;
  }

  .workspace-fullscreen-page .new-container {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
    border-radius: 0;
    background: #ffffff;
  }

  .text-fullscreen-page .new-container {
    min-height: 0 !important;
  }

  .workspace-fullscreen-page .box_4 {
    order: 2;
    position: relative;
    z-index: 3;
    display: flex;
    align-items: center;
    width: 100% !important;
    height: auto !important;
    min-width: 0 !important;
    min-height: 68px;
    margin: 0 !important;
    padding: 8px 12px !important;
    overflow: visible !important;
    box-sizing: border-box;
    border-bottom: 1px solid #e7eaed;
    background: #ffffff;
  }

  .workspace-fullscreen-page .box_4 > div {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    margin: 0 !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-doc .box_4 {
    align-items: stretch;
    min-height: 0;
    padding: 12px !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-toolbar {
    display: flex !important;
    flex-direction: column;
    align-items: stretch !important;
    justify-content: flex-start !important;
    gap: 12px;
    width: 100% !important;
    min-width: 0;
    margin: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-main,
  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-actions {
    display: flex;
    flex: 1 1 auto !important;
    flex-wrap: wrap;
    align-items: center;
    width: 100% !important;
    min-width: 0;
    margin: 0 !important;
    gap: 10px !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-language {
    display: flex;
    flex: 0 1 auto !important;
    min-width: 0;
    height: auto !important;
    border: none !important;
    border-radius: 0 !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-language > div {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    width: 100%;
    min-width: 0;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-language .image-wrapper_1,
  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-language .image-wrapper_2 {
    flex: 0 1 auto;
    min-width: 0;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-language .text-wrapper_1 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    min-width: 80px;
    height: 36px;
    padding: 0 12px;
    border: 1px solid var(--border) !important;
    border-radius: var(--radius-lg) !important;
    background: var(--bg-card) !important;
    box-sizing: border-box;
    cursor: pointer;
    transition: border-color .15s, box-shadow .15s;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-language .text-wrapper_1:hover {
    border-color: var(--primary) !important;
    box-shadow: 0 0 0 2px var(--primary-alpha-10);
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-language .text_6,
  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-language .text_8 {
    width: auto !important;
    height: auto !important;
    min-width: 0 !important;
    max-width: calc(100% - 18px);
    overflow: hidden;
    line-height: 20px !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--foreground) !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-language .thumbnail_5,
  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-language .thumbnail_6 {
    width: 10px !important;
    height: 6px !important;
    margin: 0 0 0 6px !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-language .thumbnail_26 {
    flex: 0 0 18px;
    width: 18px;
    height: 18px;
    margin: 0 6px;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-model-entry {
    flex: 1 1 130px !important;
    min-width: 0;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-model-entry /deep/ .select-mode {
    width: 100%;
    max-width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-actions {
    justify-content: flex-start !important;
    min-height: 38px;
    padding: 3px;
    border: 1px solid #edf0f4;
    border-radius: 8px;
    background: #f8fafc;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-terminology-toggle {
    border: 0;
    background: transparent;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-actions > .btn-toolbar .text_5 {
    width: auto;
    height: auto !important;
    margin: 0 0 0 4px;
    line-height: 20px !important;
  }

  .workspace-fullscreen-page .box_4 .divider {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    margin: 0;
  }

  .text-fullscreen-page .text-workbench-toolbar {
    justify-content: space-between;
    gap: 0;
  }

  .text-fullscreen-page .text-workbench-language {
    position: relative;
    z-index: 1;
    flex: 1 1 auto;
    width: 100% !important;
    min-width: 0;
    height: 52px !important;
    margin-left: 0 !important;
    overflow: visible;
    border: 1px solid #e6eaf0;
    box-sizing: border-box;
    background: #f7f9fc !important;
  }

  .text-fullscreen-page .text-workbench-language .image-wrapper_1,
  .text-fullscreen-page .text-workbench-language .image-wrapper_2 {
    position: relative;
    flex: 1 1 0;
    min-width: 0;
    overflow: visible;
  }

  .text-fullscreen-page .text-workbench-language .text-wrapper_1 {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100% !important;
    min-width: 0;
    height: 52px;
    padding: 6px 28px !important;
    overflow: hidden;
    box-sizing: border-box;
    cursor: pointer;
    touch-action: manipulation;
  }

  .text-fullscreen-page .text-workbench-language .text_6,
  .text-fullscreen-page .text-workbench-language .text_8 {
    display: block;
    flex: 0 1 auto;
    width: auto !important;
    min-width: 0;
    max-width: 100%;
    overflow: visible !important;
    text-align: center !important;
    text-overflow: clip !important;
    font-size: 15px !important;
    line-height: 18px !important;
    overflow-wrap: anywhere;
    white-space: normal !important;
  }

  .text-fullscreen-page .text-workbench-language .thumbnail_5,
  .text-fullscreen-page .text-workbench-language .thumbnail_6 {
    position: absolute;
    top: 50%;
    right: 12px;
    display: block;
    flex: 0 0 10px;
    width: 10px;
    height: 6px;
    margin: 0;
    transform: translateY(-50%);
  }

  .text-fullscreen-page .text-workbench-language .thumbnail_26 {
    flex: 0 0 18px;
    width: 18px;
    height: 18px;
    margin: 0 8px;
  }

  .text-fullscreen-page .box_4 .block_1 {
    display: none !important;
  }

  .workspace-fullscreen-page .box_5 {
    display: contents;
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    margin: 0 !important;
  }

  .workspace-fullscreen-page .box_5 .section_1 {
    order: 1;
    position: relative;
    z-index: 2;
    flex: 0 0 auto;
    width: 100% !important;
    height: auto !important;
    min-width: 0 !important;
    margin: 0 !important;
    overflow: visible;
    border-right: 0;
    border-bottom: 1px solid #e7eaed;
    background: #ffffff;
  }

  .workspace-fullscreen-page .box_5 .section_1 .menu {
    display: none;
  }

  .workspace-fullscreen-page .box_5 .section_1 .menu::-webkit-scrollbar {
    display: none;
  }

  .workspace-fullscreen-page .mobile-tool-selector {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 58px;
    padding: 0 16px;
    border: 0;
    background: #ffffff;
    color: #1f2937;
    font-family: "Microsoft YaHei", sans-serif;
    text-align: left;
    cursor: pointer;
  }

  .workspace-fullscreen-page .mobile-tool-selector-main {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .workspace-fullscreen-page .mobile-tool-selector-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    margin-right: 10px;
    border-radius: 9px;
    background: var(--primary);
    color: #ffffff;
    font-size: 18px;
  }

  .workspace-fullscreen-page .mobile-tool-selector-copy {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .workspace-fullscreen-page .mobile-tool-selector-label {
    margin-bottom: 2px;
    color: #8a94a3;
    font-size: 10px;
    line-height: 14px;
  }

  .workspace-fullscreen-page .mobile-tool-selector-name {
    overflow: hidden;
    color: #1f2937;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .workspace-fullscreen-page .mobile-tool-selector-action {
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
    gap: 5px;
    color: var(--foreground);
    font-size: 13px;
  }

  .workspace-fullscreen-page .mobile-tool-overlay {
    position: fixed;
    inset: 0;
    z-index: 5000;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background: rgba(17, 24, 39, 0.48);
  }

  .workspace-fullscreen-page .mobile-tool-sheet {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 560px;
    max-height: 82vh;
    max-height: 82dvh;
    overflow: hidden;
    border-radius: 18px 18px 0 0;
    background: #ffffff;
    box-shadow: 0 -12px 38px rgba(15, 23, 42, 0.18);
  }

  .workspace-fullscreen-page .mobile-tool-sheet-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 0 0 68px;
    padding: 0 18px;
    border-bottom: 1px solid #edf0f4;
  }

  .workspace-fullscreen-page .mobile-tool-sheet-header > div {
    display: flex;
    flex-direction: column;
  }

  .workspace-fullscreen-page .mobile-tool-sheet-header strong {
    color: #18212f;
    font-size: 18px;
    line-height: 26px;
  }

  .workspace-fullscreen-page .mobile-tool-sheet-header > div > span {
    color: #8a94a3;
    font-size: 12px;
    line-height: 18px;
  }

  .workspace-fullscreen-page .mobile-tool-sheet-header > button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: 0;
    border-radius: 50%;
    background: #f3f5f8;
    color: #5f6b7a;
    font-size: 18px;
    cursor: pointer;
  }

  .workspace-fullscreen-page .mobile-tool-sheet-body {
    flex: 1 1 auto;
    padding: 4px 16px 26px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .workspace-fullscreen-page .mobile-tool-group {
    margin-top: 18px;
  }

  .workspace-fullscreen-page .mobile-tool-group h3 {
    margin: 0 0 10px;
    color: #667085;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
  }

  .workspace-fullscreen-page .mobile-tool-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
  }

  .workspace-fullscreen-page .mobile-tool-item {
    display: flex;
    align-items: center;
    min-width: 0;
    min-height: 50px;
    padding: 9px 10px;
    border: 1px solid #e6eaf0;
    border-radius: 10px;
    background: #ffffff;
    color: #344054;
    font-family: "Microsoft YaHei", sans-serif;
    font-size: 13px;
    text-align: left;
    cursor: pointer;
  }

  .workspace-fullscreen-page .mobile-tool-item.active {
    border-color: var(--primary);
    background: var(--primary-alpha-08);
    color: var(--primary);
    font-weight: 600;
  }

  .workspace-fullscreen-page .mobile-tool-item-icon {
    flex: 0 0 18px;
    width: 18px;
    height: 18px;
    margin-right: 7px;
    color: #667085;
    font-size: 17px;
  }

  .workspace-fullscreen-page .mobile-tool-item.active .mobile-tool-item-icon {
    color: var(--primary);
  }

  .workspace-fullscreen-page .mobile-tool-item > span:last-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .workspace-fullscreen-page .menu-type {
    display: contents;
  }

  .workspace-fullscreen-page .menu-type .title {
    display: none;
  }

  .workspace-fullscreen-page .menu-type .menu-item {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    width: auto !important;
    min-height: 36px;
    margin: 0 4px 0 0;
    padding: 0 12px;
    white-space: nowrap;
    border-radius: 6px;
  }

  .workspace-fullscreen-page .menu-type .menu-item .menu-icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }

  .workspace-fullscreen-page .menu-type .menu-item .menu-name {
    font-size: 14px;
    line-height: 36px;
  }

  .workspace-fullscreen-page .box_5 > span,
  .workspace-fullscreen-page .box_5 > span > div,
  .workspace-fullscreen-page .box_5 > span > .section_2,
  .workspace-fullscreen-page .box_5 > span > .section_3,
  .workspace-fullscreen-page .box_5 > span > .section_4,
  .workspace-fullscreen-page .box_5 > span > .section_5,
  .workspace-fullscreen-page .box_5 > span > .section_6 {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    margin-right: 0 !important;
    margin-left: 0 !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page .box_5 > span {
    order: 3;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) {
    display: flex;
    flex-direction: column;
    padding: 16px 12px;
    overflow-x: hidden;
  }

  /* AI 翻译没有独立顶部工具栏，小屏直接把空间交给聊天工作台。 */
  .workspace-fullscreen-page.workspace-mode-AITranslate .box_4 {
    display: none !important;
  }

  .workspace-fullscreen-page.workspace-mode-AITranslate .box_5 > span:not(.text-workbench-content) {
    flex: 0 0 auto;
    height: clamp(560px, calc(100dvh - 220px), 680px);
    min-height: 560px;
    padding: 0;
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-AITranslate .box_5 > span > .section_2 {
    display: flex;
    flex: 1 1 auto;
    width: 100% !important;
    height: 100% !important;
    min-width: 0 !important;
    min-height: 0;
    margin: 0 !important;
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-AITranslate /deep/ .ai-chat {
    width: 100%;
    height: 100% !important;
    min-width: 0;
    margin: 0 !important;
  }

  /* 润色页小屏使用组件内语言栏和上下分区，移除空白桌面工具栏。 */
  .workspace-fullscreen-page.workspace-mode-polish .box_4 {
    display: none !important;
  }

  .workspace-fullscreen-page.workspace-mode-polish .box_5 > span:not(.text-workbench-content) {
    flex: 0 0 auto;
    height: clamp(640px, calc(100dvh - 180px), 820px);
    min-height: 640px;
    padding: 0;
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-polish .box_5 > span > .section_2 {
    display: flex;
    flex: 1 1 auto;
    width: 100% !important;
    height: 100% !important;
    min-width: 0 !important;
    min-height: 0;
    margin: 0 !important;
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-polish /deep/ .polish {
    width: 100%;
    height: 100% !important;
    min-width: 0;
    margin: 0 !important;
  }

  /* AI PPT 小屏使用组件内流程栏，移除空白桌面工具栏与固定画布。 */
  .workspace-fullscreen-page.workspace-mode-aiPPT .box_4 {
    display: none !important;
  }

  .workspace-fullscreen-page.workspace-mode-aiPPT .box_5 > span:not(.text-workbench-content) {
    flex: 0 0 auto;
    height: clamp(640px, calc(100dvh - 180px), 780px);
    min-height: 640px;
    padding: 0;
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-aiPPT .box_5 > span > .flex-row {
    display: flex;
    flex: 1 1 auto;
    width: 100% !important;
    height: 100% !important;
    min-width: 0 !important;
    min-height: 0;
    margin: 0 !important;
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-aiPPT /deep/ .ai-ppt {
    width: 100%;
    height: 100% !important;
    min-width: 0;
    margin: 0 !important;
  }

  /* 文档转换小屏清除上传区残留的桌面固定尺寸。 */
  .workspace-fullscreen-page.workspace-mode-convert .box_5 > span.convert-workspace-panel {
    display: flex !important;
    flex: 0 0 auto;
    align-items: stretch;
    width: 100% !important;
    height: auto !important;
    min-height: 0 !important;
    padding: 12px 12px calc(82px + env(safe-area-inset-bottom));
    overflow: visible !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-title,
  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card,
  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-help {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-title {
    height: auto !important;
    font-size: 20px !important;
    line-height: 28px !important;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card {
    height: auto !important;
    min-height: 0 !important;
    margin: 12px 0 0 !important;
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-links {
    display: flex !important;
    flex-wrap: wrap;
    gap: 8px 12px;
    width: 100% !important;
    min-width: 0;
    margin: 0 !important;
    padding: 12px;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-links .convert-workspace-link {
    margin-left: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .demo-form-inline,
  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .demo-form-inline > div,
  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card /deep/ .new-upload-demo,
  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card /deep/ .new-upload-demo .el-upload,
  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card /deep/ .new-upload-demo .el-upload-dragger,
  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .block_3 {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .block_3 {
    margin-top: 0 !important;
    padding: 16px 12px;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card /deep/ .new-upload-demo .el-upload-dragger {
    height: 140px !important;
    min-height: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-dropzone {
    width: 100% !important;
    height: 140px !important;
    min-width: 0;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-primary {
    margin-top: 16px !important;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .box_11,
  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .box_7,
  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-card .group_11 {
    width: 100% !important;
    height: auto !important;
    min-width: 0;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list-shell {
    display: flex !important;
    align-items: stretch !important;
    min-height: 260px;
    margin: 0 !important;
    padding: 12px;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list-card,
  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list,
  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list /deep/ .el-checkbox-group {
    width: 100% !important;
    height: auto !important;
    min-width: 0;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list /deep/ .el-checkbox-group {
    display: flex;
    flex-direction: column;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list .convert-upload-list-item {
    display: grid !important;
    grid-template-columns: 28px minmax(0, 1fr) 88px 24px;
    align-items: center;
    gap: 6px;
    width: 100% !important;
    min-height: 64px;
    margin: 0 0 10px !important;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list .convert-upload-list-item > label,
  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list .convert-upload-list-item > div {
    width: auto !important;
    min-width: 0;
    margin: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list-file {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list .convert-workspace-file-type,
  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list-delete {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-upload-list-submit {
    width: 160px !important;
    height: 41px !important;
    margin: 16px auto 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-convert .convert-workspace-help {
    height: auto !important;
    margin: 16px 0 0 !important;
    padding: 14px;
    overflow-wrap: anywhere;
  }

  /* 网页翻译插件页没有独立工具栏，小屏使用自然文档流展示安装指引。 */
  .workspace-fullscreen-page.workspace-mode-plugin .box_4 {
    display: none !important;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .box_5 > span.plugin-translation-panel {
    display: flex !important;
    flex: 0 0 auto;
    align-items: stretch;
    width: 100% !important;
    height: auto !important;
    min-height: 0 !important;
    padding: 16px 12px calc(82px + env(safe-area-inset-bottom));
    overflow: visible !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-page-title {
    height: auto !important;
    padding: 0 4px;
    font-size: 20px !important;
    line-height: 28px !important;
    color: var(--foreground);
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-page-description {
    height: auto !important;
    padding: 8px 4px 16px !important;
    font-size: 14px !important;
    line-height: 24px !important;
    text-align: left !important;
    overflow-wrap: anywhere;
    color: var(--muted-foreground);
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-browser-heading {
    display: flex !important;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    width: 100% !important;
    height: auto !important;
    min-width: 0;
    font-size: 18px !important;
    line-height: 26px !important;
    color: var(--foreground);
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-version-badge {
    width: max-content;
    max-width: 100%;
    height: auto !important;
    margin: 0 !important;
    padding: 0 10px;
    line-height: 20px !important;
    white-space: normal;
    border-radius: var(--radius-2xl);
    color: #6b7280;
    background: #f3f4f6;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-install-entry {
    width: 100% !important;
    max-width: 300px !important;
    min-width: 0;
    margin: 0 auto !important;
    padding-top: 16px !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-guide-section {
    width: 100% !important;
    height: auto !important;
    min-width: 0 !important;
    min-height: 0 !important;
    margin: 16px 0 0 !important;
    overflow: visible;
    box-sizing: border-box;
    cursor: default;
  }

  .text-fullscreen-page .text-workbench-content {
    order: 3;
    display: flex !important;
    flex-direction: column;
    width: 100% !important;
    min-width: 0 !important;
    flex: 0 0 auto;
    padding-top: 12px;
    box-sizing: border-box;
    background: #ffffff;
  }

  .text-fullscreen-page .section_2 {
    display: grid;
    grid-template-rows: 34px minmax(230px, 1fr) 34px minmax(230px, 1fr);
    width: 100% !important;
    flex: none;
    height: clamp(538px, calc(100dvh - 255px), 740px) !important;
    min-width: 0 !important;
    min-height: 538px;
    max-height: 740px;
    margin: 0 !important;
    background: #ffffff;
  }

  .text-fullscreen-page /deep/ .text_12 {
    flex: none !important;
    width: 100% !important;
    height: 100% !important;
    min-width: 0 !important;
    min-height: 0;
    margin: 0 !important;
    position: relative;
  }

  .text-fullscreen-page /deep/ .text_12 .el-textarea__inner {
    width: 100%;
    height: 100% !important;
    margin: 0 !important;
    padding: 14px 16px 16px !important;
    border: 0 !important;
    border-radius: 0;
  }

  .text-fullscreen-page /deep/ .text_12 .el-input__count {
    position: absolute;
    right: 12px;
    bottom: 8px;
    margin: 0;
  }

  .text-fullscreen-page .section_2 > .group_4 {
    display: none;
  }

  .text-fullscreen-page .section_2 > .group_5 {
    flex: none !important;
    width: 100% !important;
    height: 100% !important;
    min-width: 0 !important;
    min-height: 0;
    margin: 0 !important;
    padding: 14px 16px 16px !important;
    overflow: auto;
    box-sizing: border-box;
    border-top: 1px solid #e7eaed;
    background: #f8fafc;
  }

  .text-fullscreen-page /deep/ .file-translate-entry {
    display: none !important;
  }

  .text-fullscreen-page .mobile-text-panel-label {
    display: flex;
    align-items: center;
    flex: 0 0 34px;
    height: 34px;
    padding: 0 16px;
    border-bottom: 1px solid #edf0f4;
    background: #ffffff;
    color: #5f6b7a;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
  }

  .text-fullscreen-page .mobile-text-panel-label-result {
    border-top: 8px solid #f5f7fa;
    background: #f8fafc;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) .demo-form-inline,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) .demo-form-inline > div,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) /deep/ .el-upload,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) /deep/ .el-upload-dragger,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) .box_11,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) .block_3 {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) .section_3,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) .section_4,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) .section_5,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) .section_6,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) .demo-form-inline,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) .demo-form-inline > div,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) /deep/ .el-upload,
  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) /deep/ .el-upload-dragger {
    height: auto !important;
    min-height: 360px;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-progress {
    height: auto !important;
    min-height: 360px;
    padding: 24px 12px;
    justify-content: center;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-progress > .group_4 {
    width: 100% !important;
    max-width: 460px;
    min-width: 0;
    margin: 24px 0 22px !important;
    overflow: hidden;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-progress > .group_4 > .block_6 {
    max-width: 100%;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-shell {
    align-items: stretch !important;
    width: 100% !important;
    height: auto !important;
    min-height: 360px;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-card {
    align-items: stretch !important;
    width: 100% !important;
    height: auto !important;
    min-width: 0;
    min-height: 0;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-header {
    display: none;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list {
    width: 100% !important;
    min-width: 0;
    max-width: 100%;
    padding: 2px;
    overflow-x: hidden !important;
    overflow-y: auto;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list /deep/ .el-checkbox-group {
    display: grid;
    width: 100%;
    min-width: 0;
    gap: 10px;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-list-item {
    position: relative;
    display: grid !important;
    grid-template-columns: 28px minmax(0, 1fr) 32px minmax(0, 1fr) 28px;
    grid-template-areas:
      "check file file file delete"
      ". character character page page"
      ". model model model ."
      ". terminology terminology terminology ."
      ". from swap to .";
    width: 100% !important;
    min-width: 0;
    min-height: 0 !important;
    padding: 12px !important;
    gap: 10px 8px;
    overflow: hidden;
    box-sizing: border-box;
    border: 1px solid #e5eaf0;
    border-radius: 10px;
    background: #ffffff;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-select {
    grid-area: check;
    align-self: center;
    width: auto !important;
    margin: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-file,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-character,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-page,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-model,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-terminology,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-language,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-swap,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-delete {
    width: auto !important;
    min-width: 0;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-file {
    grid-area: file;
    display: flex !important;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #344054;
    font-size: 13px;
    font-weight: 600;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-file > img {
    flex: 0 0 22px;
    width: 22px !important;
    height: 22px !important;
    margin: 0 8px 0 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-character {
    grid-area: character;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-page {
    grid-area: page;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-model {
    grid-area: model;
    cursor: pointer;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-terminology {
    grid-area: terminology;
    text-align: left !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-character,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-page,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-model,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-terminology {
    display: flex !important;
    align-items: center;
    justify-content: flex-start !important;
    color: #667085;
    font-size: 12px;
    line-height: 20px;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-character::before,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-page::before,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-model::before,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-terminology::before {
    flex: 0 0 auto;
    margin-right: 4px;
    color: #98a2b3;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-character::before {
    content: "字数：";
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-page::before {
    content: "页数：";
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-model::before {
    content: "翻译模型：";
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-terminology::before {
    content: "术语：";
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-language-from {
    grid-area: from;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-language-to {
    grid-area: to;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-language /deep/ .el-select,
  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-language /deep/ .el-input {
    width: 100%;
    min-width: 0;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-swap {
    grid-area: swap;
    display: flex !important;
    align-items: center;
    justify-content: center;
    width: 32px !important;
    height: 40px;
    background: #ebebeb;
    z-index: 1 !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-swap .thumbnail_26 {
    width: 17px;
    height: 13px;
    margin: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-delete {
    grid-area: delete;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-delete > img {
    width: 16px;
    height: 16px;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-submit {
    flex: 0 0 auto;
    margin: 16px auto 0 !important;
  }

  .workspace-fullscreen-page .box_5 > span:not(.text-workbench-content) .block_3 {
    min-height: 360px;
    padding: 28px 12px;
    align-items: center;
    gap: 0;
    justify-content: center;
  }

  .workspace-fullscreen-page .block_3 .image-wrapper_11,
  .workspace-fullscreen-page .block_3 .text-wrapper_4 {
    display: grid !important;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    width: 100% !important;
    height: auto !important;
    max-width: 100% !important;
    margin: 0 !important;
    column-gap: 6px;
  }

  .workspace-fullscreen-page .block_3 .image-wrapper_11 {
    min-height: 30px;
    align-items: center;
  }

  .workspace-fullscreen-page .block_3 .text-wrapper_4 {
    min-height: 16px;
    margin-top: 6px !important;
    align-items: flex-start;
  }

  .workspace-fullscreen-page .block_3 .image-wrapper_11 img {
    justify-self: center;
    width: 30px !important;
    height: auto !important;
    margin-right: 0 !important;
    margin-left: 0 !important;
    object-fit: contain;
  }

  .workspace-fullscreen-page .block_3 .text-wrapper_4 > span {
    justify-self: stretch;
    width: 100% !important;
    height: auto !important;
    min-height: 14px;
    min-width: 0;
    margin: 0 !important;
    overflow: visible;
    font-size: 10px !important;
    line-height: 14px !important;
    text-align: center;
    text-overflow: clip;
    overflow-wrap: anywhere;
    white-space: normal !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-icon {
    width: 20px !important;
    height: 20px !important;
    margin: 0 !important;
    color: var(--primary);
    flex-shrink: 0;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-prompt {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 8px !important;
    margin: 0 0 8px 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-upload-prompt .text_21 {
    width: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    line-height: 20px !important;
    text-align: left !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .block_3 .image-wrapper_11,
  .workspace-fullscreen-page.workspace-mode-doc .block_3 .text-wrapper_4 {
    display: none !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-file-type-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    align-items: start;
    width: 100%;
    min-width: 0;
    column-gap: 6px;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-file-type-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 0;
    gap: 6px;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-file-type-item > img {
    flex: 0 0 auto;
    width: 30px;
    height: auto;
    margin: 0;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-file-type-item > span {
    width: 100%;
    min-height: 14px;
    margin: 0;
    color: #999999;
    font-family: ArialMT, Arial, sans-serif;
    font-size: 10px;
    line-height: 14px;
    text-align: center;
    overflow-wrap: anywhere;
  }

  .workspace-fullscreen-page .block_3 .text_21,
  .workspace-fullscreen-page .block_3 .text_22 {
    width: 100% !important;
    height: auto !important;
    max-width: 100%;
    margin: 0 !important;
    padding-right: 8px;
    padding-left: 8px;
    box-sizing: border-box;
    white-space: normal !important;
    text-align: center !important;
  }

  .workspace-fullscreen-page .block_3 .text_21 {
    margin-top: 18px !important;
    line-height: 22px !important;
  }

  .workspace-fullscreen-page .block_3 .text_22 {
    margin-top: 6px !important;
    line-height: 20px !important;
  }

  /* 图片翻译小屏：语言、输出格式和操作区分行，上传三态使用自适应卡片。 */
  .workspace-fullscreen-page.workspace-mode-img .box_4 {
    align-items: stretch;
    min-height: 0;
    padding: 10px !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-toolbar {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr);
    align-items: stretch !important;
    gap: 8px;
    width: 100% !important;
    min-width: 0;
    margin: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-language {
    display: flex;
    align-items: center;
    width: 100% !important;
    min-width: 0;
    height: 42px !important;
    margin: 0 !important;
    overflow: visible;
    box-sizing: border-box;
    border: 1px solid #e6eaf0;
    border-radius: 8px !important;
    background: #f7f9fc !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-language .image-wrapper_1,
  .workspace-fullscreen-page.workspace-mode-img .image-workbench-language .image-wrapper_2 {
    position: relative;
    flex: 1 1 0;
    min-width: 0;
    overflow: visible;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-language .text-wrapper_1 {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-width: 0;
    height: 42px;
    padding: 0 24px 0 10px;
    overflow: hidden;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-language .text_6,
  .workspace-fullscreen-page.workspace-mode-img .image-workbench-language .text_8 {
    width: auto !important;
    height: auto !important;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    line-height: 20px !important;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-language .thumbnail_5,
  .workspace-fullscreen-page.workspace-mode-img .image-workbench-language .thumbnail_14 {
    position: absolute;
    top: 50%;
    right: 10px;
    width: 10px;
    height: 6px;
    margin: 0 !important;
    transform: translateY(-50%);
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-language .thumbnail_26 {
    flex: 0 0 18px;
    width: 18px;
    height: 18px;
    margin: 0 8px;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-language .image-language-menu {
    top: 100%;
    left: 0;
    width: 100% !important;
    min-width: 120px;
    max-width: 100%;
    overflow: hidden !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-language .image-wrapper_2 .image-language-menu {
    right: 0;
    left: auto;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-language .image-language-menu-scroll {
    width: 100% !important;
    height: auto !important;
    max-height: calc(100vh - 230px);
    max-height: calc(100dvh - 230px);
    overscroll-behavior: contain;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-language .image-language-menu-scroll .domains {
    width: 100%;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-output {
    display: flex !important;
    align-items: center;
    width: 100% !important;
    min-width: 0;
    min-height: 40px;
    margin: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-output-label {
    flex: 0 0 64px;
    margin-right: 8px !important;
    font-size: 13px !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-output-switch {
    display: inline-flex;
    flex: 1 1 auto;
    min-width: 0;

    .switch-item {
      flex: 1 1 0;
      min-width: 0;
      padding: 9px 12px;
      font-size: 13px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-actions {
    display: flex !important;
    justify-self: start;
    gap: 8px;
    width: 100% !important;
    max-width: 300px;
    min-width: 0;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-workbench-actions .btn-toolbar .text_5 {
    width: auto;
    height: auto !important;
    margin: 0 0 0 5px;
    line-height: 20px !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .box_5 > span.image-translation-panel {
    flex: 0 0 auto;
    align-items: stretch;
    height: auto !important;
    min-height: 0;
    padding: 12px 12px calc(70px + env(safe-area-inset-bottom));
    overflow: visible !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section {
    height: auto !important;
    min-height: 0 !important;
    margin-top: 0 !important;
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .demo-form-inline,
  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .demo-form-inline > div,
  .workspace-fullscreen-page.workspace-mode-img .image-upload-section /deep/ .new-upload-demo,
  .workspace-fullscreen-page.workspace-mode-img .image-upload-section /deep/ .new-upload-demo .el-upload,
  .workspace-fullscreen-page.workspace-mode-img .image-upload-section /deep/ .new-upload-demo .el-upload-dragger,
  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .block_3 {
    width: 100% !important;
    height: auto !important;
    min-width: 0 !important;
    min-height: 0 !important;
    max-width: 100% !important;
    box-sizing: border-box;
    padding: 16px 12px;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-dropzone {
    flex: 0 0 210px;
    width: 100% !important;
    height: 210px !important;
    max-width: 100% !important;
    padding: 16px;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-button {
    flex: 0 0 41px;
    margin-top: 16px !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .box_11 {
    width: 100% !important;
    height: auto !important;
    min-width: 0;
    min-height: 260px;
    padding: 18px 12px;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .box_11 > .group_4 {
    width: 100% !important;
    max-width: 460px;
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .box_11 > .group_4 > .block_6 {
    max-width: 100%;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .box_7,
  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11,
  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 /deep/ .el-checkbox-group {
    width: 100% !important;
    height: auto !important;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .box_7 {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .box_7 > .text-wrapper_4 {
    display: none;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 {
    max-height: none;
    overflow: visible;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 /deep/ .el-checkbox-group {
    display: grid;
    gap: 10px;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item {
    display: grid !important;
    grid-template-columns: 24px minmax(0, 1fr) 32px minmax(0, 1fr) 28px;
    grid-template-areas:
      "check file file file delete"
      ". page page page ."
      ". from swap to .";
    align-items: center;
    gap: 9px 8px;
    width: 100% !important;
    min-width: 0;
    min-height: 0;
    padding: 12px 8px !important;
    overflow: hidden;
    box-sizing: border-box;
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    background: var(--bg-card);
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > label,
  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > div {
    width: auto !important;
    min-width: 0;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > label:nth-child(1) {
    grid-area: check;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > div:nth-child(2) {
    grid-area: file;
    display: flex;
    align-items: center;
    overflow: hidden;
    color: var(--foreground);
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > div:nth-child(2) img {
    flex: 0 0 22px;
    width: 22px;
    height: 22px;
    margin-right: 8px;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > div:nth-child(3) {
    grid-area: page;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--muted-foreground);
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > div:nth-child(3)::before {
    content: "页数：";
    color: var(--muted-foreground);
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > div:nth-child(4) {
    grid-area: from;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > div:nth-child(5) {
    grid-area: swap;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px !important;
    height: 40px;
    border-radius: 4px;
    background: var(--border-light);
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > div:nth-child(5) .thumbnail_26 {
    width: 17px;
    height: 13px;
    margin: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > div:nth-child(6) {
    grid-area: to;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > div:nth-child(7) {
    grid-area: delete;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > div:nth-child(7) img {
    width: 16px;
    height: 16px;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > .borderNewSelect /deep/ .el-select,
  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .group_11 .item > .borderNewSelect /deep/ .el-input {
    width: 100% !important;
    min-width: 0;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .text-wrapper_8 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-section .text-wrapper_8 .text_32 {
    width: auto;
    height: auto;
    margin: 0;
    line-height: 41px;
  }

  .workspace-fullscreen-page.workspace-mode-img .image-upload-help {
    width: 100% !important;
    height: auto !important;
    min-height: 0;
    margin: 16px 0 0 !important;
    padding: 14px;
    overflow: visible;
    box-sizing: border-box;
    border-radius: var(--radius-md);
    background: var(--bg-subtle);
    font-size: 12px !important;
    line-height: 20px !important;
    overflow-wrap: anywhere;
  }

  /* 多语种翻译小屏：清除上传、进度和列表状态残留的桌面固定尺寸。 */
  .workspace-fullscreen-page.workspace-mode-more .box_4 {
    min-height: 56px;
    overflow: hidden !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-workbench-toolbar {
    display: flex !important;
    align-items: center;
    width: 100% !important;
    min-width: 0;
    margin: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-workbench-main {
    display: flex !important;
    width: 100% !important;
    min-width: 0;
    margin: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-workbench-actions {
    display: flex !important;
    gap: 8px;
    width: 100% !important;
    max-width: 300px;
    min-width: 0;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-workbench-actions .btn-toolbar .text_5 {
    width: auto;
    height: auto !important;
    margin: 0 0 0 5px;
    line-height: 20px !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .box_5 > span.more-translation-panel {
    flex: 0 0 auto;
    align-items: stretch;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    overflow: visible !important;
    background: transparent !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section {
    height: auto !important;
    min-height: 0 !important;
    margin-top: 0 !important;
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .demo-form-inline,
  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .demo-form-inline > div,
  .workspace-fullscreen-page.workspace-mode-more .more-upload-section /deep/ .new-upload-demo,
  .workspace-fullscreen-page.workspace-mode-more .more-upload-section /deep/ .new-upload-demo .el-upload,
  .workspace-fullscreen-page.workspace-mode-more .more-upload-section /deep/ .new-upload-demo .el-upload-dragger,
  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .block_3 {
    width: 100% !important;
    height: auto !important;
    min-width: 0 !important;
    min-height: 0 !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .block_3 {
    padding: 16px 12px;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-dropzone {
    flex: 0 0 210px;
    width: 100% !important;
    height: 210px !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-button {
    flex: 0 0 41px;
    margin-top: 16px !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .box_11 {
    width: 100% !important;
    height: auto !important;
    min-width: 0;
    min-height: 260px;
    padding: 18px 12px;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .box_11 > .group_4 {
    width: 100% !important;
    max-width: 460px;
    overflow: hidden;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .box_11 > .group_4 > .block_6 {
    max-width: 100%;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .box_7,
  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .group_11,
  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .group_11 /deep/ .el-checkbox-group {
    width: 100% !important;
    height: auto !important;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .box_7 {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .box_7 > .text-wrapper_4 {
    display: none;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .group_11 {
    max-height: none;
    overflow: visible;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .group_11 /deep/ .el-checkbox-group {
    display: grid;
    gap: 8px;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .group_11 .item {
    display: grid !important;
    grid-template-columns: 24px minmax(0, 1fr) auto 28px;
    align-items: center;
    gap: 8px;
    width: 100% !important;
    min-width: 0;
    min-height: 56px;
    padding: 10px 8px !important;
    overflow: hidden;
    box-sizing: border-box;
    border: 1px solid #e5eaf0;
    border-radius: 8px;
    background: #ffffff;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .group_11 .item > label,
  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .group_11 .item > div {
    width: auto !important;
    min-width: 0;
    margin: 0 !important;
    padding: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .group_11 .item > div:nth-child(2) {
    overflow: hidden;
    color: #344054;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .group_11 .item > div:nth-child(2) img {
    flex: 0 0 22px;
    width: 22px;
    height: 22px;
    margin-right: 8px;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .group_11 .item > div:nth-child(3),
  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .group_11 .item > div:nth-child(4) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .group_11 .item > div:nth-child(3)::before {
    content: "字数：";
    color: #98a2b3;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .group_11 .item > div:nth-child(4) img {
    width: 16px;
    height: 16px;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .text-wrapper_8 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-section .text-wrapper_8 .text_32 {
    width: auto;
    height: auto;
    margin: 0;
    line-height: 41px;
  }

  .workspace-fullscreen-page.workspace-mode-more .more-upload-help {
    width: 100% !important;
    height: auto !important;
    min-height: 0;
    margin: 16px 0 0 !important;
    padding: 14px;
    overflow: visible;
    box-sizing: border-box;
    border-radius: 8px;
    background: #f8fafc;
    font-size: 12px !important;
    line-height: 20px !important;
    overflow-wrap: anywhere;
  }

  /* 术语词库小屏：筛选控件单列展示，表格清除桌面固定画布。 */
  .workspace-fullscreen-page.workspace-mode-setting .box_4 {
    min-height: 0;
    padding: 10px 12px 12px !important;
    overflow: visible !important;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-toolbar {
    display: flex !important;
    flex-direction: column;
    align-items: stretch !important;
    justify-content: flex-start !important;
    gap: 10px;
    width: 100% !important;
    height: auto !important;
    min-width: 0 !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-filter-row,
  .workspace-fullscreen-page.workspace-mode-setting .terminology-filter-controls {
    width: 100% !important;
    min-width: 0 !important;
    margin: 0 !important;
    flex-shrink: 1 !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-filter-controls {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-specialty-filter {
    display: grid !important;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center !important;
    gap: 8px;
    width: 100%;
    min-width: 0;
    font-size: 13px !important;
    white-space: nowrap;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-specialty-filter .borderNewSelect {
    width: 100%;
    min-width: 0;
    margin-left: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-specialty-filter .borderNewSelect /deep/ .el-select,
  .workspace-fullscreen-page.workspace-mode-setting .terminology-specialty-filter .borderNewSelect /deep/ .el-input,
  .workspace-fullscreen-page.workspace-mode-setting .terminology-search /deep/ .el-input {
    width: 100% !important;
    min-width: 0;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-search {
    width: 100% !important;
    min-width: 0;
    margin-left: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-result-count {
    flex: none !important;
    justify-content: flex-start !important;
    min-height: 20px;
    color: #667085 !important;
    font-size: 12px !important;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-ai-launcher {
    top: auto;
    right: 8px;
    bottom: calc(70px + env(safe-area-inset-bottom));
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-ai-launcher img {
    width: 112px;
    height: auto;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-ai-panel {
    top: 64px !important;
    right: 8px !important;
    bottom: calc(66px + env(safe-area-inset-bottom));
    left: auto !important;
    width: calc(100vw - 16px);
    max-width: 360px;
    max-height: none;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-ai-shell {
    position: relative;
    width: 100% !important;
    height: 100% !important;
    overflow: hidden;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-ai-header {
    width: 100% !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-ai-chat-view,
  .workspace-fullscreen-page.workspace-mode-setting .terminology-ai-history-view {
    height: calc(100% - 40px);
    min-height: 0;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-ai-messages {
    height: calc(100% - 118px) !important;
    min-height: 0;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-ai-history-list {
    height: calc(100% - 14px) !important;
    min-height: 0;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-ai-panel /deep/ .shuru {
    width: 100% !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-ai-answer,
  .workspace-fullscreen-page.workspace-mode-setting .terminology-ai-question {
    min-width: 0 !important;
    max-width: calc(100% - 42px) !important;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-ai-new-chat {
    width: calc(100% - 32px) !important;
    max-width: 255px;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-ai-divider {
    width: calc(100% - 30px) !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-setting .box_5 > span.terminology-table-panel {
    display: flex !important;
    flex: 0 0 auto;
    align-items: stretch;
    width: 100% !important;
    height: auto !important;
    min-height: 0 !important;
    padding: 12px 12px calc(82px + env(safe-area-inset-bottom));
    overflow: visible !important;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-table-section {
    width: 100% !important;
    height: auto !important;
    min-height: 0 !important;
    margin: 0 !important;
    overflow: hidden;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-table-section .box_11,
  .workspace-fullscreen-page.workspace-mode-setting .terminology-table-section .box_7 {
    align-items: stretch;
    justify-content: flex-start;
    width: 100% !important;
    height: auto !important;
    min-width: 0 !important;
    min-height: 0 !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  /* 平板/移动端：术语列表沿用桌面 doc 风格，仅收紧行高与内边距 */
  .workspace-fullscreen-page.workspace-mode-setting .terminology-list-card {
    border-radius: var(--radius-md);
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-list-header,
  .workspace-fullscreen-page.workspace-mode-setting .terminology-list-header .text_16 {
    height: 42px !important;
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-list-row {
    min-height: 48px;
    padding: 0 16px !important;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-cell-value {
    display: block;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .workspace-fullscreen-page.workspace-mode-setting /deep/ .terminology-table-section .el-empty {
    width: 100%;
    min-height: 280px;
    padding: 28px 0;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-pagination {
    width: 100%;
    height: auto !important;
    margin-top: 16px !important;
    overflow: hidden;
    line-height: normal !important;
  }

  .workspace-fullscreen-page.workspace-mode-setting /deep/ .terminology-pagination-control {
    max-width: 100%;
    white-space: nowrap;
  }

  .workspace-fullscreen-page.workspace-mode-setting /deep/ .terminology-pagination-control.is-background .btn-next,
  .workspace-fullscreen-page.workspace-mode-setting /deep/ .terminology-pagination-control.is-background .btn-prev,
  .workspace-fullscreen-page.workspace-mode-setting /deep/ .terminology-pagination-control.is-background .el-pager li {
    min-width: 28px;
    margin: 0 2px;
  }

  .workspace-fullscreen-page /deep/ .lang-panel {
    position: fixed !important;
    right: 8px !important;
    left: 8px !important;
    width: calc(100vw - 16px) !important;
    min-width: 0 !important;
    max-width: calc(100vw - 16px) !important;
    max-height: calc(100vh - 188px);
    max-height: calc(100dvh - 188px);
    overflow: hidden;
    box-sizing: border-box;
  }

  .workspace-fullscreen-page /deep/ .lang-panel .lang-table {
    flex: 0 1 auto;
    height: clamp(240px, calc(100vh - 260px), 420px) !important;
    height: clamp(240px, calc(100dvh - 260px), 420px) !important;
    min-height: 0;
  }

  .workspace-fullscreen-page /deep/ .lang-panel .letter-block > div {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .workspace-fullscreen-page /deep/ .lang-panel .lang-item {
    width: auto !important;
    min-width: 0;
    padding-right: 8px;
    overflow: hidden;
    box-sizing: border-box;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .workspace-fullscreen-page /deep/ .lang-panel .letter-index-ol {
    display: none;
  }

  .workspace-fullscreen-page .translate-site-footer {
    display: block !important;
  }
}

@media (max-width: 480px) {
  .workspace-fullscreen-page .group_3 {
    padding-right: 0;
    padding-left: 0;
  }

  .workspace-fullscreen-page .new-container {
    border-radius: 0;
  }

  .workspace-fullscreen-page .mobile-tool-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .workspace-fullscreen-page .box_4 {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }

  .workspace-fullscreen-page.workspace-mode-doc .doc-workbench-language,
  .workspace-fullscreen-page.workspace-mode-doc .doc-model-entry {
    flex-basis: 100% !important;
    width: 100% !important;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-table-section {
    padding: 10px;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-list-card {
    border: none !important;
    border-radius: 0;
    background: transparent;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-list-header {
    display: none !important;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-list {
    max-height: none;
    overflow: visible;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-list-row {
    display: block !important;
    height: auto !important;
    min-height: 0;
    margin-bottom: 10px !important;
    padding: 12px;
    border: 1px solid #ebeef5 !important;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-list-row:last-of-type {
    margin-bottom: 0 !important;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-list-row .terminology-cell {
    display: grid;
    grid-template-columns: 72px minmax(0, 1fr);
    align-items: start;
    gap: 8px;
    margin-bottom: 8px;
    overflow: visible !important;
    text-overflow: clip;
    white-space: normal !important;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-list-row .terminology-cell:last-of-type {
    margin-bottom: 0;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-list-row .terminology-cell::before {
    content: attr(data-label);
    color: #909399;
    font-size: 12px;
    font-weight: 600;
  }

  .workspace-fullscreen-page.workspace-mode-setting .terminology-list-row .terminology-cell-value {
    overflow: visible;
    color: #303133;
    text-overflow: clip;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-page-title {
    font-size: 18px !important;
    line-height: 26px !important;
  }

  .workspace-fullscreen-page.workspace-mode-plugin .plugin-page-description {
    padding-right: 2px !important;
    padding-left: 2px !important;
    font-size: 13px !important;
    line-height: 22px !important;
  }

}
</style>
